import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule, Inject, inject, ViewContainerRef, ViewChildren, HostListener, APP_INITIALIZER } from '@angular/core';
import * as i1 from '@angular/forms';
import { UntypedFormControl, Validators, UntypedFormGroup, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import * as i2$2 from '@engineering11/ui-lib/e11-input-errors';
import { E11FormValidator, Validation, E11InputErrorsModule, E11InputErrorMappingService } from '@engineering11/ui-lib/e11-input-errors';
import * as i2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { isNotNil, URL_REGEX, pick, omit, isEmptyObject, DOMAIN_REGEX, filterByKeys, stripUndefined, getEnumValues, sleep } from '@engineering11/utility';
import { RestApiClient, VersionType } from '@engineering11/web-api-rest';
import { filter as filter$1, map as map$1, switchMap, of, take, combineLatest, lastValueFrom, mergeMap, from, Subject, tap, distinctUntilChanged, finalize as finalize$1, withLatestFrom, takeUntil, firstValueFrom, catchError, EMPTY } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { filter, map, finalize } from 'rxjs/operators';
import { CollectionRepository } from '@engineering11/web-api-firebase';
import * as i1$1 from '@engineering11/web-utilities';
import { WebUtilityModule, formSelectOptionsBusinessSizeRange, formSelectOptionsGICSIndustryGroup, formSelectOptionsBusinessType } from '@engineering11/web-utilities';
import * as i1$2 from '@angular/common';
import { CommonModule, NgIf } from '@angular/common';
import * as i2$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4 from '@engineering11/ui-lib/e11-button';
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button';
import * as i5 from '@engineering11/ui-lib/e11-confirmation';
import { E11ConfirmationModule } from '@engineering11/ui-lib/e11-confirmation';
import * as i9 from '@engineering11/ui-lib/e11-switch';
import { E11SwitchModule } from '@engineering11/ui-lib/e11-switch';
import * as i5$1 from '@engineering11/ui-lib/e11-panel';
import { E11PanelModule } from '@engineering11/ui-lib/e11-panel';
import * as i11 from '@engineering11/ui-lib/e11-input';
import { E11InputModule } from '@engineering11/ui-lib/e11-input';
import * as i2$3 from '@engineering11/ui-lib/e11-empty-state';
import { E11EmptyStateModule } from '@engineering11/ui-lib/e11-empty-state';
import * as i5$2 from '@engineering11/ui-lib/e11-loader-dots';
import { E11LoaderDotsModule } from '@engineering11/ui-lib/e11-loader-dots';
import * as i3 from '@engineering11/ui-lib/e11-notifications';
import { E11NotificationMessage } from '@engineering11/ui-lib/e11-notifications';
import { AsYouType, format, parse } from 'libphonenumber-js';
import * as i7 from '@engineering11/ui-lib/e11-select';
import { E11SelectModule } from '@engineering11/ui-lib/e11-select';
import algoliasearch from 'algoliasearch/lite';
import * as i1$3 from '@engineering11/web-api-error';
import { isE11Error, e11Error, E11Logger, LOGGER_TOKEN } from '@engineering11/web-api-error';
import * as i6 from '@engineering11/angular-instantsearch';
import { NgAisHitsModule, NgAisSearchBoxModule, NgAisModule, NgAisInstantSearchModule } from '@engineering11/angular-instantsearch';
import * as i7$1 from '@engineering11/search-web';
import { SearchModule } from '@engineering11/search-web';
import * as i2$4 from '@engineering11/ui-lib/e11-card';
import { E11CardModule } from '@engineering11/ui-lib/e11-card';
import * as i2$6 from '@engineering11/ui-lib/e11-nav-left';
import { E11NavLeftModule, E11NavItemComponent } from '@engineering11/ui-lib/e11-nav-left';
import * as i11$1 from '@engineering11/ui-lib/e11-tabs';
import { E11TabsModule } from '@engineering11/ui-lib/e11-tabs';
import * as i3$3 from '@engineering11/ui-lib/e11-tooltip';
import { E11TooltipModule } from '@engineering11/ui-lib/e11-tooltip';
import * as i3$2 from '@ngrx/component';
import { LetDirective } from '@ngrx/component';
import * as i7$4 from '@engineering11/ui-lib/e11-autocomplete';
import { E11AutocompleteModule } from '@engineering11/ui-lib/e11-autocomplete';
import { E11AvatarModule } from '@engineering11/ui-lib/e11-avatar';
import { E11DividerModule } from '@engineering11/ui-lib/e11-divider';
import * as i4$1 from '@engineering11/ui-lib/e11-form-builder';
import { E11DynamicFormModule, e11FormFor, e11FormLayoutInlineGrid, e11FieldInputText, e11FormLayoutInline3Grid, e11FieldInputSelect, e11LayoutGroup, e11FieldInputUrl, e11FieldInputPhone, e11FormLayoutFullWidth, e11FieldInputSwitch, e11FieldInputTextArea, e11FieldInputMultiSelect } from '@engineering11/ui-lib/e11-form-builder';
import * as i7$3 from '@engineering11/ui-lib/e11-image';
import { E11ImageModule } from '@engineering11/ui-lib/e11-image';
import * as i4$2 from '@engineering11/ui-lib/e11-image-cropper';
import { E11ImageCropperModuleModule } from '@engineering11/ui-lib/e11-image-cropper';
import * as i6$1 from '@engineering11/ui-lib/e11-modal';
import { E11ModalModule } from '@engineering11/ui-lib/e11-modal';
import * as i8 from '@engineering11/ui-lib/e11-multi-select';
import { E11MultiSelectModule } from '@engineering11/ui-lib/e11-multi-select';
import { E11PhoneNumberModule } from '@engineering11/ui-lib/e11-phone-number';
import * as i7$2 from '@engineering11/ui-lib/e11-input-label';
import { E11InputLabelModule } from '@engineering11/ui-lib/e11-input-label';
import * as i1$4 from '@engineering11/maps-web';
import { AddressFormService, MapsModule } from '@engineering11/maps-web';
import * as i3$1 from '@engineering11/access-web';
import { tapResponse } from '@ngrx/operators';
import * as i5$3 from '@engineering11/ui-lib/e11-ui-utils';
import { E11TemplateMap } from '@engineering11/ui-lib/e11-ui-utils';
import * as i1$5 from '@engineering11/files-web';
import { ComponentStore } from '@ngrx/component-store';
import * as i2$5 from '@engineering11/web-ui-helpers';
import { __decorate, __param } from 'tslib';
import { DateService } from '@engineering11/date-time';
import { ActivityMonitorComponent } from '@engineering11/auth-web';

class BaseCustomerConfigProvider {
    getCurrentUserAppId() {
        return this.config.token$.pipe(filter(isNotNil), map((token) => {
            const user = jwt_decode(token);
            return user.appUserId;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseCustomerConfigProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseCustomerConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseCustomerConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
/**
 * @deprecated use BaseCustomerConfigProvider - less name clashing
 * TODO: On breaking change, delete
 */
class CustomerConfigProvider extends BaseCustomerConfigProvider {
}
class CustomerPartitionConfigProvider {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerPartitionConfigProvider, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerPartitionConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerPartitionConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class CultureIndexConfigProvider extends BaseCustomerConfigProvider {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CultureIndexConfigProvider, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CultureIndexConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CultureIndexConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class DefaultCustomerPartitionConfigProvider extends CustomerPartitionConfigProvider {
    get config() {
        return {
            listOfPartitionsUrl: '',
            basePartitionPartial: '',
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultCustomerPartitionConfigProvider, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultCustomerPartitionConfigProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultCustomerPartitionConfigProvider, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * A data partition is used for logically segregating a customers [platform specific] data.
 * The most common use of this would be for supporting data from multiple environments such
 * as dev, ci, qa, prod, demo.
 *
 * Note that this is only used for non-sdk based data specific to a platform, E11 SDK data (e.g. customer, users, messaging, etc.) do not support
 * data segregation. A good use case example would be a platform that ingests contacts via endpoint from a source system that belong to
 * a given customer within an E11 platform. The source system will want to test the ingestion in all of it's environments so the engineer
 * would create a data partition and pass along the ID for that partition with each call to the endpoint.
 *
 */
var ApiKeyType;
(function (ApiKeyType) {
    ApiKeyType["ADMIN"] = "customer-admin-key";
})(ApiKeyType || (ApiKeyType = {}));

var COLLECTIONS;
(function (COLLECTIONS) {
    COLLECTIONS["CUSTOMER"] = "customer/";
    COLLECTIONS["CUSTOMER_DEPARTMENT"] = "customer_department/";
    COLLECTIONS["CUSTOMER_LOCATION"] = "customer_location/";
    COLLECTIONS["CUSTOMER_CONTACT"] = "customer_contact/";
    COLLECTIONS["PARTITION_STASH"] = "customer_partition_stash/";
})(COLLECTIONS || (COLLECTIONS = {}));
var SEARCH_INDICES;
(function (SEARCH_INDICES) {
    SEARCH_INDICES["CUSTOMER"] = "customer";
    SEARCH_INDICES["CUSTOMER_CLIENT"] = "customer_client";
})(SEARCH_INDICES || (SEARCH_INDICES = {}));
const ERROR_HANDLING = {
    USER_NAME_MIN_LENGTH: 8,
    USER_NAME_MAX_LENGTH: 50,
    PASSWORD_MIN_LENGTH: 8,
    PASSWORD_MAX_LENGTH: 24,
    EMAIL_MIN_LENGTH: 7,
    EMAIL_MAX_LENGTH: 100,
    FIRST_NAME_MIN_LENGTH: 1,
    FIRST_NAME_MAX_LENGTH: 100,
    LAST_NAME_MIN_LENGTH: 1,
    LAST_NAME_MAX_LENGTH: 100,
    COMPANY_NAME_MIN_LENGTH: 5,
    COMPANY_NAME_MAX_LENGTH: 100,
    PHONE_MIN_LENGTH: 10,
    PHONE_MAX_LENGTH: 20,
    ADDRESS_MIN_LENGTH: 4,
    ADDRESS_MAX_LENGTH: 100,
    STATE_REQUIRED_LENGTH: 2,
    ZIP_MIN_LENGTH: 5,
    ZIP_MAX_LENGTH: 12,
    COUNTRY_REQUIRED_LENGTH: 2,
};
const DefaultApiKeyScopes = [
    {
        label: 'read',
        value: 'read',
        description: 'Read only access to applicable APIs.',
    },
    {
        label: 'write',
        value: 'write',
        description: 'Read and Write access to applicable APIs.',
    },
];
const DefaultApiKeyTypes = [{ name: 'Admin API Key', value: ApiKeyType.ADMIN }];
// Job posts and templates
const defaultLocationActiveInfo = "The status here allows this 'Location' to be available elsewhere in the app. If you turn it off it will not show as a selection in screens that let you choose a location.";
// Job posts and templates
const defaultDepartmentActiveInfo = 'Status allows a Department to be available and used elsewhere in the app. If you turn the status off the department will not show in screens using departments.';
const defaultContactTypes = [
    { name: 'Account Owner', value: 'AccountOwner' },
    { name: 'Billing', value: 'Billing' },
    { name: 'Technical', value: 'Technical' },
    { name: 'Other', value: 'Other' },
];
const LOGO_DEFAULTS = Object.freeze({
    headerText: 'Your Company Logo',
    subHeaderText: "This is your company's main logo",
    logoInfo: 'If a logo is added here, it will be used alongside your company when it is referenced. Please make sure it is a .png or .jpg file no larger than 5GB.',
});
const CLIENT_LOGO_DEFAULTS = Object.freeze({
    headerText: 'Client logo',
    subHeaderText: "This is your client's main logo",
    logoInfo: 'If a logo is added here, it will be used alongside your client when it is referenced. Please make sure it is a .png or .jpg file no larger than 5GB.',
});
var CustomerPermissions;
(function (CustomerPermissions) {
    CustomerPermissions["EditCustomerAddress"] = "customer/edit-customer-address";
    CustomerPermissions["EditCustomerSecurity"] = "customer/edit-customer-security";
    CustomerPermissions["EditClient"] = "customer/edit-client";
    CustomerPermissions["ViewClient"] = "customer/view-client";
    CustomerPermissions["EditClientAddress"] = "customer/edit-client-address";
    CustomerPermissions["EditClientSecurity"] = "customer/edit-client-security";
    CustomerPermissions["PlatformAdminEditAllCustomers"] = "customer/platform-admin-edit-all-customers";
    CustomerPermissions["PlatformAdminViewAllCustomers"] = "customer/platform-admin-view-all-customers";
    CustomerPermissions["PlatformAdminSearchAllCustomers"] = "customer/platform-admin-search-all-customers";
    CustomerPermissions["SearchTenants"] = "customer/search-tenants";
    CustomerPermissions["AddExternalId"] = "customer/add-external-id";
    CustomerPermissions["RequireBusinessSize"] = "customer/require-business-size";
    CustomerPermissions["EditRegistrationSettings"] = "customer/edit-registration-settings";
})(CustomerPermissions || (CustomerPermissions = {}));
var DefaultCustomerRoles;
(function (DefaultCustomerRoles) {
    DefaultCustomerRoles["TenantAdmin"] = "TenantAdmin";
    DefaultCustomerRoles["ClientEditor"] = "ClientEditor";
    DefaultCustomerRoles["ClientViewer"] = "ClientViewer";
})(DefaultCustomerRoles || (DefaultCustomerRoles = {}));
const EDIT_CLIENT_PERMISSION_MISSING = 'You do not have permission to manage clients';
const EDIT_PERMISSION_MISSING = 'You do not have permission to edit this';

class CustomerRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS.CUSTOMER;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class CustomerContactRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS.CUSTOMER_CONTACT;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class BaseCustomerRestService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = new RestApiClient({
            baseUrl: this.configProvider.config.baseUrl,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
            throwNon200s: true,
        });
    }
    /**
     * @param parentId The parent for the resource, used for building the path to the rest endpoint, for example clients/${parentId}/locations
     */
    getAll(parentId) {
        const path = this.buildPath(parentId);
        return this.restClient.get(`${path}`).pipe(map$1((response) => response.data));
    }
    /**
     * @param id The ID required to get the resource
     * @param parentId The parent for the resource, used for building the path to the rest endpoint, for example clients/${parentId}/locations
     */
    get(id, parentId) {
        const path = this.buildPath(parentId);
        return this.restClient.get(`${path}/${id}`).pipe(map$1((response) => response.data));
    }
    /**
     * @param item The item to add
     * @param parentId The parent for the resource, used for building the path to the rest endpoint, for example clients/${parentId}/locations
     */
    add(item, parentId) {
        const path = this.buildPath(parentId);
        return this.restClient.post(path, item).pipe(map$1((response) => response.data));
    }
    /**
     * * @param item The item to update
     * @param parentId The parent for the resource, used for building the path to the rest endpoint, for example clients/${parentId}/locations
     */
    update(item, parentId) {
        const path = this.buildPath(parentId);
        return this.restClient.put(`${path}/${item.id}`, item).pipe(map$1((response) => response.data));
    }
    /**
     * * @param id The ID required to delete the resource
     * @param parentId The parent for the resource, used for building the path to the rest endpoint, for example clients/${parentId}/locations
     */
    delete(id, parentId) {
        const path = this.buildPath(parentId);
        return this.restClient.delete(`${path}/${id}`).pipe(map$1((response) => response.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseCustomerRestService, deps: [{ token: BaseCustomerConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseCustomerRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: BaseCustomerRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseCustomerConfigProvider }] });

class CustomerClientDepartmentService extends BaseCustomerRestService {
    buildPath(parentId) {
        return `clients/${parentId}/departments`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDepartmentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDepartmentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDepartmentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class CustomerClientLocationService extends BaseCustomerRestService {
    buildPath(parentId) {
        return `clients/${parentId}/locations`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLocationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLocationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLocationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class CustomerClientContactService extends BaseCustomerRestService {
    buildPath(parentId) {
        return `clients/${parentId}/contacts`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientContactService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientContactService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientContactService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class CustomerDepartmentRestService extends BaseCustomerRestService {
    buildPath() {
        return `departments`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentRestService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class CustomerLocationRestService extends BaseCustomerRestService {
    buildPath() {
        return `locations`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationRestService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class CustomerContactRestService extends BaseCustomerRestService {
    buildPath() {
        return `contacts`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactRestService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class PlatformAdminCustomerRestService extends BaseCustomerRestService {
    buildPath(customerKey) {
        return `platform-admin/customers/${customerKey}`;
    }
    get(id) {
        const path = this.buildPath(id);
        return this.restClient.get(`${path}`).pipe(map$1((response) => response.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminCustomerRestService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminCustomerRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminCustomerRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class PlatformAdminDepartmentRestService extends BaseCustomerRestService {
    buildPath(parentId) {
        return `platform-admin/customers/${parentId}/departments`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminDepartmentRestService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminDepartmentRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminDepartmentRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class PlatformAdminLocationRestService extends BaseCustomerRestService {
    buildPath(parentId) {
        return `platform-admin/customers/${parentId}/locations`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminLocationRestService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminLocationRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminLocationRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });
class PlatformAdminContactRestService extends BaseCustomerRestService {
    buildPath(parentId) {
        return `platform-admin/customers/${parentId}/contacts`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminContactRestService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminContactRestService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminContactRestService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class CustomerContactService {
    constructor(repository, restService) {
        this.repository = repository;
        this.restService = restService;
    }
    get(customerKey, contactId) {
        return this.restService.get(contactId);
    }
    async getAll(customerKey) {
        return this.restService.getAll();
    }
    // async getAllValueChanges(customerKey: string) {
    //   return this.repository.getAllValueChanges(customerKey)
    // }
    async add(model) {
        return this.repository.set(model);
    }
    async update(model) {
        return this.repository.update(model);
    }
    async delete(model) {
        return this.repository.delete(model.id);
    }
    async set(model) {
        return this.repository.set(model);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactService, deps: [{ token: CustomerContactRepository }, { token: CustomerContactRestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CustomerContactRepository }, { type: CustomerContactRestService }] });

class CustomerDepartmentRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS.CUSTOMER_DEPARTMENT;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class CustomerDepartmentService {
    constructor(repository, restService) {
        this.repository = repository;
        this.restService = restService;
    }
    get(customerKey, departmentId) {
        return this.restService.get(departmentId);
    }
    getAll(customerKey) {
        return this.restService.getAll();
    }
    /**
     * Get all active retrieves only items that have an active status, use
     * this for dropdown and other lists where we should not show the inactive
     * items.
     *
     * @param customerKey
     * @returns
     */
    getAllActive(customerKey) {
        return this.restService.getAll().pipe(map$1((departments) => departments.filter((d) => d.active)));
        // return this.repository.getAllActive(customerKey)
    }
    async add(model) {
        return this.restService.add(model);
    }
    async update(model) {
        // return this.restService.update(model)
        return this.repository.update(model);
    }
    async delete(model) {
        return this.repository.delete(model.id);
    }
    async set(model) {
        return this.repository.set(model);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentService, deps: [{ token: CustomerDepartmentRepository }, { token: CustomerDepartmentRestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CustomerDepartmentRepository }, { type: CustomerDepartmentRestService }] });

class CustomerLocationRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS.CUSTOMER_LOCATION;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class CustomerLocationService {
    constructor(repository, restService, configProvider) {
        this.repository = repository;
        this.restService = restService;
        this.configProvider = configProvider;
        this.customerKey$ = this.configProvider.config.customerKey$.pipe(filter$1(isNotNil));
    }
    get(customerKey, locationId) {
        return this.restService.get(locationId);
    }
    getAll(customerKey) {
        return this.restService.getAll();
    }
    /**
     * Get all active retrieves only items that have an active status, use
     * this for dropdown and other lists where we should not show the inactive
     * items.
     *
     * @param customerKey - unused attribute
     * @returns
     */
    getAllActive(customerKey) {
        return this.getAll(customerKey).pipe(map$1((locations) => locations.filter((l) => l.active)));
    }
    async add(model) {
        return this.repository.add(model);
    }
    async update(model) {
        return this.repository.update(model);
    }
    async delete(model) {
        return this.repository.delete(model.id);
    }
    async set(model) {
        return this.repository.set(model);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationService, deps: [{ token: CustomerLocationRepository }, { token: CustomerLocationRestService }, { token: BaseCustomerConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CustomerLocationRepository }, { type: CustomerLocationRestService }, { type: BaseCustomerConfigProvider }] });

class CustomerService {
    constructor(configProvider, repository, contacts, departments, locations) {
        this.configProvider = configProvider;
        this.repository = repository;
        this.contacts = contacts;
        this.departments = departments;
        this.locations = locations;
        this.restClient = new RestApiClient({
            baseUrl: this.configProvider.config.baseUrl,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
            throwNon200s: true,
        });
    }
    tenantSearchKeyPackage() {
        return this.restClient.get(`search-keys/tenants`).pipe(map$1((kp) => kp.data));
    }
    get(customerKey) {
        return this.repository.get(customerKey);
    }
    getCurrentCustomer() {
        return this.configProvider.config.customerKey$.pipe(switchMap((customerKey) => (customerKey ? this.repository.getOrError(customerKey) : of(undefined))));
    }
    async add(model) {
        return this.repository.set(model);
    }
    async update(model) {
        return this.repository.update(model);
    }
    async delete(model) {
        return this.repository.delete(model.id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerService, deps: [{ token: BaseCustomerConfigProvider }, { token: CustomerRepository }, { token: CustomerContactService }, { token: CustomerDepartmentService }, { token: CustomerLocationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseCustomerConfigProvider }, { type: CustomerRepository }, { type: CustomerContactService }, { type: CustomerDepartmentService }, { type: CustomerLocationService }] });

/**
 * @deprecated - use sdk-customer-departments CustomerDepartmentsComponent
 */
class CustomerDepartmentDetailComponent {
    set departmentId(value) {
        if (!value) {
            this.department = {
                customerKey: this.customerKey,
                active: true,
            };
            return;
        }
        this.customerService.departments.get(this.customerKey, value).subscribe((data) => {
            if (!data)
                return;
            this.department = data;
            this.formDepartment.patchValue(data);
        });
    }
    constructor(formBuilder, translate, customerService, scrollLockService) {
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.customerService = customerService;
        this.scrollLockService = scrollLockService;
        this.confirmationMessage = 'Are you absolutely sure you want to delete this department? This cannot be undone.';
        // Forms:
        this.formDepartment = this.formBuilder.group({
            name: new UntypedFormControl(this.department?.name, [Validators.required]),
            internalCode: new UntypedFormControl(this.department?.internalCode),
        });
        this.formDepartmentSubmitted = false;
        this.successMessage = '';
        this.isExisting = true;
        this.onSuccess = new EventEmitter();
        translate.get('Success! You have added a company department.').subscribe((res) => {
            this.successMessage = res;
        });
    }
    ngOnInit() {
        this.createFormDepartment();
    }
    ngOnDestroy() {
        // this.subs.stop()
    }
    createFormDepartment() {
        this.formDepartment = this.formBuilder.group({
            name: new UntypedFormControl(this.department?.name, [Validators.required, E11FormValidator.whitespaceValidator()]),
            internalCode: new UntypedFormControl(this.department?.internalCode),
        });
        this.formDepartment.valueChanges.subscribe((changes) => {
            if (this.department) {
                this.department.name = changes.name;
                this.department.internalCode = changes.internalCode;
            }
        });
    }
    setActive(active) {
        if (this.department) {
            this.department.active = active;
        }
    }
    get f() {
        return this.formDepartment.controls;
    }
    async onSubmitFormDepartment() {
        if (this.formDepartment.valid && this.department) {
            if (this.department.id) {
                await this.customerService.departments.set(this.department);
            }
            else {
                await this.customerService.departments.add(this.department);
            }
            this.onSuccess.emit(true);
        }
        else {
            this.formDepartment.updateValueAndValidity();
            Validation.validateAll(this.formDepartment);
        }
    }
    deleteDepartment() {
        this.confirmation.open();
        this.scrollLockService.scrollLock(true);
    }
    confirmationAnswer(confirmed) {
        if (confirmed && this.department) {
            this.customerService.departments.delete(this.department);
            this.onSuccess.emit(true);
        }
        this.scrollLockService.scrollLock(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentDetailComponent, deps: [{ token: i1.UntypedFormBuilder }, { token: i2.TranslateService }, { token: CustomerService }, { token: i1$1.UiScrollLockingService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerDepartmentDetailComponent, selector: "customer-department-detail", inputs: { customerKey: "customerKey", departmentId: "departmentId" }, outputs: { onSuccess: "onSuccess" }, viewQueries: [{ propertyName: "confirmation", first: true, predicate: ["confirmation"], descendants: true }], ngImport: i0, template: "<e11-panel>\n  <form class=\"\" [formGroup]=\"formDepartment\" (ngSubmit)=\"onSubmitFormDepartment()\" novalidate>\n    <div class=\"e11-grid e11-grid-cols-1 md:e11-grid-cols-2 e11-gap-8 e11-mb-8\">\n      <div>\n        <div class=\"e11-w-full\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"name\"\n            id=\"name_formDepartment\"\n            label=\"{{ 'Department Name' | translate }}\"\n            [parentForm]=\"formDepartment\"\n            formControlName=\"name\"\n            [autofocus]=\"true\"\n            autocomplete=\"off\"\n            [required]=\"true\"\n            tabindex=\"0\"\n          >\n            <e11-input-errors [parentForm]=\"formDepartment\" [formControl]=\"f.name\" label=\"{{ 'Name' | translate }}\"></e11-input-errors>\n          </e11-input>\n        </div>\n\n        <div class=\"e11-w-full e11-mb-7\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"internalCode\"\n            id=\"departmentCode_formDepartment\"\n            label=\"{{ 'Department Code' | translate }}\"\n            [parentForm]=\"formDepartment\"\n            formControlName=\"internalCode\"\n            autocomplete=\"off\"\n            tabindex=\"1\"\n          >\n          </e11-input>\n        </div>\n      </div>\n      <div>\n        <div class=\"e11-w-full\">\n          <div class=\"e11-w-full e11-flex e11-items-center e11-pt-4 e11-mb-2\">\n            <div class=\"e11-grow e11-flex e11-items-center\">\n              <h3 class=\"e11-mb-0 e11-float-left e11-mr-4\">{{ \"Status\" | translate }}</h3>\n              <e11-switch size=\"sm\" [checked]=\"department?.active || false\" (changes)=\"setActive($event)\"></e11-switch>\n            </div>\n            <div class=\"e11-grow e11-flex e11-justify-end\"></div>\n          </div>\n\n          <div class=\"e11-w-full e11-flex\">\n            <p>\n              {{\n                \"Status allows a Department to be available and used for Job and Job Template Listings. (as well as in other places). If you turn the status off the department will not show in screens using departments.\"\n                  | translate\n              }}\n            </p>\n          </div>\n          <div class=\"e11-flex e11-w-full\" *ngIf=\"department && isExisting\">\n            <span class=\"e11-flex e11-items-center e11-text-skin-secondary e11-cursor-pointer\" (click)=\"deleteDepartment()\">\n              <span class=\"material-icons-outlined md-18 e11-mr-1\"> delete </span>\n              {{ \"Delete\" }}\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-w-full e11-flex e11-items-center e11-justify-center\">\n      <e11-button\n        id=\"department_cancel\"\n        value=\"{{ 'Cancel' | translate }}\"\n        color=\"neutral\"\n        [ghost]=\"true\"\n        [type]=\"'button'\"\n        [buttonGroup]=\"true\"\n        [routerLink]=\"['/customer/departments']\"\n        tabindex=\"4\"\n      >\n      </e11-button>\n      <e11-button id=\"submit_department\" value=\"{{ 'Save' | translate }}\" color=\"primary-accent\" [type]=\"'submit'\" tabindex=\"5\"></e11-button>\n    </div>\n  </form>\n</e11-panel>\n\n<!-- DElete Confirmation -->\n<e11-confirmation\n  #confirmation\n  confirmTitle=\"{{ 'Delete Department' | translate }}\"\n  confirmText=\"{{ 'Delete' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  (answer)=\"confirmationAnswer($event)\"\n>\n  <div [innerHTML]=\"confirmationMessage | translate\"></div>\n</e11-confirmation>\n", styles: [".address-additional{display:block;max-height:0;overflow:hidden;transition:all .2s ease-in-out 0s}.address-additional.active{max-height:200px;transition:all .2s ease-in-out 0s}.text-small{font-size:.8rem}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i5.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: i9.E11SwitchComponent, selector: "e11-switch", inputs: ["id", "size", "color", "label", "containerClassOverrides", "containerClass", "disabled", "disabledText", "checked", "loading", "spinnerLoading"], outputs: ["changes", "onChange", "changeEvent", "OnchangeEvent"] }, { kind: "component", type: i5$1.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: i11.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i2$2.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-department-detail', template: "<e11-panel>\n  <form class=\"\" [formGroup]=\"formDepartment\" (ngSubmit)=\"onSubmitFormDepartment()\" novalidate>\n    <div class=\"e11-grid e11-grid-cols-1 md:e11-grid-cols-2 e11-gap-8 e11-mb-8\">\n      <div>\n        <div class=\"e11-w-full\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"name\"\n            id=\"name_formDepartment\"\n            label=\"{{ 'Department Name' | translate }}\"\n            [parentForm]=\"formDepartment\"\n            formControlName=\"name\"\n            [autofocus]=\"true\"\n            autocomplete=\"off\"\n            [required]=\"true\"\n            tabindex=\"0\"\n          >\n            <e11-input-errors [parentForm]=\"formDepartment\" [formControl]=\"f.name\" label=\"{{ 'Name' | translate }}\"></e11-input-errors>\n          </e11-input>\n        </div>\n\n        <div class=\"e11-w-full e11-mb-7\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"internalCode\"\n            id=\"departmentCode_formDepartment\"\n            label=\"{{ 'Department Code' | translate }}\"\n            [parentForm]=\"formDepartment\"\n            formControlName=\"internalCode\"\n            autocomplete=\"off\"\n            tabindex=\"1\"\n          >\n          </e11-input>\n        </div>\n      </div>\n      <div>\n        <div class=\"e11-w-full\">\n          <div class=\"e11-w-full e11-flex e11-items-center e11-pt-4 e11-mb-2\">\n            <div class=\"e11-grow e11-flex e11-items-center\">\n              <h3 class=\"e11-mb-0 e11-float-left e11-mr-4\">{{ \"Status\" | translate }}</h3>\n              <e11-switch size=\"sm\" [checked]=\"department?.active || false\" (changes)=\"setActive($event)\"></e11-switch>\n            </div>\n            <div class=\"e11-grow e11-flex e11-justify-end\"></div>\n          </div>\n\n          <div class=\"e11-w-full e11-flex\">\n            <p>\n              {{\n                \"Status allows a Department to be available and used for Job and Job Template Listings. (as well as in other places). If you turn the status off the department will not show in screens using departments.\"\n                  | translate\n              }}\n            </p>\n          </div>\n          <div class=\"e11-flex e11-w-full\" *ngIf=\"department && isExisting\">\n            <span class=\"e11-flex e11-items-center e11-text-skin-secondary e11-cursor-pointer\" (click)=\"deleteDepartment()\">\n              <span class=\"material-icons-outlined md-18 e11-mr-1\"> delete </span>\n              {{ \"Delete\" }}\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"e11-w-full e11-flex e11-items-center e11-justify-center\">\n      <e11-button\n        id=\"department_cancel\"\n        value=\"{{ 'Cancel' | translate }}\"\n        color=\"neutral\"\n        [ghost]=\"true\"\n        [type]=\"'button'\"\n        [buttonGroup]=\"true\"\n        [routerLink]=\"['/customer/departments']\"\n        tabindex=\"4\"\n      >\n      </e11-button>\n      <e11-button id=\"submit_department\" value=\"{{ 'Save' | translate }}\" color=\"primary-accent\" [type]=\"'submit'\" tabindex=\"5\"></e11-button>\n    </div>\n  </form>\n</e11-panel>\n\n<!-- DElete Confirmation -->\n<e11-confirmation\n  #confirmation\n  confirmTitle=\"{{ 'Delete Department' | translate }}\"\n  confirmText=\"{{ 'Delete' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  (answer)=\"confirmationAnswer($event)\"\n>\n  <div [innerHTML]=\"confirmationMessage | translate\"></div>\n</e11-confirmation>\n", styles: [".address-additional{display:block;max-height:0;overflow:hidden;transition:all .2s ease-in-out 0s}.address-additional.active{max-height:200px;transition:all .2s ease-in-out 0s}.text-small{font-size:.8rem}\n"] }]
        }], ctorParameters: () => [{ type: i1.UntypedFormBuilder }, { type: i2.TranslateService }, { type: CustomerService }, { type: i1$1.UiScrollLockingService }], propDecorators: { confirmation: [{
                type: ViewChild,
                args: ['confirmation']
            }], customerKey: [{
                type: Input
            }], departmentId: [{
                type: Input
            }], onSuccess: [{
                type: Output
            }] } });

/**
 * @deprecated
 */
class CustomerDepartmentsListComponent {
    constructor(customerService, router) {
        this.customerService = customerService;
        this.router = router;
        this.addDepartment = new EventEmitter();
        this.viewDetail = new EventEmitter();
        this.loading = true;
        this.departments$ = this.customerService.departments.getAll(this.customerKey).pipe(finalize(() => (this.loading = false)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentsListComponent, deps: [{ token: CustomerService }, { token: i2$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerDepartmentsListComponent, selector: "customer-departments-list", inputs: { customerKey: "customerKey" }, outputs: { addDepartment: "addDepartment", viewDetail: "viewDetail" }, ngImport: i0, template: "<e11-panel>\n  <div class=\"e11-flex\">\n    <div class=\"e11-w-full\">\n      <div class=\"e11-hidden md:e11-flex e11-font-medium e11-border-b e11-border-skin-app-borders\">\n        <div class=\"e11-w-5/12 e11-font-primary-demibold e11-mb-2\">Code</div>\n        <div class=\"e11-w-6/12 e11-font-primary-demibold e11-mb-2\">Name</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 text-center ellipsis\">Active</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 text-center\">Edit</div>\n      </div>\n\n      <div class=\"loading\" *ngIf=\"loading\">\n        <div class=\"e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center\">\n          <e11-loader-dots [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n        </div>\n      </div>\n\n      <div *ngIf=\"(departments$ | async) && (departments$ | async)?.length !== 0; else emptyState\">\n        <div\n          class=\"e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-grey/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent\"\n          *ngFor=\"let department of departments$ | async\"\n          (click)=\"viewDetail.emit()\"\n        >\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-pl-0 md:e11-pl-2\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n              \"Code\" | translate\n            }}</span>\n            <span class=\"e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1\">{{ department.internalCode }}</span>\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-6/12\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n              \"Name\" | translate\n            }}</span>\n            <span class=\"e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1\">{{ department.name }}</span>\n          </div>\n          <div\n            class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\"\n          >\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n              \"Status\" | translate\n            }}</span>\n            <span class=\"e11-block material-icons-outlined e11-text-skin-success\" *ngIf=\"department.active\"> task_alt </span>\n            <span class=\"e11-block material-icons-outlined e11-text-skin-light\" *ngIf=\"!department.active\"> do_not_disturb_on </span>\n          </div>\n          <div\n            class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\"\n          >\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n              \"Edit\" | translate\n            }}</span>\n            <span class=\"e11-block material-icons-outlined e11-text-skin-primary-accent\"> edit </span>\n          </div>\n\n          <ng-template #emptyState>\n            <e11-empty-state\n              *ngIf=\"!loading\"\n              [icon]=\"'safety_divider'\"\n              [iconSize]=\"'md-36'\"\n              [iconType]=\"''\"\n              title=\"{{ 'No Company Departments' | translate }}\"\n              subtitle=\"{{ 'It appears that we do not have any company departments entered yet.' | translate }}\"\n              (click)=\"addDepartment.emit()\"\n            >\n            </e11-empty-state>\n          </ng-template>\n        </div>\n      </div>\n\n      <ng-template #emptyState>\n        <div class=\"e11-my-4\">\n          <e11-empty-state\n            *ngIf=\"!loading\"\n            [icon]=\"'badge'\"\n            [iconSize]=\"'md-36'\"\n            [iconType]=\"'outlined'\"\n            title=\"{{ 'No Company Departments' | translate }}\"\n            subtitle=\"{{ 'It appears that we do not have any company departments entered yet.' | translate }}\"\n            (click)=\"addDepartment.emit()\"\n          >\n          </e11-empty-state>\n        </div>\n      </ng-template>\n\n      <ng-template #emptyState>\n        <div class=\"text-center\" *ngIf=\"!loading\">\n          <div class=\"spacer-2rem\"></div>\n          <h2 class=\"text-secondary\">{{ \"No Company Departments\" | translate }}</h2>\n          <p>{{ \"It appears that we do not have any company departments entered yet.\" | translate }}</p>\n          <h3 class=\"pointer\" (click)=\"addDepartment.emit(true)\">{{ \"Let's add some!\" | translate }}</h3>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</e11-panel>\n", styles: [".header{display:flex;line-height:2rem;font-weight:600}.line-item{display:flex;line-height:4rem;cursor:pointer;height:4rem;align-items:center}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i5$1.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentsListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-departments-list', template: "<e11-panel>\n  <div class=\"e11-flex\">\n    <div class=\"e11-w-full\">\n      <div class=\"e11-hidden md:e11-flex e11-font-medium e11-border-b e11-border-skin-app-borders\">\n        <div class=\"e11-w-5/12 e11-font-primary-demibold e11-mb-2\">Code</div>\n        <div class=\"e11-w-6/12 e11-font-primary-demibold e11-mb-2\">Name</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 text-center ellipsis\">Active</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 text-center\">Edit</div>\n      </div>\n\n      <div class=\"loading\" *ngIf=\"loading\">\n        <div class=\"e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center\">\n          <e11-loader-dots [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n        </div>\n      </div>\n\n      <div *ngIf=\"(departments$ | async) && (departments$ | async)?.length !== 0; else emptyState\">\n        <div\n          class=\"e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-grey/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent\"\n          *ngFor=\"let department of departments$ | async\"\n          (click)=\"viewDetail.emit()\"\n        >\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-pl-0 md:e11-pl-2\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n              \"Code\" | translate\n            }}</span>\n            <span class=\"e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1\">{{ department.internalCode }}</span>\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-6/12\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n              \"Name\" | translate\n            }}</span>\n            <span class=\"e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1\">{{ department.name }}</span>\n          </div>\n          <div\n            class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\"\n          >\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n              \"Status\" | translate\n            }}</span>\n            <span class=\"e11-block material-icons-outlined e11-text-skin-success\" *ngIf=\"department.active\"> task_alt </span>\n            <span class=\"e11-block material-icons-outlined e11-text-skin-light\" *ngIf=\"!department.active\"> do_not_disturb_on </span>\n          </div>\n          <div\n            class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\"\n          >\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n              \"Edit\" | translate\n            }}</span>\n            <span class=\"e11-block material-icons-outlined e11-text-skin-primary-accent\"> edit </span>\n          </div>\n\n          <ng-template #emptyState>\n            <e11-empty-state\n              *ngIf=\"!loading\"\n              [icon]=\"'safety_divider'\"\n              [iconSize]=\"'md-36'\"\n              [iconType]=\"''\"\n              title=\"{{ 'No Company Departments' | translate }}\"\n              subtitle=\"{{ 'It appears that we do not have any company departments entered yet.' | translate }}\"\n              (click)=\"addDepartment.emit()\"\n            >\n            </e11-empty-state>\n          </ng-template>\n        </div>\n      </div>\n\n      <ng-template #emptyState>\n        <div class=\"e11-my-4\">\n          <e11-empty-state\n            *ngIf=\"!loading\"\n            [icon]=\"'badge'\"\n            [iconSize]=\"'md-36'\"\n            [iconType]=\"'outlined'\"\n            title=\"{{ 'No Company Departments' | translate }}\"\n            subtitle=\"{{ 'It appears that we do not have any company departments entered yet.' | translate }}\"\n            (click)=\"addDepartment.emit()\"\n          >\n          </e11-empty-state>\n        </div>\n      </ng-template>\n\n      <ng-template #emptyState>\n        <div class=\"text-center\" *ngIf=\"!loading\">\n          <div class=\"spacer-2rem\"></div>\n          <h2 class=\"text-secondary\">{{ \"No Company Departments\" | translate }}</h2>\n          <p>{{ \"It appears that we do not have any company departments entered yet.\" | translate }}</p>\n          <h3 class=\"pointer\" (click)=\"addDepartment.emit(true)\">{{ \"Let's add some!\" | translate }}</h3>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</e11-panel>\n", styles: [".header{display:flex;line-height:2rem;font-weight:600}.line-item{display:flex;line-height:4rem;cursor:pointer;height:4rem;align-items:center}\n"] }]
        }], ctorParameters: () => [{ type: CustomerService }, { type: i2$1.Router }], propDecorators: { customerKey: [{
                type: Input
            }], addDepartment: [{
                type: Output
            }], viewDetail: [{
                type: Output
            }] } });

/**
 * @deprecated
 */
class CustomerLocationDetailComponent {
    constructor(formBuilder, translate, activatedRoute, customerService, notificationsService) {
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.activatedRoute = activatedRoute;
        this.customerService = customerService;
        this.notificationsService = notificationsService;
        // Forms:
        this.formLocation = new UntypedFormGroup({});
        this.formLocationSubmitted = false;
        this.successMessage = '';
        this.locationId = '';
        this.stateList = [];
        this.STATE_REQUIRED_LENGTH = 2;
        translate.get('Success! You have added a company location.').subscribe((res) => {
            this.successMessage = res;
        });
    }
    ngOnInit() {
        this.asYouType = new AsYouType('US').input('2133734');
        this.format = format('2133734253', 'US', 'INTERNATIONAL'); // Case sensitive / CAPS
        this.parse = parse('(0777) 844 822', 'RO');
        this.createFormLocation();
        this.activatedRoute.queryParams.subscribe((params) => {
            this.locationId = params['id'];
            if (this.locationId) {
                this.customerService.locations.get(this.customerKey, this.locationId).subscribe((location) => {
                    this.location = location;
                    this.selectDefaultAddressState = this.location?.state;
                    this.formLocation.patchValue(this.location);
                });
            }
            else {
                this.location = { customerKey: this.customerKey, active: true };
            }
        });
    }
    createFormLocation() {
        this.formLocation = this.formBuilder.group({
            name: new UntypedFormControl(this.location?.name, [Validators.required, E11FormValidator.whitespaceValidator()]),
            secondaryName: new UntypedFormControl(this.location?.secondaryName),
            internalCode: new UntypedFormControl(this.location?.internalCode),
            address: new UntypedFormControl(this.location?.address, [Validators.required, E11FormValidator.whitespaceValidator()]),
            address2: new UntypedFormControl(this.location?.address2),
            city: new UntypedFormControl(this.location?.city, [Validators.required, E11FormValidator.validateAddressCity()]),
            state: new UntypedFormControl(this.selectDefaultAddressState, [Validators.required, Validators.minLength(this.STATE_REQUIRED_LENGTH)]),
            zip: new UntypedFormControl(this.location?.zip, [Validators.required, E11FormValidator.validateAddressZip()]),
            countryCode: new UntypedFormControl(this.location?.countryCode, [E11FormValidator.validateAddressCountry()]),
        });
        this.formLocation.valueChanges.subscribe((changes) => {
            if (this.location) {
                this.location.name = changes.name;
                this.location.internalCode = changes.internalCode;
                this.location.secondaryName = changes.secondaryName;
                this.location.address = changes.address1;
                this.location.address2 = changes.address2;
                this.location.city = changes.city;
                this.location.state = changes.state;
                this.location.zip = changes.zip;
                this.location.countryCode = changes.countryCode;
            }
        });
    }
    setActive(active) {
        if (this.location) {
            this.location.active = active;
        }
    }
    get f() {
        return this.formLocation.controls;
    }
    async onSubmitFormLocation() {
        this.formLocationSubmitted = true;
        if (this.formLocation.valid && this.location) {
            if (this.location.id) {
                await this.customerService.locations.set(this.location);
            }
            else {
                await this.customerService.locations.add(this.location);
            }
            this.formLocationSubmitted = false;
            // Get translations for the title and message
            let title = '', message = '';
            this.translate.get('Saved').subscribe((res) => {
                title = res;
            });
            this.translate.get('Your location information has been updated.').subscribe((res) => {
                message = res;
            });
            this.notificationsService.popNotificationMessage(new E11NotificationMessage(title, message, 'success', true, ''));
        }
        else {
            this.formLocation.updateValueAndValidity();
            Validation.validateAll(this.formLocation);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationDetailComponent, deps: [{ token: i1.UntypedFormBuilder }, { token: i2.TranslateService }, { token: i2$1.ActivatedRoute }, { token: CustomerService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerLocationDetailComponent, selector: "customer-location-detail", inputs: { customerKey: "customerKey", stateList: "stateList", STATE_REQUIRED_LENGTH: "STATE_REQUIRED_LENGTH" }, ngImport: i0, template: "<div class=\"e11-flex e11-flex-col md:e11-flex-row e11-gap-3\">\n  <div class=\"e11-w-full md:e11-w-3/4\">\n    <form class=\"\" [formGroup]=\"formLocation\" (ngSubmit)=\"onSubmitFormLocation()\" novalidate>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"name\"\n          id=\"locationName_formLocation\"\n          label=\"{{ 'Location' | translate }}\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formLocation\"\n          formControlName=\"name\"\n          [autofocus]=\"true\"\n          autocomplete=\"off\"\n          [required]=\"true\"\n          tabindex=\"0\"\n        >\n          <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.name\" label=\"{{ 'Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full e11-grid e11-grid-cols-1 md:e11-grid-cols-2 e11-gap-4\">\n        <div class=\"e11-mb-7\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"locationNameSecondary\"\n            id=\"locationNameSecondary_formLocation\"\n            label=\"{{ 'Location Name (Secondary)' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"secondaryName\"\n            autocomplete=\"off\"\n            tabindex=\"1\"\n          >\n          </e11-input>\n        </div>\n\n        <div class=\"e11-mb-7\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"locationCode\"\n            id=\"locationCode_formLocation\"\n            label=\"{{ 'Location Code' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"internalCode\"\n            autocomplete=\"off\"\n          >\n          </e11-input>\n        </div>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"address\"\n          id=\"address_formLocation\"\n          label=\"{{ 'Address' | translate }}\"\n          [parentForm]=\"formLocation\"\n          formControlName=\"address1\"\n          autocomplete=\"off\"\n          [required]=\"true\"\n        >\n          <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.address1\" label=\"{{ 'Address' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full e11-mb-7\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"address2\"\n          id=\"address2_formLocation\"\n          label=\"{{ 'Address additional...' | translate }}\"\n          [parentForm]=\"formLocation\"\n          formControlName=\"address2\"\n          autocomplete=\"off\"\n          placeholder=\"{{ 'Suite, Floor, Bldg, Apt. Attn...' | translate }}\"\n        >\n        </e11-input>\n      </div>\n\n      <div class=\"e11-flex e11-flex-wrap sm:e11-flex-nowrap sm:e11-gap-4\">\n        <div class=\"e11-w-full sm:e11-w-5/12 nopadding-left\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"city\"\n            id=\"city_formLocation\"\n            label=\"{{ 'City' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"city\"\n            autocomplete=\"off\"\n            [required]=\"true\"\n          >\n            <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.city\" label=\"{{ 'City' | translate }}\"></e11-input-errors>\n          </e11-input>\n        </div>\n        <div class=\"e11-w-full sm:e11-w-5/12 input-group\">\n          <e11-select\n            name=\"select\"\n            id=\"id_select\"\n            label=\"{{ 'State' | translate }}\"\n            labelPosition=\"top\"\n            [required]=\"true\"\n            [options]=\"stateList\"\n            formControlName=\"state\"\n          ></e11-select>\n          <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.state\" label=\"{{ 'State' | translate }}\"></e11-input-errors>\n        </div>\n        <div class=\"e11-w-full sm:e11-w-2/12\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"zip\"\n            id=\"zip_formLocation\"\n            label=\"{{ 'Zip' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"zip\"\n            autocomplete=\"off\"\n            [required]=\"true\"\n          >\n            <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.zip\" label=\"{{ 'Zip' | translate }}\"></e11-input-errors>\n          </e11-input>\n        </div>\n        <div class=\"e11-w-full sm:e11-w-2/12 nopadding-right\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"country\"\n            id=\"country_formLocation\"\n            label=\"{{ 'Country' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"countryCode\"\n            autocomplete=\"off\"\n          >\n            <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.countryCode\" label=\"{{ 'Country' | translate }}\"></e11-input-errors>\n          </e11-input>\n        </div>\n      </div>\n\n      <div class=\"e11-flex e11-w-full e11-justify-end\">\n        <e11-button\n          id=\"location_cancel\"\n          value=\"{{ 'Cancel' | translate }}\"\n          color=\"neutral\"\n          [type]=\"'button'\"\n          [buttonGroup]=\"true\"\n          [ghost]=\"true\"\n          [routerLink]=\"['/customer/locations']\"\n        >\n        </e11-button>\n        <e11-button id=\"submit_location\" value=\"{{ 'Save' | translate }}\" [color]=\"'primary-accent'\" [type]=\"'submit'\"> </e11-button>\n      </div>\n    </form>\n  </div>\n  <div class=\"e11-w-full md:e11-w-1/4\">\n    <div class=\"row\">\n      <div class=\"col-xs-6\">\n        <h3>Status</h3>\n      </div>\n      <div class=\"col-xs-6 text-right\">\n        <!-- <e11-switch size=\"xs\" [checked]=\"location?.active || false\" (changes)=\"setActive($event)\"> </e11-switch> -->\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <p>\n          {{\n            \"??The status here allows this 'Location' to be available for Job and Job Template Listings. (as well as in other places). If you turn it off it will not show as a selection in screens that let you choose a location.\"\n              | translate\n          }}\n        </p>\n        <div class=\"spacer-1rem\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".address-additional{display:block;max-height:0;overflow:hidden;transition:all .2s ease-in-out 0s}.address-additional.active{max-height:200px;transition:all .2s ease-in-out 0s}.text-small{font-size:.8rem}:host ::ng-deep .select-container{margin-bottom:2.3rem!important}\n"], dependencies: [{ kind: "directive", type: i2$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i7.E11SelectComponent, selector: "e11-select", inputs: ["id", "name", "label", "size", "selectMessage", "labelClass", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "selectClass"], outputs: ["valueChange", "onValueChange"] }, { kind: "component", type: i11.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i2$2.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationDetailComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-location-detail', template: "<div class=\"e11-flex e11-flex-col md:e11-flex-row e11-gap-3\">\n  <div class=\"e11-w-full md:e11-w-3/4\">\n    <form class=\"\" [formGroup]=\"formLocation\" (ngSubmit)=\"onSubmitFormLocation()\" novalidate>\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"name\"\n          id=\"locationName_formLocation\"\n          label=\"{{ 'Location' | translate }}\"\n          [borderGlow]=\"'primary'\"\n          [parentForm]=\"formLocation\"\n          formControlName=\"name\"\n          [autofocus]=\"true\"\n          autocomplete=\"off\"\n          [required]=\"true\"\n          tabindex=\"0\"\n        >\n          <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.name\" label=\"{{ 'Name' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full e11-grid e11-grid-cols-1 md:e11-grid-cols-2 e11-gap-4\">\n        <div class=\"e11-mb-7\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"locationNameSecondary\"\n            id=\"locationNameSecondary_formLocation\"\n            label=\"{{ 'Location Name (Secondary)' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"secondaryName\"\n            autocomplete=\"off\"\n            tabindex=\"1\"\n          >\n          </e11-input>\n        </div>\n\n        <div class=\"e11-mb-7\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"locationCode\"\n            id=\"locationCode_formLocation\"\n            label=\"{{ 'Location Code' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"internalCode\"\n            autocomplete=\"off\"\n          >\n          </e11-input>\n        </div>\n      </div>\n\n      <div class=\"e11-w-full\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"address\"\n          id=\"address_formLocation\"\n          label=\"{{ 'Address' | translate }}\"\n          [parentForm]=\"formLocation\"\n          formControlName=\"address1\"\n          autocomplete=\"off\"\n          [required]=\"true\"\n        >\n          <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.address1\" label=\"{{ 'Address' | translate }}\"></e11-input-errors>\n        </e11-input>\n      </div>\n\n      <div class=\"e11-w-full e11-mb-7\">\n        <e11-input\n          [type]=\"'text'\"\n          name=\"address2\"\n          id=\"address2_formLocation\"\n          label=\"{{ 'Address additional...' | translate }}\"\n          [parentForm]=\"formLocation\"\n          formControlName=\"address2\"\n          autocomplete=\"off\"\n          placeholder=\"{{ 'Suite, Floor, Bldg, Apt. Attn...' | translate }}\"\n        >\n        </e11-input>\n      </div>\n\n      <div class=\"e11-flex e11-flex-wrap sm:e11-flex-nowrap sm:e11-gap-4\">\n        <div class=\"e11-w-full sm:e11-w-5/12 nopadding-left\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"city\"\n            id=\"city_formLocation\"\n            label=\"{{ 'City' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"city\"\n            autocomplete=\"off\"\n            [required]=\"true\"\n          >\n            <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.city\" label=\"{{ 'City' | translate }}\"></e11-input-errors>\n          </e11-input>\n        </div>\n        <div class=\"e11-w-full sm:e11-w-5/12 input-group\">\n          <e11-select\n            name=\"select\"\n            id=\"id_select\"\n            label=\"{{ 'State' | translate }}\"\n            labelPosition=\"top\"\n            [required]=\"true\"\n            [options]=\"stateList\"\n            formControlName=\"state\"\n          ></e11-select>\n          <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.state\" label=\"{{ 'State' | translate }}\"></e11-input-errors>\n        </div>\n        <div class=\"e11-w-full sm:e11-w-2/12\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"zip\"\n            id=\"zip_formLocation\"\n            label=\"{{ 'Zip' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"zip\"\n            autocomplete=\"off\"\n            [required]=\"true\"\n          >\n            <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.zip\" label=\"{{ 'Zip' | translate }}\"></e11-input-errors>\n          </e11-input>\n        </div>\n        <div class=\"e11-w-full sm:e11-w-2/12 nopadding-right\">\n          <e11-input\n            [type]=\"'text'\"\n            name=\"country\"\n            id=\"country_formLocation\"\n            label=\"{{ 'Country' | translate }}\"\n            [parentForm]=\"formLocation\"\n            formControlName=\"countryCode\"\n            autocomplete=\"off\"\n          >\n            <e11-input-errors [parentForm]=\"formLocation\" [formControl]=\"f.countryCode\" label=\"{{ 'Country' | translate }}\"></e11-input-errors>\n          </e11-input>\n        </div>\n      </div>\n\n      <div class=\"e11-flex e11-w-full e11-justify-end\">\n        <e11-button\n          id=\"location_cancel\"\n          value=\"{{ 'Cancel' | translate }}\"\n          color=\"neutral\"\n          [type]=\"'button'\"\n          [buttonGroup]=\"true\"\n          [ghost]=\"true\"\n          [routerLink]=\"['/customer/locations']\"\n        >\n        </e11-button>\n        <e11-button id=\"submit_location\" value=\"{{ 'Save' | translate }}\" [color]=\"'primary-accent'\" [type]=\"'submit'\"> </e11-button>\n      </div>\n    </form>\n  </div>\n  <div class=\"e11-w-full md:e11-w-1/4\">\n    <div class=\"row\">\n      <div class=\"col-xs-6\">\n        <h3>Status</h3>\n      </div>\n      <div class=\"col-xs-6 text-right\">\n        <!-- <e11-switch size=\"xs\" [checked]=\"location?.active || false\" (changes)=\"setActive($event)\"> </e11-switch> -->\n      </div>\n    </div>\n\n    <div class=\"row\">\n      <div class=\"col-xs-12\">\n        <p>\n          {{\n            \"??The status here allows this 'Location' to be available for Job and Job Template Listings. (as well as in other places). If you turn it off it will not show as a selection in screens that let you choose a location.\"\n              | translate\n          }}\n        </p>\n        <div class=\"spacer-1rem\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".address-additional{display:block;max-height:0;overflow:hidden;transition:all .2s ease-in-out 0s}.address-additional.active{max-height:200px;transition:all .2s ease-in-out 0s}.text-small{font-size:.8rem}:host ::ng-deep .select-container{margin-bottom:2.3rem!important}\n"] }]
        }], ctorParameters: () => [{ type: i1.UntypedFormBuilder }, { type: i2.TranslateService }, { type: i2$1.ActivatedRoute }, { type: CustomerService }, { type: i3.E11NotificationsService }], propDecorators: { customerKey: [{
                type: Input
            }], stateList: [{
                type: Input
            }], STATE_REQUIRED_LENGTH: [{
                type: Input
            }] } });

/**
 * @deprecated
 */
class CustomerLocationListComponent {
    set customerKey(value) {
        this.locations$ = this.customerService.locations.getAll(value).pipe(finalize(() => (this.loading = false)));
    }
    constructor(customerService, router) {
        this.customerService = customerService;
        this.router = router;
        this.loading = true;
        this.addLocation = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationListComponent, deps: [{ token: CustomerService }, { token: i2$1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerLocationListComponent, selector: "customer-location-list", inputs: { customerKey: "customerKey" }, outputs: { addLocation: "addLocation" }, ngImport: i0, template: "<e11-panel>\n  <div class=\"e11-flex\">\n    <div class=\"e11-w-full\">\n      <div class=\"e11-hidden md:e11-flex e11-font-medium e11-border-b e11-border-skin-app-borders\">\n        <div class=\"e11-w-1/5 e11-font-primary-demibold e11-mb-2\">{{ \"Code\" | translate }}</div>\n        <div class=\"e11-w-5/12 e11-font-primary-demibold e11-mb-2\">{{ \"Name\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 ellipsis\">{{ \"City\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 text-center ellipsis\">{{ \"State\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 text-center ellipsis\">{{ \"Country\" | translate }}</div>\n        <div class=\"e11-w-1/12 e11-font-primary-demibold e11-mb-2 text-center ellipsis\">{{ \"Active\" | translate }}</div>\n        <div class=\"e11-w-1/12 e11-font-primary-demibold e11-mb-2 text-center\">{{ \"Edit\" | translate }}</div>\n      </div>\n\n      <div class=\"loading\" *ngIf=\"loading\">\n        <div class=\"e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center\">\n          <e11-loader-dots [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n        </div>\n      </div>\n\n      <div *ngIf=\"(locations$ | async) && (locations$ | async)?.length !== 0; else emptyState\">\n        <div\n          class=\"e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-h-[4rem] e11-cursor-pointer hover:e11-bg-skin-secondary-100 md:e11-border-b md:e11-border-skin-app-borders\"\n          *ngFor=\"let location of locations$ | async\"\n          [routerLink]=\"['/customer/locations/detail']\"\n          [queryParams]=\"{ id: location.id }\"\n        >\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/5 ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"Code\" | translate }}</span>\n            {{ location.internalCode }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-5/12 ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"Name\" | translate }}</span>\n            {{ location.name }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"City\" | translate }}</span>\n            {{ location.city }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 md:e11-text-center ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"State\" | translate }}</span>\n            {{ location.state }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 md:e11-text-center ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{\n              \"Country\" | translate\n            }}</span>\n            {{ location.countryCode }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/12 md:e11-text-center ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"Active\" | translate }}</span>\n            <span class=\"material-icons-outlined e11-text-skin-primary\" *ngIf=\"location.active\"> thumb_up </span>\n            <span class=\"material-icons-outlined e11-text-skin-light\" *ngIf=\"!location.active\"> thumb_down </span>\n          </div>\n          <div\n            class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/12 md:e11-text-center color-secondary\"\n          >\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"Edit\" | translate }}</span>\n            <span class=\"material-icons-outlined\"> edit </span>\n          </div>\n        </div>\n      </div>\n\n      <ng-template #emptyState>\n        <e11-empty-state\n          *ngIf=\"!loading\"\n          [icon]=\"'location_on'\"\n          [iconSize]=\"'md-36'\"\n          [iconType]=\"''\"\n          title=\"{{ 'No Company Locations' | translate }}\"\n          subtitle=\"{{ 'It appears that we do not have any company locations entered yet.' | translate }}\"\n          (click)=\"addLocation.emit(true)\"\n        >\n        </e11-empty-state>\n      </ng-template>\n    </div>\n  </div>\n</e11-panel>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "info", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i5$1.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-location-list', template: "<e11-panel>\n  <div class=\"e11-flex\">\n    <div class=\"e11-w-full\">\n      <div class=\"e11-hidden md:e11-flex e11-font-medium e11-border-b e11-border-skin-app-borders\">\n        <div class=\"e11-w-1/5 e11-font-primary-demibold e11-mb-2\">{{ \"Code\" | translate }}</div>\n        <div class=\"e11-w-5/12 e11-font-primary-demibold e11-mb-2\">{{ \"Name\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 ellipsis\">{{ \"City\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 text-center ellipsis\">{{ \"State\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-font-primary-demibold e11-mb-2 text-center ellipsis\">{{ \"Country\" | translate }}</div>\n        <div class=\"e11-w-1/12 e11-font-primary-demibold e11-mb-2 text-center ellipsis\">{{ \"Active\" | translate }}</div>\n        <div class=\"e11-w-1/12 e11-font-primary-demibold e11-mb-2 text-center\">{{ \"Edit\" | translate }}</div>\n      </div>\n\n      <div class=\"loading\" *ngIf=\"loading\">\n        <div class=\"e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center\">\n          <e11-loader-dots [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n        </div>\n      </div>\n\n      <div *ngIf=\"(locations$ | async) && (locations$ | async)?.length !== 0; else emptyState\">\n        <div\n          class=\"e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-h-[4rem] e11-cursor-pointer hover:e11-bg-skin-secondary-100 md:e11-border-b md:e11-border-skin-app-borders\"\n          *ngFor=\"let location of locations$ | async\"\n          [routerLink]=\"['/customer/locations/detail']\"\n          [queryParams]=\"{ id: location.id }\"\n        >\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/5 ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"Code\" | translate }}</span>\n            {{ location.internalCode }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-5/12 ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"Name\" | translate }}</span>\n            {{ location.name }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"City\" | translate }}</span>\n            {{ location.city }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 md:e11-text-center ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"State\" | translate }}</span>\n            {{ location.state }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 md:e11-text-center ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{\n              \"Country\" | translate\n            }}</span>\n            {{ location.countryCode }}\n          </div>\n          <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/12 md:e11-text-center ellipsis\">\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"Active\" | translate }}</span>\n            <span class=\"material-icons-outlined e11-text-skin-primary\" *ngIf=\"location.active\"> thumb_up </span>\n            <span class=\"material-icons-outlined e11-text-skin-light\" *ngIf=\"!location.active\"> thumb_down </span>\n          </div>\n          <div\n            class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/12 md:e11-text-center color-secondary\"\n          >\n            <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-pl-3 e11-py-3 e11-font-medium e11-bg-skin-primary-100\">{{ \"Edit\" | translate }}</span>\n            <span class=\"material-icons-outlined\"> edit </span>\n          </div>\n        </div>\n      </div>\n\n      <ng-template #emptyState>\n        <e11-empty-state\n          *ngIf=\"!loading\"\n          [icon]=\"'location_on'\"\n          [iconSize]=\"'md-36'\"\n          [iconType]=\"''\"\n          title=\"{{ 'No Company Locations' | translate }}\"\n          subtitle=\"{{ 'It appears that we do not have any company locations entered yet.' | translate }}\"\n          (click)=\"addLocation.emit(true)\"\n        >\n        </e11-empty-state>\n      </ng-template>\n    </div>\n  </div>\n</e11-panel>\n" }]
        }], ctorParameters: () => [{ type: CustomerService }, { type: i2$1.Router }], propDecorators: { customerKey: [{
                type: Input
            }], addLocation: [{
                type: Output
            }] } });

class CustomerSummaryComponent {
    constructor() {
        this.loading = true;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerSummaryComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerSummaryComponent, selector: "sdk-business-customer-summary", inputs: { customerSummary: "customerSummary", loading: "loading" }, ngImport: i0, template: "<div class=\"e11-w-full\">\n  <e11-loader-dots *ngIf=\"loading\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n\n  <div class=\"e11-flex e11-w-full e11-mb-6\">\n    <div class=\"e11-grow e11-flex\">\n      <h3>{{ customerSummary?.name }}</h3>\n    </div>\n  </div>\n  <div class=\"e11-flex e11-mb-8 e11-pb-4\">\n    <div class=\"e11-w-full\">\n      <div class=\"e11-hidden md:e11-flex e11-font-medium e11-border-b e11-border-skin-app-borders e11-px-6\">\n        <div class=\"e11-w-3/12 e11-mb-2\">{{ \"First Name\" | translate }}</div>\n        <div class=\"e11-w-3/12 e11-mb-2\">{{ \"Last Name\" | translate }}</div>\n        <div class=\"e11-w-4/12 e11-mb-2\">{{ \"Email\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-mb-2\">{{ \"Phone Number\" | translate }}</div>\n      </div>\n\n      <div\n        class=\"e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-px-6 md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent odd:e11-bg-skin-grey/10\"\n      >\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-3/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"First Name\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-line-clamp-1\"> nameFirst </span>\n        </div>\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-3/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"Last Name\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-line-clamp-1\"> nameLast </span>\n        </div>\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-4/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{ \"Email\" | translate }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1\"> email </span>\n        </div>\n\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"Phone Number\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1\"> phone </span>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"e11-flex e11-w-full e11-mb-6\">\n    <div class=\"e11-grow\">\n      <h3>{{ \"Address\" | translate }}</h3>\n    </div>\n  </div>\n\n  <div class=\"e11-flex e11-mb-8 e11-pb-4\">\n    <div class=\"e11-w-full\">\n      <div class=\"e11-hidden md:e11-flex e11-font-medium e11-border-b e11-border-skin-app-borders e11-px-6\">\n        <div class=\"e11-w-3/12 e11-mb-2\">{{ \"Address\" | translate }}</div>\n        <div class=\"e11-w-3/12 e11-mb-2\">{{ \"Address 2\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-mb-2 e11-text-left md:e11-text-center\">{{ \"City\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-mb-2 e11-text-left md:e11-text-center\">{{ \"State\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-mb-2 e11-text-left md:e11-text-center\">{{ \"Zip\" | translate }}</div>\n      </div>\n\n      <div\n        class=\"e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-px-6 md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent odd:e11-bg-skin-grey/10\"\n      >\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-3/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"Address\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-line-clamp-1\">{{ customerSummary?.address }} </span>\n        </div>\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-3/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"Address 2\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1\">{{ customerSummary?.address2 }}</span>\n        </div>\n\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{ \"City\" | translate }}</span>\n          <span class=\"e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1\">{{ customerSummary?.city }}</span>\n        </div>\n\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{ \"State\" | translate }}</span>\n          <span class=\"e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1\">{{ customerSummary?.state }}</span>\n        </div>\n\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{ \"Zip\" | translate }}</span>\n          <span class=\"e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1\">{{ customerSummary?.zip }}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerSummaryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-business-customer-summary', template: "<div class=\"e11-w-full\">\n  <e11-loader-dots *ngIf=\"loading\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n\n  <div class=\"e11-flex e11-w-full e11-mb-6\">\n    <div class=\"e11-grow e11-flex\">\n      <h3>{{ customerSummary?.name }}</h3>\n    </div>\n  </div>\n  <div class=\"e11-flex e11-mb-8 e11-pb-4\">\n    <div class=\"e11-w-full\">\n      <div class=\"e11-hidden md:e11-flex e11-font-medium e11-border-b e11-border-skin-app-borders e11-px-6\">\n        <div class=\"e11-w-3/12 e11-mb-2\">{{ \"First Name\" | translate }}</div>\n        <div class=\"e11-w-3/12 e11-mb-2\">{{ \"Last Name\" | translate }}</div>\n        <div class=\"e11-w-4/12 e11-mb-2\">{{ \"Email\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-mb-2\">{{ \"Phone Number\" | translate }}</div>\n      </div>\n\n      <div\n        class=\"e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-px-6 md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent odd:e11-bg-skin-grey/10\"\n      >\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-3/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"First Name\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-line-clamp-1\"> nameFirst </span>\n        </div>\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-3/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"Last Name\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-line-clamp-1\"> nameLast </span>\n        </div>\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-4/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{ \"Email\" | translate }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1\"> email </span>\n        </div>\n\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"Phone Number\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1\"> phone </span>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"e11-flex e11-w-full e11-mb-6\">\n    <div class=\"e11-grow\">\n      <h3>{{ \"Address\" | translate }}</h3>\n    </div>\n  </div>\n\n  <div class=\"e11-flex e11-mb-8 e11-pb-4\">\n    <div class=\"e11-w-full\">\n      <div class=\"e11-hidden md:e11-flex e11-font-medium e11-border-b e11-border-skin-app-borders e11-px-6\">\n        <div class=\"e11-w-3/12 e11-mb-2\">{{ \"Address\" | translate }}</div>\n        <div class=\"e11-w-3/12 e11-mb-2\">{{ \"Address 2\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-mb-2 e11-text-left md:e11-text-center\">{{ \"City\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-mb-2 e11-text-left md:e11-text-center\">{{ \"State\" | translate }}</div>\n        <div class=\"e11-w-2/12 e11-mb-2 e11-text-left md:e11-text-center\">{{ \"Zip\" | translate }}</div>\n      </div>\n\n      <div\n        class=\"e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-px-6 md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent odd:e11-bg-skin-grey/10\"\n      >\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-3/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"Address\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-line-clamp-1\">{{ customerSummary?.address }} </span>\n        </div>\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-3/12\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{\n            \"Address 2\" | translate\n          }}</span>\n          <span class=\"e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1\">{{ customerSummary?.address2 }}</span>\n        </div>\n\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{ \"City\" | translate }}</span>\n          <span class=\"e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1\">{{ customerSummary?.city }}</span>\n        </div>\n\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{ \"State\" | translate }}</span>\n          <span class=\"e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1\">{{ customerSummary?.state }}</span>\n        </div>\n\n        <div class=\"e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left md:e11-text-center\">\n          <span class=\"md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base\">{{ \"Zip\" | translate }}</span>\n          <span class=\"e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1\">{{ customerSummary?.zip }}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { customerSummary: [{
                type: Input
            }], loading: [{
                type: Input
            }] } });

class CustomerComponent {
    constructor() { }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerComponent, selector: "lib-customer", ngImport: i0, template: ` <p>customer works!</p> `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-customer', template: ` <p>customer works!</p> ` }]
        }], ctorParameters: () => [] });

class DynamicComponentService {
    get dynamicTabs() {
        return this._dynamicComponents || [];
    }
    loadComponents(config) {
        this._dynamicComponents = config;
        return this;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DynamicComponentService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DynamicComponentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DynamicComponentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const registrationSettingsKeys = [
    'allowDomainRegistration',
    'registrationDomains',
    'domainRegistrationRoles',
];
var CustomerType;
(function (CustomerType) {
    CustomerType["Business"] = "Business";
    CustomerType["Consumer"] = "Consumer";
})(CustomerType || (CustomerType = {}));
var BusinessClassification;
(function (BusinessClassification) {
    BusinessClassification["SoleProprietorship"] = "Sole proprietorship";
    BusinessClassification["Partnership"] = "Partnership";
    BusinessClassification["LLP"] = "LLP";
    BusinessClassification["LLC"] = "LLC";
    BusinessClassification["CCorp"] = "C corporation";
    BusinessClassification["SCorp"] = "S corporation";
    BusinessClassification["NonprofitCorporation"] = "Nonprofit corporation";
    BusinessClassification["BenefitCorporation"] = "Benefit corporation";
    BusinessClassification["Other"] = "Other";
})(BusinessClassification || (BusinessClassification = {}));
// https://www.investopedia.com/terms/i/industrygroup.asp
var IndustrySector;
(function (IndustrySector) {
    IndustrySector["CommunicationServices"] = "Communication Services";
    IndustrySector["ConsumerDiscretionary"] = "Consumer Discretionary";
    IndustrySector["ConsumerStaples"] = "Consumer Staples";
    IndustrySector["Energy"] = "Energy";
    IndustrySector["Financials"] = "Financials";
    IndustrySector["HealthCare"] = "Health Care";
    IndustrySector["Industrials"] = "Industrials";
    IndustrySector["InformationTechnology"] = "Information Technology";
    IndustrySector["Materials"] = "Materials";
    IndustrySector["RealEstate"] = "Real Estate";
    IndustrySector["Utilities"] = "Utilities";
})(IndustrySector || (IndustrySector = {}));
const BusinessSizeRange = ['1-10', '11-50', '51-200', '201-500', '501-1000', '1001-5000', '5001-10,000', '10,001+'];
// https://www.investopedia.com/terms/i/industrygroup.asp
const GICSIndustryGroup = [
    'Automobiles and Components',
    'Banks',
    'Capital Goods',
    'Commercial and Professional Services',
    'Consumer Durables and Apparel',
    'Consumer Services',
    'Diversified Financials',
    'Energy',
    'Food, Beverage, and Tobacco',
    'Food and Staples Retailing',
    'Health Care Equipment and Services',
    'Household and Personal Products',
    'Insurance',
    'Materials',
    'Media and Entertainment',
    'Pharmaceuticals, Biotechnology, and Life Sciences',
    'Real Estate',
    'Retailing',
    'Semiconductors and Semiconductor Equipment',
    'Software and Services',
    'Technology Hardware and Equipment',
    'Telecommunication Services',
    'Transportation',
    'Utilities',
];

class PlatformAdminSearchKeyService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = new RestApiClient({
            baseUrl: this.configProvider.config.baseUrl,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
            throwNon200s: true,
        });
    }
    allCustomerSearchKeyPackage() {
        return this.restClient.get(`search-keys/customers`).pipe(map$1((kp) => kp.data));
    }
    businessCustomerSearchKeyPackage() {
        return this.restClient.get(`search-keys/business-customers`).pipe(map$1((kp) => kp.data));
    }
    consumerCustomerSearchKeyPackage() {
        return this.restClient.get(`search-keys/consumer-customers`).pipe(map$1((kp) => kp.data));
    }
    clientSearchKeyPackage(customerKey) {
        return this.restClient.get(`search-keys/${customerKey}/clients`).pipe(map$1((kp) => kp.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminSearchKeyService, deps: [{ token: BaseCustomerConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminSearchKeyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminSearchKeyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseCustomerConfigProvider }] });

class SearchAllCustomersComponent {
    constructor(platformAdminSearchKeyService, logger) {
        this.platformAdminSearchKeyService = platformAdminSearchKeyService;
        this.logger = logger;
        this.viewContext = 'search';
        this.searchParams = { hitsPerPage: 20 };
        this.customerSelected = new EventEmitter();
    }
    ngOnInit() {
        let keyPackageFn = this.platformAdminSearchKeyService.allCustomerSearchKeyPackage();
        if (this.customerType) {
            keyPackageFn =
                this.customerType === CustomerType.Business
                    ? this.platformAdminSearchKeyService.businessCustomerSearchKeyPackage()
                    : this.platformAdminSearchKeyService.consumerCustomerSearchKeyPackage();
        }
        keyPackageFn.pipe(filter$1(isNotNil), take(1)).subscribe((keyPackage) => {
            this.config = {
                indexName: SEARCH_INDICES.CUSTOMER,
                searchClient: algoliasearch(keyPackage.searchAppId, keyPackage.searchKey),
            };
        });
    }
    select(customer) {
        this.customerSelected.emit(customer);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SearchAllCustomersComponent, deps: [{ token: PlatformAdminSearchKeyService }, { token: i1$3.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: SearchAllCustomersComponent, selector: "sdk-customer-search-all", inputs: { customerType: "customerType" }, outputs: { customerSelected: "customerSelected" }, ngImport: i0, template: "<e11-loader-dots *ngIf=\"!config\" [color]=\"'e11-bg-skin-primary-accent'\" label=\"{{ 'Retrieving customers...' | translate }}\"></e11-loader-dots>\n\n<ng-container *ngIf=\"config\">\n  <ais-instantsearch #instantSearch [config]=\"config\">\n    <ais-configure [searchParameters]=\"searchParams\"></ais-configure>\n    <search-refresh #searchRefresh></search-refresh>\n    <div class=\"e11-w-full e11-mb-16\">\n      <ais-hits>\n        <ng-template let-hits=\"hits\" let-results=\"results\">\n          <!-- Filter / Search / CTA -->\n          <div class=\"e11-w-full e11-block md:e11-flex e11-mb-8\">\n            <div class=\"e11-grow md:e11-mr-6\">\n              <div class=\"e11-max-w-lg\">\n                <ais-search-box\n                  placeholder=\"{{ 'Search Customers' | translate }}\"\n                  submitTitle=\"string\"\n                  resetTitle=\"string\"\n                  [searchAsYouType]=\"true\"\n                ></ais-search-box>\n\n                <!-- Results count -->\n                <div *ngIf=\"results\" class=\"e11-flex e11-w-full e11-mb-2 e11-text-xs e11-text-skin-light e11-justify-end\">\n                  <ais-stats>\n                    <ng-template let-state=\"state\">\n                      {{ state.nbHits }} {{ state.nbHits === 1 ? \"record found.\" : (\"records found.\" | translate) }}\n                    </ng-template>\n                  </ais-stats>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <ng-container *ngIf=\"results && hits.length\">\n            <div class=\"e11-grid e11-grid-cols-6 e11-w-full e11-px-4 e11-py-4 e11-text-sm md:e11-text-base e11-border-b e11-border-skin-app-borders\">\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"Name\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"Phone\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"City\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"State\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"Tenant Customer\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"Disabled\" | translate }}\n              </div>\n            </div>\n\n            <div\n              class=\"e11-grid e11-grid-cols-6 e11-w-full e11-text-sm md:e11-text-base e11-px-4 e11-py-4 e11-border-b e11-border-skin-app-borders e11-transition e11-duration-200 e11-ease-in-out e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 odd:e11-bg-skin-grey/10\"\n              *ngFor=\"let customer of hits; let i = index\"\n              (click)=\"select(customer)\"\n            >\n              <div class=\"e11-truncate\">{{ customer.name }}</div>\n              <div class=\"e11-truncate\">{{ customer.phone }}</div>\n              <div class=\"e11-truncate\">{{ customer.city }}</div>\n              <div class=\"e11-truncate\">{{ customer.state }}</div>\n              <div class=\"e11-truncate\">\n                <div *ngIf=\"customer.isTenantCustomer\">{{ \"Y\" | translate }}</div>\n                <div *ngIf=\"!customer.isTenantCustomer\">{{ \"-\" }}</div>\n              </div>\n\n              <div class=\"e11-truncate\">\n                <div *ngIf=\"customer.isDisabled\">{{ \"Y\" | translate }}</div>\n                <div *ngIf=\"!customer.isDisabled\">{{ \"-\" }}</div>\n              </div>\n            </div>\n          </ng-container>\n\n          <!-- Empty State / NOT clickable -->\n          <e11-empty-state\n            *ngIf=\"results && hits.length === 0\"\n            [icon]=\"'people'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No customers Found' | translate }}\"\n            subtitle=\"{{ 'There are either no records or nothing matching your search criteria.' | translate }}\"\n            [clickable]=\"false\"\n          >\n          </e11-empty-state>\n\n          <ais-stats>\n            <ng-template let-state=\"state\">\n              <div class=\"e11-w-full e11-mb-8\" *ngIf=\"state.nbHits && searchParams.hitsPerPage && state.nbHits > searchParams.hitsPerPage\">\n                <ais-pagination></ais-pagination>\n              </div>\n            </ng-template>\n          </ais-stats>\n        </ng-template>\n      </ais-hits>\n    </div>\n  </ais-instantsearch>\n</ng-container>\n", styles: [":host ::ng-deep .ais-Pagination{text-align:center;justify-content:center;display:flex}:host ::ng-deep .ais-Pagination-item{display:inline-block}:host ::ng-deep .ais-Pagination-item a{color:#000;float:left;padding:8px 16px;text-decoration:none;transition:background-color .3s;border:1px solid #ddd;margin:10px 0}:host ::ng-deep .ais-SearchBox-form{display:flex}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit{display:none;height:30px;line-height:normal;padding:5px 10px;border-radius:2px;border:1px solid;border-left:none}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit .ais-SearchBox-submitIcon{height:15px}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-input{display:block;padding:10px;width:100%;border-radius:2px;border:1px solid}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-reset{display:none}\n"], dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6.NgAisInstantSearch, selector: "ais-instantsearch", inputs: ["config", "instanceName"], outputs: ["change"] }, { kind: "component", type: i6.NgAisHits, selector: "ais-hits", inputs: ["escapeHTML", "transformItems"] }, { kind: "component", type: i6.NgAisSearchBox, selector: "ais-search-box", inputs: ["placeholder", "submitTitle", "resetTitle", "searchAsYouType", "autofocus", "showLoadingIndicator"], outputs: ["submit", "reset", "change", "focus", "blur"] }, { kind: "component", type: i6.NgAisPagination, selector: "ais-pagination", inputs: ["showFirst", "showLast", "showPrevious", "showNext", "padding", "totalPages"] }, { kind: "component", type: i6.NgAisStats, selector: "ais-stats" }, { kind: "component", type: i6.NgAisConfigure, selector: "ais-configure", inputs: ["searchParameters"] }, { kind: "component", type: i7$1.RefreshComponent, selector: "search-refresh" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SearchAllCustomersComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-customer-search-all', template: "<e11-loader-dots *ngIf=\"!config\" [color]=\"'e11-bg-skin-primary-accent'\" label=\"{{ 'Retrieving customers...' | translate }}\"></e11-loader-dots>\n\n<ng-container *ngIf=\"config\">\n  <ais-instantsearch #instantSearch [config]=\"config\">\n    <ais-configure [searchParameters]=\"searchParams\"></ais-configure>\n    <search-refresh #searchRefresh></search-refresh>\n    <div class=\"e11-w-full e11-mb-16\">\n      <ais-hits>\n        <ng-template let-hits=\"hits\" let-results=\"results\">\n          <!-- Filter / Search / CTA -->\n          <div class=\"e11-w-full e11-block md:e11-flex e11-mb-8\">\n            <div class=\"e11-grow md:e11-mr-6\">\n              <div class=\"e11-max-w-lg\">\n                <ais-search-box\n                  placeholder=\"{{ 'Search Customers' | translate }}\"\n                  submitTitle=\"string\"\n                  resetTitle=\"string\"\n                  [searchAsYouType]=\"true\"\n                ></ais-search-box>\n\n                <!-- Results count -->\n                <div *ngIf=\"results\" class=\"e11-flex e11-w-full e11-mb-2 e11-text-xs e11-text-skin-light e11-justify-end\">\n                  <ais-stats>\n                    <ng-template let-state=\"state\">\n                      {{ state.nbHits }} {{ state.nbHits === 1 ? \"record found.\" : (\"records found.\" | translate) }}\n                    </ng-template>\n                  </ais-stats>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <ng-container *ngIf=\"results && hits.length\">\n            <div class=\"e11-grid e11-grid-cols-6 e11-w-full e11-px-4 e11-py-4 e11-text-sm md:e11-text-base e11-border-b e11-border-skin-app-borders\">\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"Name\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"Phone\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"City\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"State\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"Tenant Customer\" | translate }}\n              </div>\n              <div class=\"e11-font-primary-demibold e11-w-fit\">\n                {{ \"Disabled\" | translate }}\n              </div>\n            </div>\n\n            <div\n              class=\"e11-grid e11-grid-cols-6 e11-w-full e11-text-sm md:e11-text-base e11-px-4 e11-py-4 e11-border-b e11-border-skin-app-borders e11-transition e11-duration-200 e11-ease-in-out e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 odd:e11-bg-skin-grey/10\"\n              *ngFor=\"let customer of hits; let i = index\"\n              (click)=\"select(customer)\"\n            >\n              <div class=\"e11-truncate\">{{ customer.name }}</div>\n              <div class=\"e11-truncate\">{{ customer.phone }}</div>\n              <div class=\"e11-truncate\">{{ customer.city }}</div>\n              <div class=\"e11-truncate\">{{ customer.state }}</div>\n              <div class=\"e11-truncate\">\n                <div *ngIf=\"customer.isTenantCustomer\">{{ \"Y\" | translate }}</div>\n                <div *ngIf=\"!customer.isTenantCustomer\">{{ \"-\" }}</div>\n              </div>\n\n              <div class=\"e11-truncate\">\n                <div *ngIf=\"customer.isDisabled\">{{ \"Y\" | translate }}</div>\n                <div *ngIf=\"!customer.isDisabled\">{{ \"-\" }}</div>\n              </div>\n            </div>\n          </ng-container>\n\n          <!-- Empty State / NOT clickable -->\n          <e11-empty-state\n            *ngIf=\"results && hits.length === 0\"\n            [icon]=\"'people'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No customers Found' | translate }}\"\n            subtitle=\"{{ 'There are either no records or nothing matching your search criteria.' | translate }}\"\n            [clickable]=\"false\"\n          >\n          </e11-empty-state>\n\n          <ais-stats>\n            <ng-template let-state=\"state\">\n              <div class=\"e11-w-full e11-mb-8\" *ngIf=\"state.nbHits && searchParams.hitsPerPage && state.nbHits > searchParams.hitsPerPage\">\n                <ais-pagination></ais-pagination>\n              </div>\n            </ng-template>\n          </ais-stats>\n        </ng-template>\n      </ais-hits>\n    </div>\n  </ais-instantsearch>\n</ng-container>\n", styles: [":host ::ng-deep .ais-Pagination{text-align:center;justify-content:center;display:flex}:host ::ng-deep .ais-Pagination-item{display:inline-block}:host ::ng-deep .ais-Pagination-item a{color:#000;float:left;padding:8px 16px;text-decoration:none;transition:background-color .3s;border:1px solid #ddd;margin:10px 0}:host ::ng-deep .ais-SearchBox-form{display:flex}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit{display:none;height:30px;line-height:normal;padding:5px 10px;border-radius:2px;border:1px solid;border-left:none}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit .ais-SearchBox-submitIcon{height:15px}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-input{display:block;padding:10px;width:100%;border-radius:2px;border:1px solid}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-reset{display:none}\n"] }]
        }], ctorParameters: () => [{ type: PlatformAdminSearchKeyService }, { type: i1$3.E11Logger }], propDecorators: { customerType: [{
                type: Input
            }], customerSelected: [{
                type: Output
            }] } });

class CustomerListHeaderComponent {
    constructor() {
        this.disabled = false;
        this.disabledText = EDIT_CLIENT_PERMISSION_MISSING;
        this.addClicked = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerListHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: { headerText: "headerText", buttonText: "buttonText", disabled: "disabled", disabledText: "disabledText" }, outputs: { addClicked: "addClicked" }, ngImport: i0, template: `
    <div class="e11-flex e11-w-full e11-mb-6 e11-gap-2 e11-flex-col lg:e11-flex-row">
      <div class="e11-grow">
        <h3>{{ headerText | translate }}</h3>
      </div>
      <div class="e11-flex lg:e11-justify-end ">
        <e11-button
          color="primary-accent"
          [disabled]="disabled"
          [disabledText]="disabledText"
          [size]="'sm'"
          [icon]="'add'"
          [iconPosition]="'left'"
          [iconSize]="'md-18'"
          value="{{ buttonText | translate }}"
          (click)="addClicked.emit()"
        >
        </e11-button>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerListHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-list-header',
                    template: `
    <div class="e11-flex e11-w-full e11-mb-6 e11-gap-2 e11-flex-col lg:e11-flex-row">
      <div class="e11-grow">
        <h3>{{ headerText | translate }}</h3>
      </div>
      <div class="e11-flex lg:e11-justify-end ">
        <e11-button
          color="primary-accent"
          [disabled]="disabled"
          [disabledText]="disabledText"
          [size]="'sm'"
          [icon]="'add'"
          [iconPosition]="'left'"
          [iconSize]="'md-18'"
          value="{{ buttonText | translate }}"
          (click)="addClicked.emit()"
        >
        </e11-button>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { headerText: [{
                type: Input
            }], buttonText: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], addClicked: [{
                type: Output
            }] } });

const ImportExportModules$1 = [
    E11EmptyStateModule,
    E11ButtonModule,
    E11ConfirmationModule,
    E11SwitchModule,
    E11PanelModule,
    E11LoaderDotsModule,
    E11SelectModule,
    E11InputModule,
    E11ImageCropperModuleModule,
    E11AvatarModule,
    E11MultiSelectModule,
    E11SelectModule,
    E11ModalModule,
    E11AutocompleteModule,
    E11PhoneNumberModule,
    E11DynamicFormModule,
    E11DividerModule,
    E11InputErrorsModule,
    E11ImageModule,
    E11NavLeftModule,
    E11NavItemComponent,
    E11InputLabelModule,
];
class UiComponentLibraryModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, imports: [CommonModule, E11EmptyStateModule,
            E11ButtonModule,
            E11ConfirmationModule,
            E11SwitchModule,
            E11PanelModule,
            E11LoaderDotsModule,
            E11SelectModule,
            E11InputModule,
            E11ImageCropperModuleModule,
            E11AvatarModule,
            E11MultiSelectModule,
            E11SelectModule,
            E11ModalModule,
            E11AutocompleteModule,
            E11PhoneNumberModule,
            E11DynamicFormModule,
            E11DividerModule,
            E11InputErrorsModule,
            E11ImageModule,
            E11NavLeftModule,
            E11NavItemComponent,
            E11InputLabelModule], exports: [E11EmptyStateModule,
            E11ButtonModule,
            E11ConfirmationModule,
            E11SwitchModule,
            E11PanelModule,
            E11LoaderDotsModule,
            E11SelectModule,
            E11InputModule,
            E11ImageCropperModuleModule,
            E11AvatarModule,
            E11MultiSelectModule,
            E11SelectModule,
            E11ModalModule,
            E11AutocompleteModule,
            E11PhoneNumberModule,
            E11DynamicFormModule,
            E11DividerModule,
            E11InputErrorsModule,
            E11ImageModule,
            E11NavLeftModule,
            E11NavItemComponent,
            E11InputLabelModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, imports: [CommonModule, ImportExportModules$1, E11EmptyStateModule,
            E11ButtonModule,
            E11ConfirmationModule,
            E11SwitchModule,
            E11PanelModule,
            E11LoaderDotsModule,
            E11SelectModule,
            E11InputModule,
            E11ImageCropperModuleModule,
            E11AvatarModule,
            E11MultiSelectModule,
            E11SelectModule,
            E11ModalModule,
            E11AutocompleteModule,
            E11PhoneNumberModule,
            E11DynamicFormModule,
            E11DividerModule,
            E11InputErrorsModule,
            E11ImageModule,
            E11NavLeftModule,
            E11InputLabelModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: UiComponentLibraryModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule, ...ImportExportModules$1],
                    exports: [...ImportExportModules$1],
                }]
        }] });

const DeclareExportComponents$5 = [CustomerListHeaderComponent];
const ImportExportModules = [
    UiComponentLibraryModule,
    TranslateModule,
    WebUtilityModule,
    LetDirective,
    ReactiveFormsModule,
    E11NavLeftModule,
    E11CardModule,
    E11TooltipModule,
    E11TabsModule,
];
class SharedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: SharedModule, declarations: [CustomerListHeaderComponent], imports: [CommonModule, UiComponentLibraryModule,
            TranslateModule,
            WebUtilityModule,
            LetDirective,
            ReactiveFormsModule,
            E11NavLeftModule,
            E11CardModule,
            E11TooltipModule,
            E11TabsModule], exports: [UiComponentLibraryModule,
            TranslateModule,
            WebUtilityModule,
            LetDirective,
            ReactiveFormsModule,
            E11NavLeftModule,
            E11CardModule,
            E11TooltipModule,
            E11TabsModule, CustomerListHeaderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SharedModule, imports: [CommonModule, UiComponentLibraryModule,
            TranslateModule,
            WebUtilityModule,
            ReactiveFormsModule,
            E11NavLeftModule,
            E11CardModule,
            E11TooltipModule,
            E11TabsModule,
            UiComponentLibraryModule,
            TranslateModule,
            WebUtilityModule,
            ReactiveFormsModule,
            E11NavLeftModule,
            E11CardModule,
            E11TooltipModule,
            E11TabsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DeclareExportComponents$5],
                    imports: [CommonModule, ...ImportExportModules],
                    exports: [...ImportExportModules, ...DeclareExportComponents$5],
                }]
        }] });

class ContactFormComponent {
    set currentContact(contact) {
        this._currentContact = contact;
    }
    set locations(locations) {
        this.fieldGroups = this.#buildContactForm(locations);
    }
    constructor(logger, configProvider) {
        this.logger = logger;
        this.configProvider = configProvider;
        this.fieldGroups = this.#buildContactForm();
        this.contactTypes = this.configProvider.config.contactTypeOptions;
        this.cancelled = new EventEmitter();
        this.deleteClicked = new EventEmitter();
        this.addContact = new EventEmitter();
        this.updateContact = new EventEmitter();
        this.deleteContact = new EventEmitter();
        this.confirmationMessage = 'Are you sure you want to delete this contact? This cannot be undone.';
    }
    confirmationAnswer(confirmed) {
        if (!confirmed)
            return;
        this.deleteContact.emit(this._currentContact.id);
    }
    onSubmit(submittedContact) {
        const contact = { ...this._currentContact, ...submittedContact };
        this.logger.log({ contact });
        if (contact.id)
            this.updateContact.emit(contact);
        else
            this.addContact.emit(contact);
    }
    cancelClicked() {
        this.contactFormBuilder.reset(this._currentContact);
        this.cancelled.emit();
    }
    #buildContactForm(locations) {
        const locationOptions = locations?.map((l) => ({ name: l.name, value: l.id })) ?? [];
        return e11FormFor()([
            e11FormLayoutInlineGrid([
                e11FieldInputText('firstName', 'First Name', undefined, {
                    validatorOrOpts: [Validators.required, E11FormValidator.minLengthAlphanumeric(1)],
                }),
                e11FieldInputText('lastName', 'Last Name', undefined, {
                    validatorOrOpts: [Validators.required, E11FormValidator.minLengthAlphanumeric(1)],
                }),
            ]),
            e11FormLayoutInline3Grid([
                e11FieldInputText('phoneNumber', 'Phone Number', undefined),
                e11FieldInputText('email', 'Email', undefined),
                e11FieldInputSelect('contactType', 'Contact Type', this.contactTypes ?? defaultContactTypes, undefined, {
                    validatorOrOpts: [Validators.required],
                }),
            ]),
            e11FormLayoutInlineGrid([e11FieldInputSelect('locationId', 'Location', locationOptions)]),
        ]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ContactFormComponent, deps: [{ token: i1$3.E11Logger }, { token: BaseCustomerConfigProvider }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ContactFormComponent, selector: "sdk-contact-form", inputs: { currentContact: "currentContact", locations: "locations" }, outputs: { cancelled: "cancelled", deleteClicked: "deleteClicked", addContact: "addContact", updateContact: "updateContact", deleteContact: "deleteContact" }, viewQueries: [{ propertyName: "contactFormBuilder", first: true, predicate: ["contactFormBuilder"], descendants: true }], ngImport: i0, template: `
    <div class="e11-md:flex">
      <e11-dynamic-form-builder
        #contactFormBuilder
        [initialValue]="_currentContact"
        [fieldGroups]="fieldGroups"
        [submitButtonTitle]="'Save' | translate"
        [showCancelButton]="true"
        [showDeleteButton]="!!_currentContact"
        (onSubmit)="onSubmit($event)"
        (onCancel)="cancelClicked()"
        (onDelete)="deleteConfirmation.open()"
      ></e11-dynamic-form-builder>
    </div>

    <e11-confirmation
      #deleteConfirmation
      confirmTitle="{{ 'Delete Contact' | translate }}"
      confirmText="{{ 'Delete' | translate }}"
      cancelText="{{ 'Cancel' | translate }}"
      [backdropStyle]="'dark'"
      (answer)="confirmationAnswer($event)"
    >
      <div [innerHTML]="confirmationMessage | translate"></div>
    </e11-confirmation>
  `, isInline: true, dependencies: [{ kind: "component", type: i5.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: i4$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ContactFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-contact-form',
                    template: `
    <div class="e11-md:flex">
      <e11-dynamic-form-builder
        #contactFormBuilder
        [initialValue]="_currentContact"
        [fieldGroups]="fieldGroups"
        [submitButtonTitle]="'Save' | translate"
        [showCancelButton]="true"
        [showDeleteButton]="!!_currentContact"
        (onSubmit)="onSubmit($event)"
        (onCancel)="cancelClicked()"
        (onDelete)="deleteConfirmation.open()"
      ></e11-dynamic-form-builder>
    </div>

    <e11-confirmation
      #deleteConfirmation
      confirmTitle="{{ 'Delete Contact' | translate }}"
      confirmText="{{ 'Delete' | translate }}"
      cancelText="{{ 'Cancel' | translate }}"
      [backdropStyle]="'dark'"
      (answer)="confirmationAnswer($event)"
    >
      <div [innerHTML]="confirmationMessage | translate"></div>
    </e11-confirmation>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$3.E11Logger }, { type: BaseCustomerConfigProvider }], propDecorators: { contactFormBuilder: [{
                type: ViewChild,
                args: ['contactFormBuilder']
            }], currentContact: [{
                type: Input
            }], locations: [{
                type: Input
            }], cancelled: [{
                type: Output
            }], deleteClicked: [{
                type: Output
            }], addContact: [{
                type: Output
            }], updateContact: [{
                type: Output
            }], deleteContact: [{
                type: Output
            }] } });

class ContactListComponent {
    constructor() {
        this.disabled = false;
        this.disabledText = EDIT_PERMISSION_MISSING;
        this.contactClicked = new EventEmitter();
        this.addContactClicked = new EventEmitter();
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ContactListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ContactListComponent, selector: "sdk-contact-list", inputs: { contacts: "contacts", disabled: "disabled", disabledText: "disabledText" }, outputs: { contactClicked: "contactClicked", addContactClicked: "addContactClicked" }, ngImport: i0, template: `
    <div class="e11-flex">
      <div class="e11-w-full">
        <div
          class="e11-hidden md:e11-flex e11-font-bold e11-text-sm e11-border-b e11-border-skin-app-borders"
          [ngClass]="{ 'e11-mb-8': !contacts?.length }"
        >
          <div class="e11-w-1/4 e11-mb-2">{{ 'First Name' | translate }}</div>
          <div class="e11-w-1/4 e11-mb-2">{{ 'Last Name' | translate }}</div>
          <div class="e11-w-1/4 e11-mb-2">{{ 'Phone Number' | translate }}</div>
          <div class="e11-w-1/4 e11-mb-2 e11-text-center">{{ 'Edit' | translate }}</div>
        </div>

        <div *ngIf="contacts && contacts.length; else emptyState">
          <div
            class="e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent odd:e11-bg-skin-grey/10"
            *ngFor="let contact of contacts"
            (click)="contactClicked.emit(contact)"
          >
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/4 e11-pl-0 md:e11-pl-2">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">
                {{ 'First Name' | translate }}</span
              >
              <span class="e11-w-3/4 md:e11-grow e11-line-clamp-1">{{ contact.firstName }} </span>
            </div>
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/4">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Last Name' | translate
              }}</span>
              <span class="e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1">{{ contact.lastName }}</span>
            </div>

            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/4 e11-text-left">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Phone Number' | translate
              }}</span>
              <span class="e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1">{{ contact.phoneNumber }}</span>
            </div>
            <div
              class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/4 e11-text-left md:e11-text-center"
            >
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Edit' | translate
              }}</span>
              <span class="e11-block e11-text-center material-icons-outlined e11-text-skin-primary-accent"> edit </span>
            </div>
          </div>
        </div>

        <ng-template #emptyState>
          <e11-empty-state
            [icon]="''"
            [border]="'solid'"
            [title]="'No Contacts'"
            [subtitle]="'It appears that there are no contacts entered yet.'"
            [clickable]="!disabled"
            (click)="!disabled ? addContactClicked.emit() : null"
          ></e11-empty-state>
        </ng-template>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ContactListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-contact-list',
                    template: `
    <div class="e11-flex">
      <div class="e11-w-full">
        <div
          class="e11-hidden md:e11-flex e11-font-bold e11-text-sm e11-border-b e11-border-skin-app-borders"
          [ngClass]="{ 'e11-mb-8': !contacts?.length }"
        >
          <div class="e11-w-1/4 e11-mb-2">{{ 'First Name' | translate }}</div>
          <div class="e11-w-1/4 e11-mb-2">{{ 'Last Name' | translate }}</div>
          <div class="e11-w-1/4 e11-mb-2">{{ 'Phone Number' | translate }}</div>
          <div class="e11-w-1/4 e11-mb-2 e11-text-center">{{ 'Edit' | translate }}</div>
        </div>

        <div *ngIf="contacts && contacts.length; else emptyState">
          <div
            class="e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent odd:e11-bg-skin-grey/10"
            *ngFor="let contact of contacts"
            (click)="contactClicked.emit(contact)"
          >
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/4 e11-pl-0 md:e11-pl-2">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">
                {{ 'First Name' | translate }}</span
              >
              <span class="e11-w-3/4 md:e11-grow e11-line-clamp-1">{{ contact.firstName }} </span>
            </div>
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/4">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Last Name' | translate
              }}</span>
              <span class="e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1">{{ contact.lastName }}</span>
            </div>

            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/4 e11-text-left">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Phone Number' | translate
              }}</span>
              <span class="e11-w-3/4 md:e11-w-full md:e11-grow e11-line-clamp-1">{{ contact.phoneNumber }}</span>
            </div>
            <div
              class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-1/4 e11-text-left md:e11-text-center"
            >
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Edit' | translate
              }}</span>
              <span class="e11-block e11-text-center material-icons-outlined e11-text-skin-primary-accent"> edit </span>
            </div>
          </div>
        </div>

        <ng-template #emptyState>
          <e11-empty-state
            [icon]="''"
            [border]="'solid'"
            [title]="'No Contacts'"
            [subtitle]="'It appears that there are no contacts entered yet.'"
            [clickable]="!disabled"
            (click)="!disabled ? addContactClicked.emit() : null"
          ></e11-empty-state>
        </ng-template>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { contacts: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], contactClicked: [{
                type: Output
            }], addContactClicked: [{
                type: Output
            }] } });

class FormDepartmentDetailComponent {
    set department(department) {
        this._department = department;
        this.departmentActive = department?.active ?? this.departmentActive;
    }
    constructor(scrollLockService, logger) {
        this.scrollLockService = scrollLockService;
        this.logger = logger;
        this.confirmationMessage = 'Are you absolutely sure you want to delete this department? This cannot be undone.';
        this.formDepartmentSubmitted = false;
        this.departmentActive = true;
        this.activeInfo = defaultDepartmentActiveInfo;
        this.fieldGroups = e11FormFor()([
            e11FormLayoutInlineGrid([
                e11FieldInputText('name', 'Department Name', undefined, {
                    validatorOrOpts: [Validators.required, E11FormValidator.whitespaceValidator(), E11FormValidator.minLengthAlphanumeric(1)],
                }),
            ]),
            e11FormLayoutInlineGrid([e11FieldInputText('internalCode', 'Internal Code', undefined)]),
        ]);
        this.departmentAdded = new EventEmitter();
        this.departmentUpdated = new EventEmitter();
        this.cancelled = new EventEmitter();
    }
    ngOnInit() { }
    onSubmit(submittedDepartment) {
        const department = { ...this._department, ...submittedDepartment, active: this.departmentActive };
        this.logger.log({ department });
        if (department.id)
            this.departmentUpdated.emit(department);
        else
            this.departmentAdded.emit(department);
    }
    cancelClicked() {
        this.departmentFormBuilder.reset(this._department);
        this.cancelled.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormDepartmentDetailComponent, deps: [{ token: i1$1.UiScrollLockingService }, { token: i1$3.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: FormDepartmentDetailComponent, selector: "sdk-form-department", inputs: { activeInfo: "activeInfo", department: "department" }, outputs: { departmentAdded: "departmentAdded", departmentUpdated: "departmentUpdated", cancelled: "cancelled" }, viewQueries: [{ propertyName: "departmentFormBuilder", first: true, predicate: ["departmentFormBuilder"], descendants: true }, { propertyName: "confirmation", first: true, predicate: ["confirmation"], descendants: true }], ngImport: i0, template: `
    <div class="e11-grid e11-grid-cols-1 md:e11-grid-cols-2 e11-gap-8 e11-mb-8">
      <e11-dynamic-form-builder
        #departmentFormBuilder
        [initialValue]="_department"
        [fieldGroups]="fieldGroups"
        [submitButtonTitle]="'Save Department' | translate"
        [hideSubmitMenu]="true"
        (onSubmit)="onSubmit($event)"
        (onCancel)="cancelled.emit()"
      ></e11-dynamic-form-builder>
      <div>
        <div class="e11-w-full">
          <div class="e11-w-full e11-flex e11-items-center e11-pt-4 e11-mb-2">
            <div class="e11-grow e11-flex e11-items-center">
              <h3 class="e11-mb-0 e11-float-left e11-mr-4">{{ 'Status' | translate }}</h3>
              <e11-switch size="xs" [checked]="departmentActive" (changes)="departmentActive = $event"></e11-switch>
            </div>
            <div class="e11-grow e11-flex e11-justify-end"></div>
          </div>

          <div class="e11-w-full e11-flex">
            <p>
              {{ activeInfo | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="e11-w-full e11-flex e11-items-center e11-justify-end e11-mb-8">
      <e11-button
        id="department_cancel"
        value="{{ 'Cancel' | translate }}"
        color="neutral"
        [ghost]="true"
        [type]="'button'"
        [buttonGroup]="true"
        tabindex="4"
        (click)="cancelClicked()"
      >
      </e11-button>
      <e11-button
        id="submit_department"
        value="{{ 'Save' | translate }}"
        color="primary-accent"
        [type]="'submit'"
        tabindex="5"
        (click)="departmentFormBuilder.onSubmitClick()"
      ></e11-button>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i9.E11SwitchComponent, selector: "e11-switch", inputs: ["id", "size", "color", "label", "containerClassOverrides", "containerClass", "disabled", "disabledText", "checked", "loading", "spinnerLoading"], outputs: ["changes", "onChange", "changeEvent", "OnchangeEvent"] }, { kind: "component", type: i4$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormDepartmentDetailComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-form-department',
                    template: `
    <div class="e11-grid e11-grid-cols-1 md:e11-grid-cols-2 e11-gap-8 e11-mb-8">
      <e11-dynamic-form-builder
        #departmentFormBuilder
        [initialValue]="_department"
        [fieldGroups]="fieldGroups"
        [submitButtonTitle]="'Save Department' | translate"
        [hideSubmitMenu]="true"
        (onSubmit)="onSubmit($event)"
        (onCancel)="cancelled.emit()"
      ></e11-dynamic-form-builder>
      <div>
        <div class="e11-w-full">
          <div class="e11-w-full e11-flex e11-items-center e11-pt-4 e11-mb-2">
            <div class="e11-grow e11-flex e11-items-center">
              <h3 class="e11-mb-0 e11-float-left e11-mr-4">{{ 'Status' | translate }}</h3>
              <e11-switch size="xs" [checked]="departmentActive" (changes)="departmentActive = $event"></e11-switch>
            </div>
            <div class="e11-grow e11-flex e11-justify-end"></div>
          </div>

          <div class="e11-w-full e11-flex">
            <p>
              {{ activeInfo | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="e11-w-full e11-flex e11-items-center e11-justify-end e11-mb-8">
      <e11-button
        id="department_cancel"
        value="{{ 'Cancel' | translate }}"
        color="neutral"
        [ghost]="true"
        [type]="'button'"
        [buttonGroup]="true"
        tabindex="4"
        (click)="cancelClicked()"
      >
      </e11-button>
      <e11-button
        id="submit_department"
        value="{{ 'Save' | translate }}"
        color="primary-accent"
        [type]="'submit'"
        tabindex="5"
        (click)="departmentFormBuilder.onSubmitClick()"
      ></e11-button>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$1.UiScrollLockingService }, { type: i1$3.E11Logger }], propDecorators: { departmentFormBuilder: [{
                type: ViewChild,
                args: ['departmentFormBuilder']
            }], confirmation: [{
                type: ViewChild,
                args: ['confirmation']
            }], activeInfo: [{
                type: Input
            }], department: [{
                type: Input
            }], departmentAdded: [{
                type: Output
            }], departmentUpdated: [{
                type: Output
            }], cancelled: [{
                type: Output
            }] } });

class CompanyDepartmentsListComponent {
    constructor() {
        this.disabled = false;
        this.disabledText = EDIT_PERMISSION_MISSING;
        this.departmentSelected = new EventEmitter();
        this.addDepartmentClicked = new EventEmitter();
    }
    ngOnInit() { }
    selected(department) {
        this.departmentSelected.emit(department);
    }
    addClicked() {
        this.addDepartmentClicked.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyDepartmentsListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CompanyDepartmentsListComponent, selector: "sdk-department-list", inputs: { departments: "departments", disabled: "disabled", disabledText: "disabledText" }, outputs: { departmentSelected: "departmentSelected", addDepartmentClicked: "addDepartmentClicked" }, ngImport: i0, template: `
    <div class="e11-flex">
      <div class="e11-w-full">
        <div
          class="e11-hidden md:e11-flex e11-font-bold e11-text-sm e11-border-b e11-border-skin-app-borders e11-pb-2"
          [ngClass]="{ 'e11-mb-8': !departments?.length }"
        >
          <div class="e11-w-6/12">{{ 'Name' | translate }}</div>
          <div class="e11-w-2/12">{{ 'Code' | translate }}</div>
          <div class="e11-w-2/12 e11-flex e11-text-left md:e11-justify-center">{{ 'Active' | translate }}</div>
          <div class="e11-w-2/12 e11-flex e11-text-left md:e11-justify-center">{{ 'Edit' | translate }}</div>
        </div>

        <div *ngIf="departments && departments.length; else emptyState">
          <div
            class="e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent odd:e11-bg-skin-grey/10"
            *ngFor="let department of departments"
            (click)="selected(department)"
          >
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-6/12 e11-pl-0 md:e11-pl-2">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Name' | translate
              }}</span>
              <span class="e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1">{{ department.name }}</span>
            </div>
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Code' | translate
              }}</span>
              <span class="e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1">{{ department.internalCode }}</span>
            </div>
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Status' | translate
              }}</span>
              <span class="e11-block e11-text-center material-icons-outlined e11-text-skin-success" *ngIf="department.active"> task_alt </span>
              <span class="e11-block e11-text-center material-icons-outlined e11-text-skin-light" *ngIf="!department.active">
                do_not_disturb_on
              </span>
            </div>
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Edit' | translate
              }}</span>
              <span class="e11-block e11-text-center material-icons-outlined e11-text-skin-primary-accent"> edit </span>
            </div>
          </div>
        </div>
        <ng-template #emptyState>
          <e11-empty-state
            [icon]="''"
            [clickable]="!disabled"
            [border]="'solid'"
            title="{{ 'No Departments' | translate }}"
            subtitle="{{ 'It appears that we do not have any company departments entered yet.' | translate }}"
            (click)="!disabled ? addClicked() : null"
          >
          </e11-empty-state>
        </ng-template>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyDepartmentsListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-department-list',
                    template: `
    <div class="e11-flex">
      <div class="e11-w-full">
        <div
          class="e11-hidden md:e11-flex e11-font-bold e11-text-sm e11-border-b e11-border-skin-app-borders e11-pb-2"
          [ngClass]="{ 'e11-mb-8': !departments?.length }"
        >
          <div class="e11-w-6/12">{{ 'Name' | translate }}</div>
          <div class="e11-w-2/12">{{ 'Code' | translate }}</div>
          <div class="e11-w-2/12 e11-flex e11-text-left md:e11-justify-center">{{ 'Active' | translate }}</div>
          <div class="e11-w-2/12 e11-flex e11-text-left md:e11-justify-center">{{ 'Edit' | translate }}</div>
        </div>

        <div *ngIf="departments && departments.length; else emptyState">
          <div
            class="e11-flex e11-rounded-lg e11-mb-4 e11-overflow-hidden e11-border e11-flex-col md:e11-border-0 md:e11-rounded-none md:e11-mb-0 md:e11-flex-row e11-items-center md:e11-py-4 e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 md:e11-border-b md:e11-border-skin-app-borders last:e11-border-b-transparent odd:e11-bg-skin-grey/10"
            *ngFor="let department of departments"
            (click)="selected(department)"
          >
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-6/12 e11-pl-0 md:e11-pl-2">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Name' | translate
              }}</span>
              <span class="e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1">{{ department.name }}</span>
            </div>
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Code' | translate
              }}</span>
              <span class="e11-w-3/4 md:e11-grow e11-pr-2 e11-line-clamp-1">{{ department.internalCode }}</span>
            </div>
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Status' | translate
              }}</span>
              <span class="e11-block e11-text-center material-icons-outlined e11-text-skin-success" *ngIf="department.active"> task_alt </span>
              <span class="e11-block e11-text-center material-icons-outlined e11-text-skin-light" *ngIf="!department.active">
                do_not_disturb_on
              </span>
            </div>
            <div class="e11-w-full e11-border-b md:e11-border-b-0 e11-flex e11-items-center md:e11-block md:e11-w-2/12 e11-text-left">
              <span class="md:e11-hidden e11-w-1/4 e11-mr-2 e11-p-2 e11-bg-skin-primary-100 e11-text-sm md:e11-text-base">{{
                'Edit' | translate
              }}</span>
              <span class="e11-block e11-text-center material-icons-outlined e11-text-skin-primary-accent"> edit </span>
            </div>
          </div>
        </div>
        <ng-template #emptyState>
          <e11-empty-state
            [icon]="''"
            [clickable]="!disabled"
            [border]="'solid'"
            title="{{ 'No Departments' | translate }}"
            subtitle="{{ 'It appears that we do not have any company departments entered yet.' | translate }}"
            (click)="!disabled ? addClicked() : null"
          >
          </e11-empty-state>
        </ng-template>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { departments: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], departmentSelected: [{
                type: Output
            }], addDepartmentClicked: [{
                type: Output
            }] } });

class CultureIndexService {
    constructor(configProvider, errorHandler, logger) {
        this.configProvider = configProvider;
        this.errorHandler = errorHandler;
        this.logger = logger;
        this.restClient = new RestApiClient({
            baseUrl: this.configProvider.config.baseUrl,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
            throwNon200s: true,
        });
    }
    getCompanyDetail(companyCode) {
        return this.restClient.get(`/culture-index/companies/${companyCode}`, { version: '1' }).pipe(map$1((res) => res.data), tapResponse((response) => {
            this.logger.log('CultureIndexService.getCompanyDetail:', response);
        }, (error) => {
            this.errorHandler.handleError(error, { alertUser: true });
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CultureIndexService, deps: [{ token: CultureIndexConfigProvider }, { token: i1$3.E11ErrorHandlerService }, { token: i1$3.E11Logger }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CultureIndexService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CultureIndexService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CultureIndexConfigProvider }, { type: i1$3.E11ErrorHandlerService }, { type: i1$3.E11Logger }] });

const templateKeys = {
    companyInfo: 'companyInfo',
    address: 'address',
    businessInfo: 'businessInfo',
    security: 'security',
    sessionTimeout: 'sessionTimeout',
    registrationSettings: 'registrationSettings',
    registrationDomains: 'registrationDomains',
    checkCompanyCode: 'checkCompanyCode',
};
class FormCompanyDetailComponent {
    set business(business) {
        this._business = business;
        const registrationDomains = this.domainsArrayToString(business?.registrationSettings?.registrationDomains);
        this._formInitialValue = {
            ...business,
            ...business?.registrationSettings,
            registrationDomains,
        };
    }
    constructor(addressFormService, permissionStore, roleDisplayService, cxService) {
        this.addressFormService = addressFormService;
        this.permissionStore = permissionStore;
        this.roleDisplayService = roleDisplayService;
        this.cxService = cxService;
        this.templateKeys = templateKeys;
        this.authTimeoutOptions = [
            { value: null, name: 'Never' },
            { value: toSeconds(5), name: '5 minutes' },
            { value: toSeconds(10), name: '10 minutes' },
            { value: toSeconds(15), name: '15 minutes' },
            { value: toSeconds(30), name: '30 minutes' },
            { value: toSeconds(60), name: '1 hour' },
        ];
        this.canAddExternalId$ = this.permissionStore.hasPermission(CustomerPermissions.AddExternalId);
        this.canRequireBusinessSize$ = this.permissionStore.hasPermission(CustomerPermissions.RequireBusinessSize);
        this.permissions$ = this.permissionStore.userPermissions$;
        this.availableRoles$ = this.roleDisplayService.availableRoleSelectOptions$;
        this.companyDetailGroups$ = combineLatest([this.permissions$, this.availableRoles$]).pipe(map$1(([permissions, availableRoles]) => this.buildCompanyDetailForm(permissions, availableRoles ?? [])));
        this.loading = false;
        this.loadingSubmit = false;
        this.cancelText = 'Cancel';
        this.disabled = false;
        this.disabledText = EDIT_PERMISSION_MISSING;
        this.isClient = false;
        this.companyAdded = new EventEmitter();
        this.companyUpdated = new EventEmitter();
        this.cancelled = new EventEmitter();
        this.companyDetailLoading = false;
    }
    ngAfterViewInit() {
        this.addressFormService.init(this.companyDetailForm);
        E11InputErrorMappingService.addErrorMessages({
            invalidDomain: '{{value}} is not a valid domain',
            blockedDomain: '{{value}} is not permitted for self-serve registration - use your company domain instead',
        });
    }
    buildCompanyDetailForm(permissions, availableRoles) {
        const canAddExternalId = permissions?.has(CustomerPermissions.AddExternalId) ?? false;
        const canRequireBusinessSize = permissions?.has(CustomerPermissions.RequireBusinessSize) ?? false;
        const canEditRegistrationSettings = permissions?.has(CustomerPermissions.EditRegistrationSettings) ?? false;
        const canEditAddress = (this.isClient ? permissions?.has(CustomerPermissions.EditClientAddress) : permissions?.has(CustomerPermissions.EditCustomerAddress)) ?? false;
        const canEditSecurity = (this.isClient ? permissions?.has(CustomerPermissions.EditClientSecurity) : permissions?.has(CustomerPermissions.EditCustomerSecurity)) ?? false;
        return e11FormFor()([
            e11LayoutGroup([
                e11FormLayoutInlineGrid([
                    e11FieldInputText('name', 'Company Name', undefined, { validatorOrOpts: [Validators.required, E11FormValidator.whitespaceValidator()] }),
                    e11FieldInputUrl('websiteURL', 'Company Website', undefined, {
                        validatorOrOpts: [Validators.pattern(URL_REGEX), E11FormValidator.whitespaceValidator()],
                    }),
                    e11FieldInputPhone('phone', 'Primary Phone', undefined, {
                        validatorOrOpts: [Validators.required, E11FormValidator.whitespaceValidator()],
                    }),
                ]),
                e11FormLayoutInline3Grid([
                    ...(canAddExternalId && this.isClient
                        ? [e11FieldInputText('externalId', 'Company Code', undefined, { validatorOrOpts: [Validators.required] })]
                        : []),
                ], canAddExternalId && this.isClient
                    ? {
                        containerClass: '!e11-justify-end e11-flex-row-reverse e11-items-center',
                        fieldsClass: '',
                        templateSpec: {
                            templateKey: templateKeys.checkCompanyCode,
                            templatePosition: 'left',
                        },
                    }
                    : {}),
            ], { templateSpec: { templateKey: templateKeys.companyInfo } }),
            e11LayoutGroup([...this.addressFormService.formGroup({ markAsRequired: true, isDisabled: !canEditAddress })], {
                templateSpec: { templateKey: templateKeys.address },
            }),
            e11FormLayoutInline3Grid([
                e11FieldInputSelect('businessSizeRange', 'Business Size', [...formSelectOptionsBusinessSizeRange], undefined, {
                    validatorOrOpts: canRequireBusinessSize && this.isClient ? [Validators.required] : [],
                }),
                e11FieldInputSelect('industryGroup', 'Industry', [...formSelectOptionsGICSIndustryGroup], undefined),
                e11FieldInputSelect('businessClassification', 'Business Type', [...formSelectOptionsBusinessType], undefined),
            ], { templateSpec: { templateKey: templateKeys.businessInfo } }),
            e11LayoutGroup([
                e11LayoutGroup([
                    e11FormLayoutFullWidth([
                        e11FieldInputSelect('sessionExpirationSeconds', '', [...this.authTimeoutOptions], null, {
                            isDisabled: !canEditSecurity,
                            extraInputOption: { selectMessage: undefined },
                        }),
                    ], { templateSpec: { templateKey: templateKeys.sessionTimeout, templatePosition: 'top' } }),
                ]),
            ], {
                layoutContainerClass: 'lg:e11-max-w-2xl e11-mb-4',
                templateSpec: { templateKey: templateKeys.security },
            }),
            ...(canEditRegistrationSettings
                ? [
                    e11LayoutGroup([
                        e11FormLayoutFullWidth([
                            e11FieldInputSwitch('allowDomainRegistration', 'Allow Domain Registration', false, {
                                extraInputOption: { size: 'xs' },
                            }),
                            e11FieldInputTextArea('registrationDomains', 'Registration Domains', undefined, {
                                validatorOrOpts: [domainsValidator],
                                extraInputOption: {
                                    placeholder: 'example.com\ncompany.org\ndomain.net',
                                    tooltipConfig: {
                                        tooltipText: 
                                        // TODO: Switch from tooltip to description
                                        'Users with emails matching these domains can self-serve register without needing to be sent an invitation. Use new lines to separate entries.',
                                    },
                                },
                            }),
                            e11FieldInputMultiSelect('domainRegistrationRoles', 'Roles', availableRoles ?? [], undefined, {
                                extraInputOption: {
                                    tooltipConfig: {
                                        tooltipText: 'Self-serve registration will grant these roles automatically.',
                                    },
                                },
                            }),
                        ]),
                    ], {
                        templateSpec: { templateKey: templateKeys.registrationSettings },
                    }),
                ]
                : []),
        ]);
    }
    submitForm(formData) {
        // formData.websiteURL || null is a hack to get around backend url validation
        const registrationSettings = {
            ...pick(this._business?.registrationSettings ?? {}, ...registrationSettingsKeys), // Do not clear registration settings if they are not present
            ...pick(formData, ...registrationSettingsKeys),
            registrationDomains: formData.registrationDomains
                ? this.domainsStringToArray(formData.registrationDomains)
                : this._business?.registrationSettings?.registrationDomains,
        };
        const companyData = {
            ...this._business,
            ...omit(formData, ...registrationSettingsKeys),
            websiteURL: formData.websiteURL || null,
            sessionExpirationSeconds: parseInt(`${formData.sessionExpirationSeconds}`) || null,
            registrationSettings,
        };
        if (companyData.id)
            this.companyUpdated.emit(companyData);
        else
            this.companyAdded.emit(companyData);
    }
    cancelClicked() {
        this.companyDetailForm.reset(this._formInitialValue);
        this.cancelled.emit();
    }
    ngOnDestroy() {
        this.addressFormService.ngOnDestroy();
    }
    domainsArrayToString(domains) {
        return domains?.join('\n') || '';
    }
    domainsStringToArray(domainsString) {
        if (!domainsString?.trim())
            return [];
        return domainsString
            .split('\n')
            .map((domain) => domain.trim())
            .filter((domain) => domain.length > 0);
    }
    async checkCompanyCode() {
        const externalId = this.companyDetailForm.form.get('externalId')?.value;
        if (!externalId) {
            this.companyDetailForm.form.get('externalId')?.setErrors({ require: true });
            return;
        }
        try {
            this.companyDetailLoading = true;
            this.companyDetailForm.loading = true;
            const cxCompanyInfo = await lastValueFrom(this.cxService.getCompanyDetail(externalId));
            if (isEmptyObject(cxCompanyInfo)) {
                this.companyDetailLoading = false;
                this.companyDetailForm.loading = false;
                return;
            }
            this.companyDetailLoading = false;
            this.companyDetailForm.loading = false;
            const currentFormValue = this.companyDetailForm.form.getRawValue();
            const companyData = {
                ...currentFormValue,
                ...cxCompanyInfo,
                businessSizeRange: cxCompanyInfo?.companySize,
            };
            this.companyDetailForm.form.patchValue(companyData);
        }
        catch (error) {
            this.companyDetailLoading = false;
            this.companyDetailForm.loading = false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCompanyDetailComponent, deps: [{ token: i1$4.AddressFormService }, { token: i3$1.PermissionStore }, { token: i3$1.RoleDisplayService }, { token: CultureIndexService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: FormCompanyDetailComponent, selector: "sdk-form-company-detail", inputs: { business: "business", loading: "loading", loadingSubmit: "loadingSubmit", cancelText: "cancelText", disabled: "disabled", disabledText: "disabledText", isClient: "isClient" }, outputs: { companyAdded: "companyAdded", companyUpdated: "companyUpdated", cancelled: "cancelled" }, providers: [AddressFormService], viewQueries: [{ propertyName: "companyDetailForm", first: true, predicate: ["companyDetailForm"], descendants: true }], ngImport: i0, template: `
    <section class="e11-mb-4">
      <e11-dynamic-form-builder
        *ngrxLet="companyDetailGroups$ as companyDetailGroups"
        #companyDetailForm
        [initialValue]="_formInitialValue"
        [fieldGroups]="companyDetailGroups"
        [hideSubmitMenu]="true"
        [loading]="loading"
        [disabled]="disabled"
        [disabledText]="disabledText"
        (onSubmit)="submitForm($event)"
        (onCancel)="cancelled.emit()"
      >
        <ng-template e11Template="{{ templateKeys.companyInfo }}">
          <h3>{{ 'Company Info' | translate }}</h3>
          <p>{{ 'Company name, website,  and other information' | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.address }}">
          <h3>{{ 'Address' | translate }}</h3>
          <p>{{ "The company's main, corporate, or headquarters location" | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.businessInfo }}">
          <h3>{{ 'Business Info' | translate }}</h3>
          <p>{{ "The company's size, industry, and type" | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.security }}">
          <h3>{{ 'Security' | translate }}</h3>
          <p>{{ "The company's security settings" | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.registrationSettings }}">
          <h3>{{ 'Registration Settings' | translate }}</h3>
          <p>{{ 'Configure registration settings for the company' | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.sessionTimeout }}">
          <e11-input-label [label]="'Session Timeout'" for="sessionExpirationSeconds"></e11-input-label>
          <p class="e11-mb-0 e11-text-xs">
            {{
              'Automatically logout user if the user is inactive for the duration specified. This is a global setting applied across all users on your account.'
                | translate
            }}
          </p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.registrationDomains }}">
          <e11-input-label [label]="'Registration Domains'" for="registrationDomains"></e11-input-label>
          <p class="e11-mb-0 e11-text-xs">
            {{
              'Users with emails matching these domains can self-serve register without needing to be sent an invitation. Use new lines to separate entries.'
                | translate
            }}
          </p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.checkCompanyCode }}">
          <e11-button
            [value]="'Check' | translate"
            [containerClassOverrides]="'e11-relative e11--top-2'"
            [color]="'primary-accent'"
            [size]="'md'"
            [buttonStyle]="'rounded'"
            [loading]="companyDetailLoading"
            [loadingText]="'Checking' | translate"
            [disabled]="companyDetailLoading"
            (click)="checkCompanyCode()"
          ></e11-button>
        </ng-template>
      </e11-dynamic-form-builder>
    </section>

    <section class="e11-mb-4">
      <div class="e11-w-full e11-flex e11-items-center e11-justify-end">
        <e11-button
          id="button_cancel"
          value="{{ cancelText | translate }}"
          color="neutral"
          [ghost]="true"
          (click)="cancelClicked()"
          [buttonGroup]="true"
        >
        </e11-button>
        <e11-button
          id="submit_account"
          value="{{ 'Save' | translate }}"
          color="primary-accent"
          [disabled]="disabled"
          [disabledText]="disabledText"
          [loading]="loadingSubmit"
          [loadingText]="'Saving' | translate"
          (click)="!loadingSubmit && companyDetailForm.onSubmitClick()"
        >
        </e11-button>
      </div>
    </section>
  `, isInline: true, dependencies: [{ kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "directive", type: i5$3.E11Template, selector: "[e11Template]", inputs: ["type", "e11Template"] }, { kind: "component", type: i4$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "component", type: i7$2.E11InputLabelComponent, selector: "e11-input-label", inputs: ["label", "id", "for", "size", "labelClassOverrides", "required", "hasError", "disabled", "darkMode", "requiredMode", "labelTextOptional", "description", "tooltipConfig"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: FormCompanyDetailComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-form-company-detail',
                    providers: [AddressFormService],
                    template: `
    <section class="e11-mb-4">
      <e11-dynamic-form-builder
        *ngrxLet="companyDetailGroups$ as companyDetailGroups"
        #companyDetailForm
        [initialValue]="_formInitialValue"
        [fieldGroups]="companyDetailGroups"
        [hideSubmitMenu]="true"
        [loading]="loading"
        [disabled]="disabled"
        [disabledText]="disabledText"
        (onSubmit)="submitForm($event)"
        (onCancel)="cancelled.emit()"
      >
        <ng-template e11Template="{{ templateKeys.companyInfo }}">
          <h3>{{ 'Company Info' | translate }}</h3>
          <p>{{ 'Company name, website,  and other information' | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.address }}">
          <h3>{{ 'Address' | translate }}</h3>
          <p>{{ "The company's main, corporate, or headquarters location" | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.businessInfo }}">
          <h3>{{ 'Business Info' | translate }}</h3>
          <p>{{ "The company's size, industry, and type" | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.security }}">
          <h3>{{ 'Security' | translate }}</h3>
          <p>{{ "The company's security settings" | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.registrationSettings }}">
          <h3>{{ 'Registration Settings' | translate }}</h3>
          <p>{{ 'Configure registration settings for the company' | translate }}</p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.sessionTimeout }}">
          <e11-input-label [label]="'Session Timeout'" for="sessionExpirationSeconds"></e11-input-label>
          <p class="e11-mb-0 e11-text-xs">
            {{
              'Automatically logout user if the user is inactive for the duration specified. This is a global setting applied across all users on your account.'
                | translate
            }}
          </p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.registrationDomains }}">
          <e11-input-label [label]="'Registration Domains'" for="registrationDomains"></e11-input-label>
          <p class="e11-mb-0 e11-text-xs">
            {{
              'Users with emails matching these domains can self-serve register without needing to be sent an invitation. Use new lines to separate entries.'
                | translate
            }}
          </p>
        </ng-template>
        <ng-template e11Template="{{ templateKeys.checkCompanyCode }}">
          <e11-button
            [value]="'Check' | translate"
            [containerClassOverrides]="'e11-relative e11--top-2'"
            [color]="'primary-accent'"
            [size]="'md'"
            [buttonStyle]="'rounded'"
            [loading]="companyDetailLoading"
            [loadingText]="'Checking' | translate"
            [disabled]="companyDetailLoading"
            (click)="checkCompanyCode()"
          ></e11-button>
        </ng-template>
      </e11-dynamic-form-builder>
    </section>

    <section class="e11-mb-4">
      <div class="e11-w-full e11-flex e11-items-center e11-justify-end">
        <e11-button
          id="button_cancel"
          value="{{ cancelText | translate }}"
          color="neutral"
          [ghost]="true"
          (click)="cancelClicked()"
          [buttonGroup]="true"
        >
        </e11-button>
        <e11-button
          id="submit_account"
          value="{{ 'Save' | translate }}"
          color="primary-accent"
          [disabled]="disabled"
          [disabledText]="disabledText"
          [loading]="loadingSubmit"
          [loadingText]="'Saving' | translate"
          (click)="!loadingSubmit && companyDetailForm.onSubmitClick()"
        >
        </e11-button>
      </div>
    </section>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$4.AddressFormService }, { type: i3$1.PermissionStore }, { type: i3$1.RoleDisplayService }, { type: CultureIndexService }], propDecorators: { companyDetailForm: [{
                type: ViewChild,
                args: ['companyDetailForm']
            }], business: [{
                type: Input
            }], loading: [{
                type: Input
            }], loadingSubmit: [{
                type: Input
            }], cancelText: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], isClient: [{
                type: Input
            }], companyAdded: [{
                type: Output
            }], companyUpdated: [{
                type: Output
            }], cancelled: [{
                type: Output
            }] } });
const toSeconds = (minutes) => minutes * 60;
// Common consumer email domains that should be blocked
const BLOCKED_DOMAINS = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'aol.com',
    'icloud.com',
    'protonmail.com',
    'yandex.com',
    'mail.com',
    'zoho.com',
    'gmx.com',
    'fastmail.com',
    'tutanota.com',
    'live.com',
    'msn.com',
    'comcast.net',
    'verizon.net',
    'att.net',
    'charter.net',
    'cox.net',
];
const domainsValidator = (control) => {
    if (!control.value || control.value.trim() === '')
        return null; // Allow empty values
    const domains = control.value
        .split('\n')
        .map((domain) => domain.trim())
        .filter((domain) => domain.length > 0);
    for (const domain of domains) {
        if (!DOMAIN_REGEX.test(domain))
            return { invalidDomain: { value: domain } };
        if (BLOCKED_DOMAINS.includes(domain))
            return { blockedDomain: { value: domain } };
    }
    return null;
};

class LocationFormComponent {
    set location(location) {
        this._location = location;
        this.locationActive = location?.active ?? this.locationActive;
    }
    constructor(addressFormService) {
        this.addressFormService = addressFormService;
        this.locationActive = true;
        this.STATE_REQUIRED_LENGTH = 2;
        this.activeInfo = defaultLocationActiveInfo;
        this.locationAdded = new EventEmitter();
        this.locationUpdated = new EventEmitter();
        this.locationDeleted = new EventEmitter();
        this.cancelled = new EventEmitter();
        this.fieldGroups = e11FormFor()([
            e11FormLayoutInlineGrid([
                e11FieldInputText('name', 'Location', undefined, {
                    validatorOrOpts: [Validators.required, E11FormValidator.whitespaceValidator(), E11FormValidator.minLengthAlphanumeric(1)],
                }),
            ]),
            e11FormLayoutInlineGrid([e11FieldInputText('secondaryName', 'Nickname'), e11FieldInputText('internalCode', 'Location Code')]),
            ...this.addressFormService.formGroup({
                validators: {
                    address: [Validators.required],
                    city: [Validators.required],
                },
            }),
            e11FormLayoutInline3Grid([
                e11FieldInputUrl('locationWebsite', 'Website', undefined, {
                    validatorOrOpts: [Validators.pattern(URL_REGEX), E11FormValidator.whitespaceValidator()],
                }),
                e11FieldInputPhone('phone', 'Phone', undefined),
                e11FieldInputPhone('fax', 'Fax', undefined),
            ]),
            e11FormLayoutInlineGrid([e11FieldInputTextArea('notes', 'Notes', undefined)]),
        ]);
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this.locationFormFn = this.addressFormService.init(this.locationFormBuilder);
    }
    ngOnDestroy() {
        if (this.locationFormFn)
            this.locationFormFn();
    }
    onSubmit(submittedLocation) {
        const location = { ...this._location, ...submittedLocation, active: this.locationActive };
        if (location.locationWebsite?.length === 0)
            location.locationWebsite = undefined;
        if (location.id)
            this.locationUpdated.emit(location);
        else
            this.locationAdded.emit(location);
    }
    cancelClicked() {
        this.locationFormBuilder.reset(this._location);
        this.cancelled.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocationFormComponent, deps: [{ token: i1$4.AddressFormService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: LocationFormComponent, selector: "sdk-form-location", inputs: { location: "location", STATE_REQUIRED_LENGTH: "STATE_REQUIRED_LENGTH", activeInfo: "activeInfo" }, outputs: { locationAdded: "locationAdded", locationUpdated: "locationUpdated", locationDeleted: "locationDeleted", cancelled: "cancelled" }, providers: [AddressFormService], viewQueries: [{ propertyName: "locationFormBuilder", first: true, predicate: ["locationFormBuilder"], descendants: true }, { propertyName: "itemTemplate", first: true, predicate: ["itemTemplate"], descendants: true }], ngImport: i0, template: `
    <div class="e11-flex e11-flex-col md:e11-flex-row e11-gap-3 e11-mb-8">
      <div class="e11-w-full">
        <e11-dynamic-form-builder
          #locationFormBuilder
          [initialValue]="_location"
          [fieldGroups]="fieldGroups"
          [hideSubmitMenu]="true"
          (onSubmit)="onSubmit($event)"
          (onCancel)="cancelled.emit()"
        ></e11-dynamic-form-builder>

        <ng-template #itemTemplate let-item>
          {{ item | json }}
          <a [innerHTML]="item.name"></a>
        </ng-template>
        <div class="e11-flex e11-items-center e11-w-full">
          <h3 class="e11-mr-2">{{ 'Status' | translate }}</h3>
          <e11-switch [size]="'xs'" [checked]="locationActive" (changes)="locationActive = $event"></e11-switch>
        </div>
        <div class="e11-w-full e11-mb-4">
          {{ activeInfo | translate }}
        </div>

        <div class="e11-flex e11-w-full e11-justify-end">
          <e11-button
            id="location_cancel"
            value="{{ 'Cancel' | translate }}"
            color="neutral"
            [type]="'button'"
            [buttonGroup]="true"
            [ghost]="true"
            (click)="cancelClicked()"
          >
          </e11-button>
          <e11-button
            id="submit_location"
            value="{{ 'Save' | translate }}"
            [color]="'primary-accent'"
            [type]="'submit'"
            (click)="locationFormBuilder.onSubmitClick()"
          >
          </e11-button>
        </div>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i9.E11SwitchComponent, selector: "e11-switch", inputs: ["id", "size", "color", "label", "containerClassOverrides", "containerClass", "disabled", "disabledText", "checked", "loading", "spinnerLoading"], outputs: ["changes", "onChange", "changeEvent", "OnchangeEvent"] }, { kind: "component", type: i4$1.E11DynamicFormBuilderComponent, selector: "e11-dynamic-form-builder", inputs: ["initialValue", "hideSubmitMenu", "loading", "disabled", "disabledText", "submitButtonConfig", "cancelButtonConfig", "deleteButtonConfig", "cancelLinkConfig", "showCancelLink", "showCancelButton", "showDeleteButton", "submitButtonTitle", "cancelLinkTitle", "cancelButtonTitle", "deleteButtonTitle", "buttonColorSubmit", "buttonColorCancel", "buttonColorDelete", "fieldGroups", "errorMessageOverrides"], outputs: ["valueChanges", "onSubmit", "onCancel", "onDelete"] }, { kind: "pipe", type: i1$2.JsonPipe, name: "json" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LocationFormComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-form-location',
                    providers: [AddressFormService],
                    template: `
    <div class="e11-flex e11-flex-col md:e11-flex-row e11-gap-3 e11-mb-8">
      <div class="e11-w-full">
        <e11-dynamic-form-builder
          #locationFormBuilder
          [initialValue]="_location"
          [fieldGroups]="fieldGroups"
          [hideSubmitMenu]="true"
          (onSubmit)="onSubmit($event)"
          (onCancel)="cancelled.emit()"
        ></e11-dynamic-form-builder>

        <ng-template #itemTemplate let-item>
          {{ item | json }}
          <a [innerHTML]="item.name"></a>
        </ng-template>
        <div class="e11-flex e11-items-center e11-w-full">
          <h3 class="e11-mr-2">{{ 'Status' | translate }}</h3>
          <e11-switch [size]="'xs'" [checked]="locationActive" (changes)="locationActive = $event"></e11-switch>
        </div>
        <div class="e11-w-full e11-mb-4">
          {{ activeInfo | translate }}
        </div>

        <div class="e11-flex e11-w-full e11-justify-end">
          <e11-button
            id="location_cancel"
            value="{{ 'Cancel' | translate }}"
            color="neutral"
            [type]="'button'"
            [buttonGroup]="true"
            [ghost]="true"
            (click)="cancelClicked()"
          >
          </e11-button>
          <e11-button
            id="submit_location"
            value="{{ 'Save' | translate }}"
            [color]="'primary-accent'"
            [type]="'submit'"
            (click)="locationFormBuilder.onSubmitClick()"
          >
          </e11-button>
        </div>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$4.AddressFormService }], propDecorators: { locationFormBuilder: [{
                type: ViewChild,
                args: ['locationFormBuilder']
            }], itemTemplate: [{
                type: ViewChild,
                args: ['itemTemplate']
            }], location: [{
                type: Input
            }], STATE_REQUIRED_LENGTH: [{
                type: Input
            }], activeInfo: [{
                type: Input
            }], locationAdded: [{
                type: Output
            }], locationUpdated: [{
                type: Output
            }], locationDeleted: [{
                type: Output
            }], cancelled: [{
                type: Output
            }] } });

class CompanyLocationCardComponent {
    constructor() {
        this.disabled = false;
        this.disabledText = EDIT_PERMISSION_MISSING;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyLocationCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CompanyLocationCardComponent, selector: "sdk-location-card", inputs: { location: "location", disabled: "disabled", disabledText: "disabledText" }, ngImport: i0, template: `
    <e11-card [height]="'165px'">
      <div class="e11-flex">
        <div class="e11-justify-start e11-grow e11-line-clamp-2">
          <p class="e11-font-bold e11-mb-2 e11-truncate e11-text-ellipsis">{{ location.name }}</p>
          <div *ngIf="location.secondaryName || location.internalCode" class="e11-flex e11-mb-2">
            <p *ngIf="location.secondaryName" [ngClass]="{ 'e11-mr-1': location.secondaryName }" class="e11-mb-0 e11-line-clamp-2">
              {{ location.secondaryName }}
            </p>
            <p *ngIf="location.internalCode" class="e11-mb-0">{{ location.internalCode }}</p>
          </div>
          <div class="e11-text-sm">
            <p *ngIf="location.address" class="e11-mb-1">{{ location.address }}</p>
            <p *ngIf="location.address2" class="e11-mb-1">{{ location.address2 }}</p>
          </div>
          <div class="e11-flex e11-text-sm">
            <sdk-maps-view-address [address]="location" [hide]="['address', 'address2']"></sdk-maps-view-address>
          </div>
        </div>
        <div class="e11-justify-end">
          <div class="e11-flex e11-justify-center">
            <span
              class="material-icons-outlined e11-text-skin-primary-accent  hover:e11-rounded-full hover:e11-cursor-pointer hover:e11-text-skin-primary"
              >edit</span
            >
            <e11-tooltip [color]="'dark'" [tooltipText]="'This location is active and available for selection.' | translate">
              <span *ngIf="location.active" class="material-icons e11-text-skin-success ">task_alt</span>
            </e11-tooltip>
            <e11-tooltip
              [color]="'dark'"
              [tooltipText]="
                'This location is disabled and is not available for selection. Re-enable this location to make it an available selection.' | translate
              "
              ><span *ngIf="!location.active" class="material-icons-outlined e11-text-skin-grey hover:e11-cursor-pointer"
                >do_not_disturb_on</span
              ></e11-tooltip
            >
          </div>
        </div>
      </div>
    </e11-card>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$4.E11CardComponent, selector: "e11-card", inputs: ["isClickable", "status", "state", "arrow", "borderDashed", "width", "height", "containerClassOverrides", "containerClass", "customStateCss", "isLoading"] }, { kind: "component", type: i3$3.E11TooltipComponent, selector: "e11-tooltip", inputs: ["tooltipText", "tooltipClassOverrides", "hideTooltip", "color", "tooltipContent", "position", "interactive", "maxWidth", "delay"], outputs: ["tooltipClick"] }, { kind: "component", type: i1$4.ViewAddressComponent, selector: "sdk-maps-view-address", inputs: ["hide", "address", "class"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyLocationCardComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-location-card',
                    template: `
    <e11-card [height]="'165px'">
      <div class="e11-flex">
        <div class="e11-justify-start e11-grow e11-line-clamp-2">
          <p class="e11-font-bold e11-mb-2 e11-truncate e11-text-ellipsis">{{ location.name }}</p>
          <div *ngIf="location.secondaryName || location.internalCode" class="e11-flex e11-mb-2">
            <p *ngIf="location.secondaryName" [ngClass]="{ 'e11-mr-1': location.secondaryName }" class="e11-mb-0 e11-line-clamp-2">
              {{ location.secondaryName }}
            </p>
            <p *ngIf="location.internalCode" class="e11-mb-0">{{ location.internalCode }}</p>
          </div>
          <div class="e11-text-sm">
            <p *ngIf="location.address" class="e11-mb-1">{{ location.address }}</p>
            <p *ngIf="location.address2" class="e11-mb-1">{{ location.address2 }}</p>
          </div>
          <div class="e11-flex e11-text-sm">
            <sdk-maps-view-address [address]="location" [hide]="['address', 'address2']"></sdk-maps-view-address>
          </div>
        </div>
        <div class="e11-justify-end">
          <div class="e11-flex e11-justify-center">
            <span
              class="material-icons-outlined e11-text-skin-primary-accent  hover:e11-rounded-full hover:e11-cursor-pointer hover:e11-text-skin-primary"
              >edit</span
            >
            <e11-tooltip [color]="'dark'" [tooltipText]="'This location is active and available for selection.' | translate">
              <span *ngIf="location.active" class="material-icons e11-text-skin-success ">task_alt</span>
            </e11-tooltip>
            <e11-tooltip
              [color]="'dark'"
              [tooltipText]="
                'This location is disabled and is not available for selection. Re-enable this location to make it an available selection.' | translate
              "
              ><span *ngIf="!location.active" class="material-icons-outlined e11-text-skin-grey hover:e11-cursor-pointer"
                >do_not_disturb_on</span
              ></e11-tooltip
            >
          </div>
        </div>
      </div>
    </e11-card>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { location: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }] } });

class CompanyLocationListComponent {
    set locations(locations) {
        this._locations = locations;
        this.originalLocations = locations;
    }
    constructor() {
        this.showSearch = false;
        this.disabled = false;
        this.disabledText = EDIT_PERMISSION_MISSING;
        this.searchForm = new FormGroup({
            search: new FormControl(''),
        });
        this.locationSelected = new EventEmitter();
        this.addLocationClicked = new EventEmitter();
    }
    select(location) {
        this.locationSelected.emit(location);
    }
    search(input) {
        if (input === '') {
            this._locations = this.originalLocations;
            return;
        }
        if (typeof input !== 'string' || !this._locations || input.length < 2)
            return;
        this._locations = filterByKeys(input, this._locations, ['name', 'address', 'address2', 'city', 'state', 'zip', 'countryCode']);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyLocationListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CompanyLocationListComponent, selector: "sdk-location-list", inputs: { showSearch: "showSearch", locations: "locations", disabled: "disabled", disabledText: "disabledText" }, outputs: { locationSelected: "locationSelected", addLocationClicked: "addLocationClicked" }, ngImport: i0, template: `
    <div *ngIf="showSearch" class="e11-mb-4 e11-w-2/5">
      <form [formGroup]="searchForm">
        <e11-input
          [parentForm]="searchForm"
          [clearIcon]="true"
          [leadingIcon]="'search'"
          [placeholder]="'Search' | translate"
          [size]="'md'"
          [type]="'text'"
          [isRounded]="true"
          borderGlow="primary"
          formControlName="search"
          id="input_searchForm"
          name="searchForm"
          (change)="search($event)"
        ></e11-input>
      </form>
    </div>

    <div *ngIf="_locations?.length; else emptyState" [ngClass]="{ 'e11-mb-8': !_locations?.length }" class="e11-mb-4">
      <div class="e11-grid e11-grid-cols-1 lg:e11-grid-cols-2 xl:e11-grid-cols-3 2xl:e11-grid-cols-4 e11-gap-4">
        <div *ngFor="let location of _locations" (click)="select(location)">
          <sdk-location-card [location]="location"></sdk-location-card>
        </div>
      </div>
    </div>

    <div class="e11-mb-6">
      <ng-template #emptyState>
        <e11-empty-state
          [title]="'No Locations'"
          [clickable]="!disabled"
          [subtitle]="'It appears that there are no locations entered yet.'"
          [icon]="''"
          [border]="'solid'"
          (click)="!disabled ? addLocationClicked.emit() : null"
        ></e11-empty-state>
      </ng-template>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: i11.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: CompanyLocationCardComponent, selector: "sdk-location-card", inputs: ["location", "disabled", "disabledText"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyLocationListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-location-list',
                    template: `
    <div *ngIf="showSearch" class="e11-mb-4 e11-w-2/5">
      <form [formGroup]="searchForm">
        <e11-input
          [parentForm]="searchForm"
          [clearIcon]="true"
          [leadingIcon]="'search'"
          [placeholder]="'Search' | translate"
          [size]="'md'"
          [type]="'text'"
          [isRounded]="true"
          borderGlow="primary"
          formControlName="search"
          id="input_searchForm"
          name="searchForm"
          (change)="search($event)"
        ></e11-input>
      </form>
    </div>

    <div *ngIf="_locations?.length; else emptyState" [ngClass]="{ 'e11-mb-8': !_locations?.length }" class="e11-mb-4">
      <div class="e11-grid e11-grid-cols-1 lg:e11-grid-cols-2 xl:e11-grid-cols-3 2xl:e11-grid-cols-4 e11-gap-4">
        <div *ngFor="let location of _locations" (click)="select(location)">
          <sdk-location-card [location]="location"></sdk-location-card>
        </div>
      </div>
    </div>

    <div class="e11-mb-6">
      <ng-template #emptyState>
        <e11-empty-state
          [title]="'No Locations'"
          [clickable]="!disabled"
          [subtitle]="'It appears that there are no locations entered yet.'"
          [icon]="''"
          [border]="'solid'"
          (click)="!disabled ? addLocationClicked.emit() : null"
        ></e11-empty-state>
      </ng-template>
    </div>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { showSearch: [{
                type: Input
            }], locations: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], locationSelected: [{
                type: Output
            }], addLocationClicked: [{
                type: Output
            }] } });

class CompanyLogoUploadModalComponent {
    constructor() {
        this.logoInfo = LOGO_DEFAULTS.logoInfo;
        this.logoUploaded = new EventEmitter();
        this.logoRemoved = new EventEmitter();
    }
    ngOnInit() { }
    imageCropped(event) {
        const extension = this.fileForImageCropper.name.split('.').pop();
        const newFilename = crypto.randomUUID() + '.' + extension;
        this.croppedImage = new File([event.file], newFilename, { type: event.file.type });
    }
    setImageToCropper(event) {
        if (event.target.files && event.target.files.length) {
            const [file] = event.target.files;
            this.fileForImageCropper = file;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyLogoUploadModalComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CompanyLogoUploadModalComponent, selector: "modal-company-logo-upload", inputs: { logoInfo: "logoInfo", logoUrl: "logoUrl" }, outputs: { logoUploaded: "logoUploaded", logoRemoved: "logoRemoved" }, ngImport: i0, template: `
    <div>
      <div class="e11-mb-5">
        <input hidden="true" type="file" id="imageUpload" accept=".png, .jpg, .jpeg, .webp" #fileInput (change)="setImageToCropper($event)" />

        <img *ngIf="logoUrl && !fileForImageCropper" [src]="logoUrl" class="e11-max-h-60 md:e11-max-h-96 e11-m-auto" />

        <e11-image-cropper
          *ngIf="fileForImageCropper"
          (imageCropped)="imageCropped($event)"
          imageContainerClassOverrides="e11-max-h-60 md:e11-max-h-96"
          [imageFile]="fileForImageCropper"
          [maintainAspectRatio]="false"
        >
        </e11-image-cropper>

        <e11-empty-state
          *ngIf="!fileForImageCropper && !logoUrl"
          [icon]="'file_upload'"
          [iconSize]="'md-36'"
          [iconType]="''"
          title="{{ 'Upload a company logo' | translate }}"
          subtitle="{{ logoInfo | translate }}"
          (click)="fileInput.click()"
        >
        </e11-empty-state>
      </div>

      <div class="e11-flex e11-flex-wrap-reverse md:e11-flex-nowrap e11-items-center e11-justify-center e11-gap-4 e11-mb-5">
        <div class="e11-w-full md:e11-w-auto" *ngIf="logoUrl && !fileForImageCropper">
          <e11-button
            class="e11-w-full"
            id="button_submit"
            value="{{ 'Delete' | translate }}"
            color="secondary"
            type="button"
            [ghost]="true"
            [icon]="'delete'"
            [iconType]="'outlined'"
            [iconSize]="'md-24'"
            [iconPosition]="'left'"
            [display]="'block'"
            (click)="logoRemoved.emit()"
          >
          </e11-button>
        </div>

        <div class="e11-w-full md:e11-w-auto">
          <e11-button
            class="e11-w-full"
            id="button_upload"
            value="{{ 'Upload' | translate }}"
            color="primary-accent"
            type="button"
            [ghost]="true"
            [icon]="'file_upload'"
            [iconType]="'outlined'"
            [iconSize]="'md-24'"
            [iconPosition]="'left'"
            (click)="fileInput.click()"
            [display]="'block'"
          >
          </e11-button>
        </div>

        <div class="e11-w-full md:e11-w-auto" *ngIf="croppedImage">
          <e11-button
            class="e11-w-full"
            id="button_save"
            value="{{ 'Save' | translate }}"
            color="primary-accent"
            type="button"
            [ghost]="false"
            [display]="'block'"
            (click)="logoUploaded.emit(croppedImage)"
          >
          </e11-button>
        </div>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i4$2.E11ImageCropperComponent, selector: "e11-image-cropper", inputs: ["imageChangedEvent", "imageURL", "imageBase64", "imageFile", "format", "maintainAspectRatio", "transform", "aspectRatio", "resizeToWidth", "resizeToHeight", "cropperMinWidth", "cropperMinHeight", "cropperStaticWidth", "cropperStaticHeight", "canvasRotation", "initialStepSize", "roundCropper", "onlyScaleDown", "imageQuality", "autoCrop", "backgroundColor", "containWithinAspectRatio", "hideResizeSquares", "imageContainerClassOverrides", "cropper", "scale", "alignImage", "disabled", "rotation"], outputs: ["imageCropped", "startCropImage", "imageLoaded", "cropperReady", "loadImageFailed"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyLogoUploadModalComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'modal-company-logo-upload',
                    template: `
    <div>
      <div class="e11-mb-5">
        <input hidden="true" type="file" id="imageUpload" accept=".png, .jpg, .jpeg, .webp" #fileInput (change)="setImageToCropper($event)" />

        <img *ngIf="logoUrl && !fileForImageCropper" [src]="logoUrl" class="e11-max-h-60 md:e11-max-h-96 e11-m-auto" />

        <e11-image-cropper
          *ngIf="fileForImageCropper"
          (imageCropped)="imageCropped($event)"
          imageContainerClassOverrides="e11-max-h-60 md:e11-max-h-96"
          [imageFile]="fileForImageCropper"
          [maintainAspectRatio]="false"
        >
        </e11-image-cropper>

        <e11-empty-state
          *ngIf="!fileForImageCropper && !logoUrl"
          [icon]="'file_upload'"
          [iconSize]="'md-36'"
          [iconType]="''"
          title="{{ 'Upload a company logo' | translate }}"
          subtitle="{{ logoInfo | translate }}"
          (click)="fileInput.click()"
        >
        </e11-empty-state>
      </div>

      <div class="e11-flex e11-flex-wrap-reverse md:e11-flex-nowrap e11-items-center e11-justify-center e11-gap-4 e11-mb-5">
        <div class="e11-w-full md:e11-w-auto" *ngIf="logoUrl && !fileForImageCropper">
          <e11-button
            class="e11-w-full"
            id="button_submit"
            value="{{ 'Delete' | translate }}"
            color="secondary"
            type="button"
            [ghost]="true"
            [icon]="'delete'"
            [iconType]="'outlined'"
            [iconSize]="'md-24'"
            [iconPosition]="'left'"
            [display]="'block'"
            (click)="logoRemoved.emit()"
          >
          </e11-button>
        </div>

        <div class="e11-w-full md:e11-w-auto">
          <e11-button
            class="e11-w-full"
            id="button_upload"
            value="{{ 'Upload' | translate }}"
            color="primary-accent"
            type="button"
            [ghost]="true"
            [icon]="'file_upload'"
            [iconType]="'outlined'"
            [iconSize]="'md-24'"
            [iconPosition]="'left'"
            (click)="fileInput.click()"
            [display]="'block'"
          >
          </e11-button>
        </div>

        <div class="e11-w-full md:e11-w-auto" *ngIf="croppedImage">
          <e11-button
            class="e11-w-full"
            id="button_save"
            value="{{ 'Save' | translate }}"
            color="primary-accent"
            type="button"
            [ghost]="false"
            [display]="'block'"
            (click)="logoUploaded.emit(croppedImage)"
          >
          </e11-button>
        </div>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [], propDecorators: { logoInfo: [{
                type: Input
            }], logoUrl: [{
                type: Input
            }], logoUploaded: [{
                type: Output
            }], logoRemoved: [{
                type: Output
            }] } });

// TODO: UX pass - replace empty state with an empty logo image
class LogoManageComponent {
    constructor(filesService, modalService, errorHandler) {
        this.filesService = filesService;
        this.modalService = modalService;
        this.errorHandler = errorHandler;
        this.headerText = LOGO_DEFAULTS.headerText;
        this.subHeaderText = LOGO_DEFAULTS.subHeaderText;
        this.logoInfo = LOGO_DEFAULTS.logoInfo; // "This logo is used many places including internal and external Job Posts, your Careers Page, and Candidate's Search Results just to name a few. Please make sure it is a .png or .jpg file no larger than 5GB."
        this.disabled = false;
        this.showHeaderTitle = true;
        this.flexDirection = 'row';
        this.deleteDurationDays = 365;
        this.logoUploaded = new EventEmitter();
        this.logoDeleted = new EventEmitter();
        this.loading = false;
    }
    ngOnInit() { }
    async upload(file) {
        if (this.customerKey) {
            this.loading = true;
            if (file) {
                await this.removeUploadedFile();
                const receipt = await this.filesService.uploadFile({
                    file,
                    makePublic: true,
                    customerKey: this.customerKey,
                    deletionDelayDays: this.deleteDurationDays,
                });
                this.logoUploaded.emit(receipt);
                this.logoUrl = receipt.url;
            }
            this.loading = false;
        }
    }
    async removeUploadedFile() {
        if (this.logoUrl) {
            this.logoDeleted.emit();
            this.logoUrl = undefined;
        }
    }
    openUploadModal(modalTemplate) {
        this.modalService.openModal({
            body: modalTemplate,
            footer: undefined,
            width: 'md',
            bodyHeight: 'auto',
            title: 'Manage company logo',
            showHeader: true,
            showFooter: false,
        });
    }
    closeModal() {
        this.modalService.closeModal();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LogoManageComponent, deps: [{ token: i1$5.FilesService }, { token: i6$1.E11ModalGlobalService }, { token: i1$3.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: LogoManageComponent, selector: "sdk-logo-manage", inputs: { logoUrl: "logoUrl", customerKey: "customerKey", headerText: "headerText", subHeaderText: "subHeaderText", logoInfo: "logoInfo", disabled: "disabled", disabledText: "disabledText", showHeaderTitle: "showHeaderTitle", flexDirection: "flexDirection", deleteDurationDays: "deleteDurationDays" }, outputs: { logoUploaded: "logoUploaded", logoDeleted: "logoDeleted" }, ngImport: i0, template: `
    <div class="e11-mb-4" *ngIf="showHeaderTitle">
      <h3>{{ headerText | translate }}</h3>
    </div>

    <div class="e11-w-full e11-block md:e11-flex md:e11-justify-center e11-gap-4" [ngClass]="{ 'e11-flex-col': flexDirection === 'column' }">
      <div class="e11-block md:e11-flex ">
        <e11-loader-dots
          *ngIf="loading || !customerKey"
          [color]="'e11-bg-skin-primary-accent'"
          [label]="'Loading logo...' | translate"
        ></e11-loader-dots>
        <div *ngIf="!loading && customerKey">
          <ng-container *ngIf="logoUrl; else noLogo">
            <div class="e11-w-full e11-border e11-border-skin-app-border e11-mb-4" id="imagePreview">
              <img class="e11-w-full e11-max-h-60" src="{{ logoUrl }}" />
            </div>
          </ng-container>

          <ng-template #noLogo>
            <div class="e11-flex e11-justify-center e11-mb-4 e11-max-h-60 e11-max-w-60">
              <e11-image [imageUrl]="logoUrl" [size]="'lg'" [shape]="'rounded'"></e11-image>
            </div>
          </ng-template>
        </div>

        <ng-template #uploadLogoModal>
          <modal-company-logo-upload
            [logoUrl]="logoUrl"
            (logoUploaded)="upload($event); closeModal()"
            (logoRemoved)="removeUploadedFile(); closeModal()"
          ></modal-company-logo-upload>
        </ng-template>
      </div>

      <div class="e11-block md:e11-flex e11-grow  ">
        <div>
          <div class="e11-max-w-xl">
            <p class="e11-font-primary-demibold e11-mb-2">{{ subHeaderText | translate }}</p>
            <p class="e11-text-sm">
              {{ logoInfo | translate }}
            </p>
          </div>
          <div class="e11-flex e11-w-full">
            <e11-button
              (click)="openUploadModal(uploadLogoModal)"
              [disabled]="disabled"
              [disabledText]="disabledText"
              [color]="'primary-accent'"
              [size]="'sm'"
              value="{{ 'Manage Logo' | translate }}"
            ></e11-button>
          </div>
        </div>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i7$3.E11ImageComponent, selector: "e11-image", inputs: ["imageUrl", "altText", "imageFit", "shape", "width", "height", "size", "background", "contentClassOverrides", "containerClassOverrides"] }, { kind: "component", type: CompanyLogoUploadModalComponent, selector: "modal-company-logo-upload", inputs: ["logoInfo", "logoUrl"], outputs: ["logoUploaded", "logoRemoved"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: LogoManageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-logo-manage',
                    template: `
    <div class="e11-mb-4" *ngIf="showHeaderTitle">
      <h3>{{ headerText | translate }}</h3>
    </div>

    <div class="e11-w-full e11-block md:e11-flex md:e11-justify-center e11-gap-4" [ngClass]="{ 'e11-flex-col': flexDirection === 'column' }">
      <div class="e11-block md:e11-flex ">
        <e11-loader-dots
          *ngIf="loading || !customerKey"
          [color]="'e11-bg-skin-primary-accent'"
          [label]="'Loading logo...' | translate"
        ></e11-loader-dots>
        <div *ngIf="!loading && customerKey">
          <ng-container *ngIf="logoUrl; else noLogo">
            <div class="e11-w-full e11-border e11-border-skin-app-border e11-mb-4" id="imagePreview">
              <img class="e11-w-full e11-max-h-60" src="{{ logoUrl }}" />
            </div>
          </ng-container>

          <ng-template #noLogo>
            <div class="e11-flex e11-justify-center e11-mb-4 e11-max-h-60 e11-max-w-60">
              <e11-image [imageUrl]="logoUrl" [size]="'lg'" [shape]="'rounded'"></e11-image>
            </div>
          </ng-template>
        </div>

        <ng-template #uploadLogoModal>
          <modal-company-logo-upload
            [logoUrl]="logoUrl"
            (logoUploaded)="upload($event); closeModal()"
            (logoRemoved)="removeUploadedFile(); closeModal()"
          ></modal-company-logo-upload>
        </ng-template>
      </div>

      <div class="e11-block md:e11-flex e11-grow  ">
        <div>
          <div class="e11-max-w-xl">
            <p class="e11-font-primary-demibold e11-mb-2">{{ subHeaderText | translate }}</p>
            <p class="e11-text-sm">
              {{ logoInfo | translate }}
            </p>
          </div>
          <div class="e11-flex e11-w-full">
            <e11-button
              (click)="openUploadModal(uploadLogoModal)"
              [disabled]="disabled"
              [disabledText]="disabledText"
              [color]="'primary-accent'"
              [size]="'sm'"
              value="{{ 'Manage Logo' | translate }}"
            ></e11-button>
          </div>
        </div>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$5.FilesService }, { type: i6$1.E11ModalGlobalService }, { type: i1$3.E11ErrorHandlerService }], propDecorators: { logoUrl: [{
                type: Input
            }], customerKey: [{
                type: Input
            }], headerText: [{
                type: Input
            }], subHeaderText: [{
                type: Input
            }], logoInfo: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], showHeaderTitle: [{
                type: Input
            }], flexDirection: [{
                type: Input
            }], deleteDurationDays: [{
                type: Input
            }], logoUploaded: [{
                type: Output
            }], logoDeleted: [{
                type: Output
            }] } });

const DeclareExportComponents$4 = [
    ContactFormComponent,
    ContactListComponent,
    FormDepartmentDetailComponent,
    CompanyDepartmentsListComponent,
    FormCompanyDetailComponent,
    LocationFormComponent,
    CompanyLocationListComponent,
    CompanyLocationCardComponent,
    CompanyLogoUploadModalComponent,
    LogoManageComponent,
];
class EditableBusinessModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EditableBusinessModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: EditableBusinessModule, declarations: [ContactFormComponent,
            ContactListComponent,
            FormDepartmentDetailComponent,
            CompanyDepartmentsListComponent,
            FormCompanyDetailComponent,
            LocationFormComponent,
            CompanyLocationListComponent,
            CompanyLocationCardComponent,
            CompanyLogoUploadModalComponent,
            LogoManageComponent], imports: [CommonModule, SharedModule, MapsModule], exports: [ContactFormComponent,
            ContactListComponent,
            FormDepartmentDetailComponent,
            CompanyDepartmentsListComponent,
            FormCompanyDetailComponent,
            LocationFormComponent,
            CompanyLocationListComponent,
            CompanyLocationCardComponent,
            CompanyLogoUploadModalComponent,
            LogoManageComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EditableBusinessModule, imports: [CommonModule, SharedModule, MapsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EditableBusinessModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DeclareExportComponents$4],
                    imports: [CommonModule, SharedModule, MapsModule],
                    exports: [...DeclareExportComponents$4],
                }]
        }] });

const initialState$2 = {
    currentCustomer: null,
};
class CustomerStore extends ComponentStore {
    constructor(customerService, notificationHelper, errorHandler) {
        super(initialState$2);
        this.customerService = customerService;
        this.notificationHelper = notificationHelper;
        this.errorHandler = errorHandler;
        // SELECTORS
        this.getState = this.select((s) => s);
        this.currentCustomer$ = this.select((s) => s.currentCustomer);
        this.currentCustomerKey$ = this.select(this.currentCustomer$, (customer) => customer?.id);
        // EFFECTS
        this.onGetCurrentCustomer = this.effect((_$) => _$.pipe(switchMap((_) => this.customerService.getCurrentCustomer().pipe(tapResponse((res) => this.onCurrentCustomerFetched(res ?? null), (err) => this.errorHandler.handleError(err))))));
        this.onUpdateCustomer = this.effect((customer$) => customer$.pipe(mergeMap((customer) => from(this.customerService.update(customer)).pipe(tapResponse((res) => {
            this.notificationHelper.popNotification(accountUpdatedNotif);
            return this.onCurrentCustomerUpdated(customer);
        }, (err) => this.errorHandler.handleError(err))))));
        // UPDATERS
        this.onCurrentCustomerFetched = this.updater((state, currentCustomer) => ({ ...state, currentCustomer }));
        this.onCurrentCustomerUpdated = this.updater((state, update) => {
            const currentCustomer = { ...state.currentCustomer, ...stripUndefined(update) };
            return { ...state, currentCustomer };
        });
        this.onGetCurrentCustomer();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerStore, deps: [{ token: CustomerService }, { token: i2$5.NotificationHelper }, { token: i1$3.E11ErrorHandlerService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerStore, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CustomerService }, { type: i2$5.NotificationHelper }, { type: i1$3.E11ErrorHandlerService }] });
const accountUpdatedNotif = {
    title: 'Saved!',
    message: 'Your account information has been updated.',
    type: 'success',
    autoClose: true,
};

class CustomerManageCompanyInfoComponent {
    constructor(customerStore, notificationService) {
        this.customerStore = customerStore;
        this.notificationService = notificationService;
        this.destroy$ = new Subject();
        this.customer$ = this.customerStore.currentCustomer$;
    }
    async onCompanyUpdated(editableBusiness) {
        this.customerStore.onUpdateCustomer(editableBusiness);
    }
    cancel() {
        this.notificationService.popNotification({
            title: 'Cancelled',
            message: 'Your changes were cancelled.',
            type: 'info',
            autoClose: true,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerManageCompanyInfoComponent, deps: [{ token: CustomerStore }, { token: i2$5.NotificationHelper }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerManageCompanyInfoComponent, selector: "sdk-customer-manage-company-info", ngImport: i0, template: `
    <div *ngrxLet="customer$ as customer">
      <sdk-form-company-detail
        [business]="customer"
        [loading]="!customer"
        (cancelled)="cancel()"
        (companyUpdated)="onCompanyUpdated($event)"
      ></sdk-form-company-detail>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: FormCompanyDetailComponent, selector: "sdk-form-company-detail", inputs: ["business", "loading", "loadingSubmit", "cancelText", "disabled", "disabledText", "isClient"], outputs: ["companyAdded", "companyUpdated", "cancelled"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerManageCompanyInfoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-manage-company-info',
                    template: `
    <div *ngrxLet="customer$ as customer">
      <sdk-form-company-detail
        [business]="customer"
        [loading]="!customer"
        (cancelled)="cancel()"
        (companyUpdated)="onCompanyUpdated($event)"
      ></sdk-form-company-detail>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerStore }, { type: i2$5.NotificationHelper }] });

class CustomerLogoComponent {
    constructor(customerStore) {
        this.customerStore = customerStore;
        this.headerText = LOGO_DEFAULTS.headerText;
        this.subHeaderText = LOGO_DEFAULTS.subHeaderText;
        this.logoInfo = LOGO_DEFAULTS.logoInfo;
        this.customer$ = this.customerStore.currentCustomer$;
    }
    ngOnInit() { }
    async logoUpdated(logo, customer) {
        const customerUpdate = { ...customer, logoImageURL: logo.url, logoImage: logo };
        this.customerStore.onUpdateCustomer(customerUpdate);
    }
    async logoDeleted(customer) {
        const customerUpdate = { ...customer, logoImageURL: null, logoImage: null };
        this.customerStore.onUpdateCustomer(customerUpdate);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLogoComponent, deps: [{ token: CustomerStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerLogoComponent, selector: "sdk-customer-logo", inputs: { headerText: "headerText", subHeaderText: "subHeaderText", logoInfo: "logoInfo" }, ngImport: i0, template: `
    <sdk-logo-manage
      *ngrxLet="customer$ as customer"
      [headerText]="headerText"
      [subHeaderText]="subHeaderText"
      [logoInfo]="logoInfo"
      [customerKey]="customer?.id"
      [logoUrl]="customer?.logoImage?.url ?? customer?.logoImageURL ?? undefined"
      (logoUploaded)="logoUpdated($event, customer!)"
      (logoDeleted)="logoDeleted(customer!)"
    ></sdk-logo-manage>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: LogoManageComponent, selector: "sdk-logo-manage", inputs: ["logoUrl", "customerKey", "headerText", "subHeaderText", "logoInfo", "disabled", "disabledText", "showHeaderTitle", "flexDirection", "deleteDurationDays"], outputs: ["logoUploaded", "logoDeleted"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLogoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-logo',
                    template: `
    <sdk-logo-manage
      *ngrxLet="customer$ as customer"
      [headerText]="headerText"
      [subHeaderText]="subHeaderText"
      [logoInfo]="logoInfo"
      [customerKey]="customer?.id"
      [logoUrl]="customer?.logoImage?.url ?? customer?.logoImageURL ?? undefined"
      (logoUploaded)="logoUpdated($event, customer!)"
      (logoDeleted)="logoDeleted(customer!)"
    ></sdk-logo-manage>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerStore }], propDecorators: { headerText: [{
                type: Input
            }], subHeaderText: [{
                type: Input
            }], logoInfo: [{
                type: Input
            }] } });

/**
 * @deprecated use sdk-customer-logo
 */
class ManageCompanyLogoComponent {
    constructor() {
        this.logoInfo = LOGO_DEFAULTS.logoInfo;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManageCompanyLogoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ManageCompanyLogoComponent, selector: "customer-manage-company-logo", inputs: { logoInfo: "logoInfo" }, ngImport: i0, template: `
    <h2 class="e11-text-skin-primary-accent">{{ 'Company Logo' | translate }}</h2>
    <p>
      {{ logoInfo | translate }}
    </p>

    <e11-panel>
      <sdk-customer-logo></sdk-customer-logo>
    </e11-panel>
  `, isInline: true, styles: [".loading{position:absolute;display:flex;width:100%;height:100%;inset:0;opacity:0;z-index:-9;transition:opacity .4s ease-in-out 0s,z-index 0s linear .4s;background-color:#fffc;border-radius:9px;align-items:center;justify-content:center}.loading.active{opacity:1;z-index:9;transition:opacity .4s ease-in-out 0s,z-index 0s linear 0s}.profile-pic{width:100px;height:100px;border-radius:50%;background-size:contain;background-repeat:no-repeat;margin:0 auto}.avatar-upload{position:relative;max-width:100%;overflow:scroll;margin:10px auto 30px}.avatar-upload .avatar-edit{position:absolute;right:19px;z-index:1;top:13px}.avatar-upload .avatar-edit input{display:none}.avatar-upload .avatar-edit .custom-label:hover{opacity:1}.avatar-upload .avatar-edit .custom-label:after{position:absolute;text-align:center;margin:auto;top:8px;right:0;left:2px;width:18px}.avatar-upload .avatar-preview{position:relative;align-items:center;width:100%;max-width:100%;overflow:scroll;min-height:140px;max-height:400px;border:1px solid gray;margin:0 auto;margin-bottom:1rem}.avatar-upload .avatar-preview:before{content:\"\";font-size:4rem;width:100%;position:absolute;font-family:century-gothic,Helvetica,Arial,sans-serif;color:gray;z-index:0}.avatar-upload .avatar-preview>div{width:100%;height:100%;border-radius:100%;background-size:cover;background-repeat:no-repeat;background-position:center;z-index:2}.avatar-upload .avatar-preview>div img{max-width:100%}.avatar-preview .modal{border:transparent}.avatar-preview .modal img{max-width:100%}.avatar-upload.modal{min-height:100px;max-height:240px;border:1px solid gray}.avatar-upload.modal .avatar-preview{border:1px solid transparent;justify-content:center}\n"], dependencies: [{ kind: "component", type: i5$1.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: CustomerLogoComponent, selector: "sdk-customer-logo", inputs: ["headerText", "subHeaderText", "logoInfo"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManageCompanyLogoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-manage-company-logo', template: `
    <h2 class="e11-text-skin-primary-accent">{{ 'Company Logo' | translate }}</h2>
    <p>
      {{ logoInfo | translate }}
    </p>

    <e11-panel>
      <sdk-customer-logo></sdk-customer-logo>
    </e11-panel>
  `, styles: [".loading{position:absolute;display:flex;width:100%;height:100%;inset:0;opacity:0;z-index:-9;transition:opacity .4s ease-in-out 0s,z-index 0s linear .4s;background-color:#fffc;border-radius:9px;align-items:center;justify-content:center}.loading.active{opacity:1;z-index:9;transition:opacity .4s ease-in-out 0s,z-index 0s linear 0s}.profile-pic{width:100px;height:100px;border-radius:50%;background-size:contain;background-repeat:no-repeat;margin:0 auto}.avatar-upload{position:relative;max-width:100%;overflow:scroll;margin:10px auto 30px}.avatar-upload .avatar-edit{position:absolute;right:19px;z-index:1;top:13px}.avatar-upload .avatar-edit input{display:none}.avatar-upload .avatar-edit .custom-label:hover{opacity:1}.avatar-upload .avatar-edit .custom-label:after{position:absolute;text-align:center;margin:auto;top:8px;right:0;left:2px;width:18px}.avatar-upload .avatar-preview{position:relative;align-items:center;width:100%;max-width:100%;overflow:scroll;min-height:140px;max-height:400px;border:1px solid gray;margin:0 auto;margin-bottom:1rem}.avatar-upload .avatar-preview:before{content:\"\";font-size:4rem;width:100%;position:absolute;font-family:century-gothic,Helvetica,Arial,sans-serif;color:gray;z-index:0}.avatar-upload .avatar-preview>div{width:100%;height:100%;border-radius:100%;background-size:cover;background-repeat:no-repeat;background-position:center;z-index:2}.avatar-upload .avatar-preview>div img{max-width:100%}.avatar-preview .modal{border:transparent}.avatar-preview .modal img{max-width:100%}.avatar-upload.modal{min-height:100px;max-height:240px;border:1px solid gray}.avatar-upload.modal .avatar-preview{border:1px solid transparent;justify-content:center}\n"] }]
        }], ctorParameters: () => [], propDecorators: { logoInfo: [{
                type: Input
            }] } });

let BaseCompanyDataComponentStore = class BaseCompanyDataComponentStore extends ComponentStore {
    constructor(initialState) {
        super(initialState);
        this.requiresParentId = true; // require parentId by default
        // Selectors
        this.getState = this.select((s) => s);
        this.state$ = this.select((s) => s);
        this.allItems$ = this.select((s) => s.allItems);
        this.selectedItem$ = this.select((s) => s.selectedItem);
        this.loaded$ = this.select((s) => s.loaded);
        this.parentId$ = this.select((s) => s.parentId);
        // Effects
        this.selectItem = this.effect((item$) => item$.pipe(tap((item) => this.setSelectedItem(item))));
        // TODO: Consider wiring in CustomerStore and writing loadWithCurrentCustomer method
        this.loadAllItems = this.effect((companyId$) => companyId$.pipe(distinctUntilChanged(), tap((companyId) => (companyId ? this.setLoaded(false) : this.setLoaded(true))), tap((companyId) => (companyId ? null : this.clear())), filter$1(isNotNil), tap((companyId) => this.setParentId(companyId)), tap((parentId) => {
            if (!this.requiresParentId)
                this.getAllItems(undefined);
            else
                this.getAllItems(parentId);
        })));
        this.getAllItems = this.effect((parentId$) => parentId$.pipe(switchMap((parentId) => this.itemService.getAll(parentId).pipe(tapResponse((items) => {
            this.setAll(items);
        }, (e) => this.errorHandler.handleError(e)), finalize$1(() => this.setLoaded(true))))));
        this.getItem = this.effect((itemId$) => itemId$.pipe(withLatestFrom(this.parentId$), tap(() => this.setLoaded(false)), tap(([itemId, parentId]) => this.deleteItem(itemId)), mergeMap(([itemId, parentId]) => this.itemService.get(itemId, parentId).pipe(tapResponse((item) => {
            this.setSelectedItem(item);
        }, (e) => {
            this.errorHandler.handleError(e);
            this.notifyError(e, 'Could not get record');
        }), finalize$1(() => this.setLoaded(true))))));
        this.update = this.effect((item$) => item$.pipe(withLatestFrom(this.parentId$), // makes sure this.parentId$ doesn't refire update/add
        tap(() => this.setLoaded(false)), mergeMap(([item, parentId]) => this.itemService.update(item, parentId).pipe(tapResponse((item) => {
            this.updateItem(item);
            this.notifySuccess(`The ${this.itemLabel} was updated`);
        }, (e) => {
            this.errorHandler.handleError(e);
            this.notifyError(e, 'Could not update record');
        }), finalize$1(() => this.setLoaded(true))))));
        this.add = this.effect((item$) => item$.pipe(withLatestFrom(this.parentId$), tap(() => this.setLoaded(false)), mergeMap(([item, parentId]) => this.itemService.add(item, parentId).pipe(tapResponse((item) => {
            this.addItem(item);
            this.notifySuccess(`The ${this.itemLabel} was added`);
        }, (e) => {
            this.errorHandler.handleError(e);
            this.notifyError(e, 'Could add update record');
        }), finalize$1(() => this.setLoaded(true))))));
        this.delete = this.effect((itemId$) => itemId$.pipe(withLatestFrom(this.parentId$), tap(() => this.setLoaded(false)), tap(([itemId, parentId]) => this.deleteItem(itemId)), mergeMap(([itemId, parentId]) => this.itemService.delete(itemId, parentId).pipe(tapResponse((itemId) => {
            this.notifySuccess(`The ${this.itemLabel} was deleted`);
        }, (e) => {
            this.errorHandler.handleError(e);
            this.notifyError(e, 'Could not delete record');
        }), finalize$1(() => this.setLoaded(true))))));
        // Updaters
        this.setParentId = this.updater((state, parentId) => ({
            ...state,
            parentId,
        }));
        this.clear = this.updater((state) => ({
            ...state,
            selectedItem: undefined,
            allItems: [],
        }));
        this.setSelectedItem = this.updater((state, item) => ({
            ...state,
            selectedItem: item,
        }));
        this.setAll = this.updater((state, items) => ({
            ...state,
            allItems: items,
        }));
        this.addItem = this.updater((state, item) => ({
            ...state,
            allItems: state.allItems.concat([item]),
        }));
        this.updateItem = this.updater((state, item) => ({
            ...state,
            allItems: state.allItems.map((i) => (i.id === item.id ? item : i)),
        }));
        this.deleteItem = this.updater((state, itemId) => ({
            ...state,
            allItems: state.allItems.filter((i) => i.id !== itemId),
        }));
        this.setLoaded = this.updater((state, loaded) => ({
            ...state,
            loaded: loaded,
        }));
    }
    notifyError(e, notificationTitle) {
        const message = isE11Error(e) ? e.errorData.title : 'Our engineers have been notified and are investigating the problem';
        this.notificationService.popNotificationMessage({ title: notificationTitle, type: 'error', message });
    }
    notifySuccess(message) {
        this.notificationService.popNotificationMessage({ title: 'Success', type: 'success', message });
    }
};
BaseCompanyDataComponentStore = __decorate([
    __param(0, Inject('initialState'))
], BaseCompanyDataComponentStore);

class CustomerContactStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Contact';
        this.requiresParentId = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: CustomerContactRestService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: CustomerContactRestService }, { type: i3.E11NotificationsService }] });

class CustomerClientContactStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Contact';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientContactStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: CustomerClientContactService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientContactStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientContactStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: CustomerClientContactService }, { type: i3.E11NotificationsService }] });

class CustomerClientDepartmentStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Department';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDepartmentStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: CustomerClientDepartmentService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDepartmentStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDepartmentStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: CustomerClientDepartmentService }, { type: i3.E11NotificationsService }] });

class CustomerClientLocationStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Location';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLocationStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: CustomerClientLocationService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLocationStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLocationStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: CustomerClientLocationService }, { type: i3.E11NotificationsService }] });

class CustomerDepartmentStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Department';
        this.activeDepartments$ = this.select(this.allItems$, (items) => items.filter((d) => d.active));
        this.requiresParentId = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: CustomerDepartmentRestService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: CustomerDepartmentRestService }, { type: i3.E11NotificationsService }] });

class CustomerLocationStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Location';
        this.requiresParentId = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: CustomerLocationRestService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: CustomerLocationRestService }, { type: i3.E11NotificationsService }] });

class PlatformAdminContactStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Contact';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminContactStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: PlatformAdminContactRestService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminContactStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminContactStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: PlatformAdminContactRestService }, { type: i3.E11NotificationsService }] });

class PlatformAdminCustomerStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Customer';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminCustomerStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: PlatformAdminCustomerRestService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminCustomerStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminCustomerStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: PlatformAdminCustomerRestService }, { type: i3.E11NotificationsService }] });

class PlatformAdminDepartmentStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.activeDepartments$ = this.select(this.allItems$, (items) => items.filter((d) => d.active));
        this.itemLabel = 'Department';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminDepartmentStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: PlatformAdminDepartmentRestService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminDepartmentStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminDepartmentStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: PlatformAdminDepartmentRestService }, { type: i3.E11NotificationsService }] });

class PlatformAdminLocationStore extends BaseCompanyDataComponentStore {
    constructor(errorHandler, itemService, notificationService) {
        const initialState = {
            loaded: false,
            allItems: [],
            parentId: undefined,
        };
        super(initialState);
        this.errorHandler = errorHandler;
        this.itemService = itemService;
        this.notificationService = notificationService;
        this.itemLabel = 'Location';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminLocationStore, deps: [{ token: i1$3.E11ErrorHandlerService }, { token: PlatformAdminLocationRestService }, { token: i3.E11NotificationsService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminLocationStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminLocationStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11ErrorHandlerService }, { type: PlatformAdminLocationRestService }, { type: i3.E11NotificationsService }] });

class CustomerContactsComponent {
    constructor(contactStore, locationStore, customerStore) {
        this.contactStore = contactStore;
        this.locationStore = locationStore;
        this.customerStore = customerStore;
        this.suppressHeader = false;
        this.currentCustomer$ = this.customerStore.currentCustomer$.pipe(filter$1(isNotNil));
        this.contacts$ = this.contactStore.allItems$;
        this.selectedItem$ = this.contactStore.selectedItem$;
        this.loaded$ = this.contactStore.loaded$;
        this.locations$ = this.locationStore.allItems$;
    }
    ngOnInit() {
        const customerId$ = this.currentCustomer$.pipe(map$1((customer) => customer.id), distinctUntilChanged());
        this.contactStore.loadAllItems(customerId$);
        this.locationStore.loadAllItems(customerId$);
    }
    ngOnDestroy() { }
    select(contact) {
        this.contactStore.selectItem({ ...contact });
        this.editContactModal.open();
    }
    addClicked() {
        this.contactStore.selectItem(undefined);
        this.editContactModal.open();
    }
    addContact(contact, customerKey) {
        this.contactStore.add({ ...contact, customerKey });
    }
    updateContact(contact, customerKey) {
        this.contactStore.update({ ...contact, id: contact.id, customerKey });
    }
    deleteContact(contactId) {
        this.contactStore.delete(contactId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactsComponent, deps: [{ token: CustomerContactStore }, { token: CustomerLocationStore }, { token: CustomerStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerContactsComponent, selector: "sdk-customer-contacts", inputs: { suppressHeader: "suppressHeader" }, viewQueries: [{ propertyName: "editContactModal", first: true, predicate: ["editContact"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else contacts" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #contacts>
      <sdk-customer-list-header
        *ngIf="!suppressHeader"
        [headerText]="'Manage Contacts'"
        [buttonText]="'Add Contact'"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>
      <sdk-contact-list
        [contacts]="(contacts$ | async) ?? []"
        (contactClicked)="select($event)"
        (addContactClicked)="addClicked()"
      ></sdk-contact-list>

      <e11-modal
        #editContact
        [darkMode]="false"
        [title]="'Edit Contact' | translate"
        [showHeader]="true"
        [showFooter]="true"
        [hideCloseButton]="false"
        [width]="'lg'"
      >
        <div modal-body *ngrxLet="currentCustomer$ as currentCustomer">
          <sdk-contact-form
            [currentContact]="(selectedItem$ | async) ?? undefined"
            [locations]="(locations$ | async) ?? undefined"
            (addContact)="addContact($event, currentCustomer.id)"
            (updateContact)="updateContact($event, currentCustomer.id)"
            (cancelled)="editContact.close()"
            (deleteContact)="deleteContact($event)"
          ></sdk-contact-form>
        </div>
      </e11-modal>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: ContactFormComponent, selector: "sdk-contact-form", inputs: ["currentContact", "locations"], outputs: ["cancelled", "deleteClicked", "addContact", "updateContact", "deleteContact"] }, { kind: "component", type: ContactListComponent, selector: "sdk-contact-list", inputs: ["contacts", "disabled", "disabledText"], outputs: ["contactClicked", "addContactClicked"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerContactsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-contacts',
                    template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else contacts" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #contacts>
      <sdk-customer-list-header
        *ngIf="!suppressHeader"
        [headerText]="'Manage Contacts'"
        [buttonText]="'Add Contact'"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>
      <sdk-contact-list
        [contacts]="(contacts$ | async) ?? []"
        (contactClicked)="select($event)"
        (addContactClicked)="addClicked()"
      ></sdk-contact-list>

      <e11-modal
        #editContact
        [darkMode]="false"
        [title]="'Edit Contact' | translate"
        [showHeader]="true"
        [showFooter]="true"
        [hideCloseButton]="false"
        [width]="'lg'"
      >
        <div modal-body *ngrxLet="currentCustomer$ as currentCustomer">
          <sdk-contact-form
            [currentContact]="(selectedItem$ | async) ?? undefined"
            [locations]="(locations$ | async) ?? undefined"
            (addContact)="addContact($event, currentCustomer.id)"
            (updateContact)="updateContact($event, currentCustomer.id)"
            (cancelled)="editContact.close()"
            (deleteContact)="deleteContact($event)"
          ></sdk-contact-form>
        </div>
      </e11-modal>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerContactStore }, { type: CustomerLocationStore }, { type: CustomerStore }], propDecorators: { editContactModal: [{
                type: ViewChild,
                args: ['editContact']
            }], suppressHeader: [{
                type: Input
            }] } });

class CustomerDepartmentsComponent {
    constructor(customerStore, departmentStore) {
        this.customerStore = customerStore;
        this.departmentStore = departmentStore;
        this.suppressHeader = false;
        this.departmentActiveInfo = defaultDepartmentActiveInfo;
        this.currentCustomer$ = this.customerStore.currentCustomer$.pipe(filter$1(isNotNil));
        this.departments$ = this.departmentStore.allItems$;
        this.selectedDepartment$ = this.departmentStore.selectedItem$.pipe(map$1((department) => department));
        this.loaded$ = this.departmentStore.loaded$;
    }
    ngOnInit() {
        this.departmentStore.loadAllItems(this.currentCustomer$.pipe(map$1((customer) => customer.id)));
    }
    ngOnDestroy() { }
    select(department) {
        this.departmentStore.selectItem(department);
        this.editDepartmentModal.open();
    }
    deselect() {
        this.departmentStore.selectItem(undefined);
        this.editDepartmentModal.close();
    }
    cancelEdit() {
        this.deselect();
    }
    addClicked() {
        this.departmentStore.selectItem(undefined);
        this.editDepartmentModal.open();
    }
    update(department) {
        const casted = department;
        this.departmentStore.update(casted);
        this.deselect();
    }
    add(department, customerKey) {
        const customerDepartment = { ...department, customerKey };
        this.departmentStore.add(customerDepartment);
        this.deselect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentsComponent, deps: [{ token: CustomerStore }, { token: CustomerDepartmentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerDepartmentsComponent, selector: "sdk-customer-departments", inputs: { suppressHeader: "suppressHeader", departmentActiveInfo: "departmentActiveInfo" }, viewQueries: [{ propertyName: "editDepartmentModal", first: true, predicate: ["editDepartment"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else departments" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #departments>
      <sdk-customer-list-header
        *ngIf="!suppressHeader"
        [headerText]="'Manage Departments'"
        [buttonText]="'Add Department'"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>
      <sdk-department-list
        [departments]="(departments$ | async) ?? undefined"
        (departmentSelected)="select($event)"
        (addDepartmentClicked)="addClicked()"
      ></sdk-department-list>

      <e11-modal
        #editDepartment
        [title]="'Manage Department' | translate"
        [showHeader]="true"
        [showFooter]="false"
        [hideCloseButton]="false"
        [width]="'lg'"
        [bodyHeight]="'auto'"
      >
        >
        <div modal-body *ngrxLet="currentCustomer$ as currentCustomer">
          <sdk-form-department
            [department]="(selectedDepartment$ | async) ?? undefined"
            [activeInfo]="departmentActiveInfo"
            (cancelled)="cancelEdit()"
            (departmentAdded)="add($event, currentCustomer.id)"
            (departmentUpdated)="update($event)"
          ></sdk-form-department>
        </div>
      </e11-modal>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: FormDepartmentDetailComponent, selector: "sdk-form-department", inputs: ["activeInfo", "department"], outputs: ["departmentAdded", "departmentUpdated", "cancelled"] }, { kind: "component", type: CompanyDepartmentsListComponent, selector: "sdk-department-list", inputs: ["departments", "disabled", "disabledText"], outputs: ["departmentSelected", "addDepartmentClicked"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDepartmentsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-departments',
                    template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else departments" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #departments>
      <sdk-customer-list-header
        *ngIf="!suppressHeader"
        [headerText]="'Manage Departments'"
        [buttonText]="'Add Department'"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>
      <sdk-department-list
        [departments]="(departments$ | async) ?? undefined"
        (departmentSelected)="select($event)"
        (addDepartmentClicked)="addClicked()"
      ></sdk-department-list>

      <e11-modal
        #editDepartment
        [title]="'Manage Department' | translate"
        [showHeader]="true"
        [showFooter]="false"
        [hideCloseButton]="false"
        [width]="'lg'"
        [bodyHeight]="'auto'"
      >
        >
        <div modal-body *ngrxLet="currentCustomer$ as currentCustomer">
          <sdk-form-department
            [department]="(selectedDepartment$ | async) ?? undefined"
            [activeInfo]="departmentActiveInfo"
            (cancelled)="cancelEdit()"
            (departmentAdded)="add($event, currentCustomer.id)"
            (departmentUpdated)="update($event)"
          ></sdk-form-department>
        </div>
      </e11-modal>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerStore }, { type: CustomerDepartmentStore }], propDecorators: { editDepartmentModal: [{
                type: ViewChild,
                args: ['editDepartment']
            }], suppressHeader: [{
                type: Input
            }], departmentActiveInfo: [{
                type: Input
            }] } });

class CustomerLocationsComponent {
    constructor(customerStore, locationStore, modalService) {
        this.customerStore = customerStore;
        this.locationStore = locationStore;
        this.modalService = modalService;
        this.suppressHeader = false;
        this.showSearch = false;
        this.disabled = false;
        this.disabledText = EDIT_PERMISSION_MISSING;
        this.locationActiveInfo = defaultLocationActiveInfo;
        this.currentCustomer$ = this.customerStore.currentCustomer$.pipe(filter$1(isNotNil));
        this.locations$ = this.locationStore.allItems$;
        this.loaded$ = this.locationStore.loaded$;
        this.selectedLocation$ = this.locationStore.selectedItem$.pipe(map$1((location) => location));
        this.locationSelected = new EventEmitter();
        this.addLocationClicked = new EventEmitter();
    }
    ngOnInit() {
        this.locationStore.loadAllItems(this.currentCustomer$.pipe(map$1((customer) => customer.id)));
    }
    ngOnDestroy() { }
    openModal() {
        this.modalService.openModal({
            body: this.editLocationModal,
            width: 'lg',
            darkMode: false,
            title: 'Edit Location',
            showHeader: true,
            showFooter: false,
            hideCloseButton: false,
        });
    }
    select(location) {
        this.locationStore.selectItem(location);
        this.openModal();
    }
    deselect() {
        this.locationStore.selectItem(undefined);
        this.modalService.closeModal();
    }
    cancelEdit() {
        this.deselect();
    }
    addClicked() {
        this.locationStore.selectItem(undefined);
        this.openModal();
    }
    update(location) {
        const casted = location;
        this.locationStore.update(casted);
        this.deselect();
    }
    delete(location) {
        const casted = location;
        this.locationStore.delete(casted.id);
        this.deselect();
    }
    add(location, customerKey) {
        const customerLocations = { ...location, customerKey };
        this.locationStore.add(customerLocations);
        this.deselect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationsComponent, deps: [{ token: CustomerStore }, { token: CustomerLocationStore }, { token: i6$1.E11ModalGlobalService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerLocationsComponent, selector: "sdk-customer-locations", inputs: { suppressHeader: "suppressHeader", showSearch: "showSearch", locations: "locations", disabled: "disabled", disabledText: "disabledText", locationActiveInfo: "locationActiveInfo" }, outputs: { locationSelected: "locationSelected", addLocationClicked: "addLocationClicked" }, viewQueries: [{ propertyName: "editLocationModal", first: true, predicate: ["editLocation"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else locations" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #locations>
      <sdk-customer-list-header
        *ngIf="!suppressHeader"
        [headerText]="'Manage Locations'"
        [buttonText]="'Add Location'"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>

      <sdk-location-list
        [locations]="(locations$ | async) ?? undefined"
        (locationSelected)="select($event)"
        (addLocationClicked)="addClicked()"
        [showSearch]="showSearch"
      ></sdk-location-list>

      <ng-template #editLocation>
        <div *ngrxLet="currentCustomer$ as currentCustomer">
          <sdk-form-location
            [location]="(selectedLocation$ | async) ?? undefined"
            [activeInfo]="locationActiveInfo"
            (cancelled)="cancelEdit()"
            (locationAdded)="add($event, currentCustomer.id)"
            (locationDeleted)="delete($event)"
            (locationUpdated)="update($event)"
          ></sdk-form-location>
        </div>
      </ng-template>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: LocationFormComponent, selector: "sdk-form-location", inputs: ["location", "STATE_REQUIRED_LENGTH", "activeInfo"], outputs: ["locationAdded", "locationUpdated", "locationDeleted", "cancelled"] }, { kind: "component", type: CompanyLocationListComponent, selector: "sdk-location-list", inputs: ["showSearch", "locations", "disabled", "disabledText"], outputs: ["locationSelected", "addLocationClicked"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerLocationsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-locations',
                    template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else locations" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #locations>
      <sdk-customer-list-header
        *ngIf="!suppressHeader"
        [headerText]="'Manage Locations'"
        [buttonText]="'Add Location'"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>

      <sdk-location-list
        [locations]="(locations$ | async) ?? undefined"
        (locationSelected)="select($event)"
        (addLocationClicked)="addClicked()"
        [showSearch]="showSearch"
      ></sdk-location-list>

      <ng-template #editLocation>
        <div *ngrxLet="currentCustomer$ as currentCustomer">
          <sdk-form-location
            [location]="(selectedLocation$ | async) ?? undefined"
            [activeInfo]="locationActiveInfo"
            (cancelled)="cancelEdit()"
            (locationAdded)="add($event, currentCustomer.id)"
            (locationDeleted)="delete($event)"
            (locationUpdated)="update($event)"
          ></sdk-form-location>
        </div>
      </ng-template>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerStore }, { type: CustomerLocationStore }, { type: i6$1.E11ModalGlobalService }], propDecorators: { suppressHeader: [{
                type: Input
            }], showSearch: [{
                type: Input
            }], locations: [{
                type: Input
            }], disabled: [{
                type: Input
            }], disabledText: [{
                type: Input
            }], editLocationModal: [{
                type: ViewChild,
                args: ['editLocation']
            }], locationActiveInfo: [{
                type: Input
            }], locationSelected: [{
                type: Output
            }], addLocationClicked: [{
                type: Output
            }] } });

// ! Only add to declare exports if it's needed externally
const DeclareExportComponents$3 = [
    CustomerManageCompanyInfoComponent,
    ManageCompanyLogoComponent,
    CustomerContactsComponent,
    CustomerDepartmentsComponent,
    CustomerLocationsComponent,
    CustomerLogoComponent,
];
class CompanyAccountModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyAccountModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: CompanyAccountModule, declarations: [CustomerManageCompanyInfoComponent,
            ManageCompanyLogoComponent,
            CustomerContactsComponent,
            CustomerDepartmentsComponent,
            CustomerLocationsComponent,
            CustomerLogoComponent], imports: [CommonModule, SharedModule, EditableBusinessModule], exports: [CustomerManageCompanyInfoComponent,
            ManageCompanyLogoComponent,
            CustomerContactsComponent,
            CustomerDepartmentsComponent,
            CustomerLocationsComponent,
            CustomerLogoComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyAccountModule, imports: [CommonModule, SharedModule, EditableBusinessModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanyAccountModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DeclareExportComponents$3],
                    imports: [CommonModule, SharedModule, EditableBusinessModule],
                    exports: [...DeclareExportComponents$3],
                }]
        }] });

class PlatformAdminDepartmentsComponent {
    set customerKey(customerKey) {
        this._customerKey = customerKey;
        this.departmentStore.loadAllItems(customerKey);
    }
    constructor(departmentStore) {
        this.departmentStore = departmentStore;
        this.departments$ = this.departmentStore.allItems$;
        this.selectedDepartment$ = this.departmentStore.selectedItem$;
        this.departmentActiveInfo = defaultDepartmentActiveInfo;
    }
    addClicked() {
        this.editDepartmentModal.open();
    }
    select(department) {
        this.departmentStore.selectItem(department);
        this.editDepartmentModal.open();
    }
    deselect() {
        this.departmentStore.selectItem(undefined);
        this.editDepartmentModal.close();
    }
    cancelEdit() {
        this.deselect();
    }
    update(department) {
        const casted = department;
        this.departmentStore.update(casted);
        this.deselect();
    }
    add(department) {
        if (!this._customerKey) {
            throw e11Error({ title: 'Invalid configuration', message: 'No customerKey', type: 'customer-admin/no-customer-key' });
        }
        const customerDepartment = { ...department, customerKey: this._customerKey };
        this.departmentStore.add(customerDepartment);
        this.deselect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminDepartmentsComponent, deps: [{ token: PlatformAdminDepartmentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PlatformAdminDepartmentsComponent, selector: "sdk-customer-admin-departments", inputs: { customerKey: "customerKey" }, viewQueries: [{ propertyName: "editDepartmentModal", first: true, predicate: ["editDepartment"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="departments$ as departments; suspenseTpl: loading">
      <sdk-customer-list-header
        [headerText]="'Manage Departments'"
        [buttonText]="'Add Department'"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>
      <sdk-department-list
        [departments]="departments"
        (departmentSelected)="select($event)"
        (addDepartmentClicked)="addClicked()"
      ></sdk-department-list>
    </ng-container>
    <e11-modal
      #editDepartment
      [title]="'Manage Department' | translate"
      [showHeader]="true"
      [showFooter]="false"
      [hideCloseButton]="false"
      [width]="'lg'"
      [bodyHeight]="'auto'"
    >
      >
      <div modal-body>
        <ng-container *ngrxLet="selectedDepartment$ as selectedDepartment; suspenseTpl: loading">
          <sdk-form-department
            [department]="selectedDepartment"
            [activeInfo]="departmentActiveInfo"
            (cancelled)="deselect()"
            (departmentAdded)="add($event)"
            (departmentUpdated)="update($event)"
          ></sdk-form-department>
        </ng-container>
      </div>
    </e11-modal>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: FormDepartmentDetailComponent, selector: "sdk-form-department", inputs: ["activeInfo", "department"], outputs: ["departmentAdded", "departmentUpdated", "cancelled"] }, { kind: "component", type: CompanyDepartmentsListComponent, selector: "sdk-department-list", inputs: ["departments", "disabled", "disabledText"], outputs: ["departmentSelected", "addDepartmentClicked"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminDepartmentsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-admin-departments',
                    template: `
    <ng-container *ngrxLet="departments$ as departments; suspenseTpl: loading">
      <sdk-customer-list-header
        [headerText]="'Manage Departments'"
        [buttonText]="'Add Department'"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>
      <sdk-department-list
        [departments]="departments"
        (departmentSelected)="select($event)"
        (addDepartmentClicked)="addClicked()"
      ></sdk-department-list>
    </ng-container>
    <e11-modal
      #editDepartment
      [title]="'Manage Department' | translate"
      [showHeader]="true"
      [showFooter]="false"
      [hideCloseButton]="false"
      [width]="'lg'"
      [bodyHeight]="'auto'"
    >
      >
      <div modal-body>
        <ng-container *ngrxLet="selectedDepartment$ as selectedDepartment; suspenseTpl: loading">
          <sdk-form-department
            [department]="selectedDepartment"
            [activeInfo]="departmentActiveInfo"
            (cancelled)="deselect()"
            (departmentAdded)="add($event)"
            (departmentUpdated)="update($event)"
          ></sdk-form-department>
        </ng-container>
      </div>
    </e11-modal>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: PlatformAdminDepartmentStore }], propDecorators: { editDepartmentModal: [{
                type: ViewChild,
                args: ['editDepartment']
            }], customerKey: [{
                type: Input
            }] } });

class SearchBusinessCustomersComponent {
    constructor() {
        this.customerSelected = new EventEmitter();
        this.customerType = CustomerType.Business;
    }
    selected(customer) {
        this.customerSelected.emit(customer);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SearchBusinessCustomersComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: SearchBusinessCustomersComponent, selector: "sdk-customer-search-business", outputs: { customerSelected: "customerSelected" }, ngImport: i0, template: `<sdk-customer-search-all [customerType]="customerType" (customerSelected)="selected($event)"></sdk-customer-search-all> `, isInline: true, dependencies: [{ kind: "component", type: SearchAllCustomersComponent, selector: "sdk-customer-search-all", inputs: ["customerType"], outputs: ["customerSelected"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SearchBusinessCustomersComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-search-business',
                    template: `<sdk-customer-search-all [customerType]="customerType" (customerSelected)="selected($event)"></sdk-customer-search-all> `,
                }]
        }], ctorParameters: () => [], propDecorators: { customerSelected: [{
                type: Output
            }] } });

class SearchConsumerCustomersComponent {
    constructor() {
        this.customerSelected = new EventEmitter();
        this.customerType = CustomerType.Consumer;
    }
    selected(customer) {
        this.customerSelected.emit(customer);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SearchConsumerCustomersComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: SearchConsumerCustomersComponent, selector: "sdk-customer-search-consumer", outputs: { customerSelected: "customerSelected" }, ngImport: i0, template: `<sdk-customer-search-all [customerType]="customerType" (customerSelected)="selected($event)"></sdk-customer-search-all> `, isInline: true, dependencies: [{ kind: "component", type: SearchAllCustomersComponent, selector: "sdk-customer-search-all", inputs: ["customerType"], outputs: ["customerSelected"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: SearchConsumerCustomersComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-search-consumer',
                    template: `<sdk-customer-search-all [customerType]="customerType" (customerSelected)="selected($event)"></sdk-customer-search-all> `,
                }]
        }], ctorParameters: () => [], propDecorators: { customerSelected: [{
                type: Output
            }] } });

class PlatformAdminLocationsComponent {
    set customerKey(customerKey) {
        this._customerKey = customerKey;
        this.locationsStore.loadAllItems(customerKey);
    }
    constructor(modalService, locationsStore) {
        this.modalService = modalService;
        this.locationsStore = locationsStore;
        this.locations$ = this.locationsStore.allItems$;
        this.selectedLocation$ = this.locationsStore.selectedItem$;
        this.locationActiveInfo = defaultLocationActiveInfo;
    }
    addClicked() {
        this.modalService.openModal({
            body: this.editLocationModal,
            width: 'lg',
            darkMode: false,
            title: 'Edit Location',
            showHeader: true,
            showFooter: false,
            hideCloseButton: false,
        });
    }
    select(location) {
        this.locationsStore.selectItem(location);
        this.modalService.openModal({
            body: this.editLocationModal,
            width: 'lg',
            darkMode: false,
            title: 'Edit Location',
            showHeader: true,
            showFooter: false,
            hideCloseButton: false,
        });
    }
    deselect() {
        this.locationsStore.selectItem(undefined);
        this.modalService.closeModal();
    }
    cancelEdit() {
        this.deselect();
    }
    update(location) {
        const casted = location;
        this.locationsStore.update(casted);
        this.deselect();
    }
    add(location) {
        if (!this._customerKey) {
            throw e11Error({ title: 'Invalid configuration', message: 'No customerKey', type: 'customer-admin/no-customer-key' });
        }
        const customerLocation = { ...location, customerKey: this._customerKey };
        this.locationsStore.add(customerLocation);
        this.deselect();
    }
    delete(location) {
        if (location.id) {
            this.locationsStore.delete(location.id);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminLocationsComponent, deps: [{ token: i6$1.E11ModalGlobalService }, { token: PlatformAdminLocationStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PlatformAdminLocationsComponent, selector: "sdk-customer-admin-locations", inputs: { customerKey: "customerKey" }, viewQueries: [{ propertyName: "editLocationModal", first: true, predicate: ["editLocation"], descendants: true }], ngImport: i0, template: `
    <sdk-customer-list-header [headerText]="'Manage Locations'" [buttonText]="'Add Location'" (addClicked)="addClicked()"></sdk-customer-list-header>
    <ng-container *ngrxLet="locations$ as locations; suspenseTpl: loading">
      <sdk-location-list
        [locations]="locations"
        (locationSelected)="select($event)"
        (addLocationClicked)="addClicked()"
        [showSearch]="true"
      ></sdk-location-list>
    </ng-container>
    <ng-template #editLocation>
      <ng-container *ngrxLet="selectedLocation$ as selectedLocation; suspenseTpl: loading">
        <sdk-form-location
          [location]="selectedLocation"
          [activeInfo]="locationActiveInfo"
          (cancelled)="cancelEdit()"
          (locationAdded)="add($event)"
          (locationDeleted)="delete($event)"
          (locationUpdated)="update($event)"
        ></sdk-form-location>
      </ng-container>
    </ng-template>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: LocationFormComponent, selector: "sdk-form-location", inputs: ["location", "STATE_REQUIRED_LENGTH", "activeInfo"], outputs: ["locationAdded", "locationUpdated", "locationDeleted", "cancelled"] }, { kind: "component", type: CompanyLocationListComponent, selector: "sdk-location-list", inputs: ["showSearch", "locations", "disabled", "disabledText"], outputs: ["locationSelected", "addLocationClicked"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminLocationsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-admin-locations',
                    template: `
    <sdk-customer-list-header [headerText]="'Manage Locations'" [buttonText]="'Add Location'" (addClicked)="addClicked()"></sdk-customer-list-header>
    <ng-container *ngrxLet="locations$ as locations; suspenseTpl: loading">
      <sdk-location-list
        [locations]="locations"
        (locationSelected)="select($event)"
        (addLocationClicked)="addClicked()"
        [showSearch]="true"
      ></sdk-location-list>
    </ng-container>
    <ng-template #editLocation>
      <ng-container *ngrxLet="selectedLocation$ as selectedLocation; suspenseTpl: loading">
        <sdk-form-location
          [location]="selectedLocation"
          [activeInfo]="locationActiveInfo"
          (cancelled)="cancelEdit()"
          (locationAdded)="add($event)"
          (locationDeleted)="delete($event)"
          (locationUpdated)="update($event)"
        ></sdk-form-location>
      </ng-container>
    </ng-template>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: i6$1.E11ModalGlobalService }, { type: PlatformAdminLocationStore }], propDecorators: { editLocationModal: [{
                type: ViewChild,
                args: ['editLocation']
            }], customerKey: [{
                type: Input
            }] } });

class PlatformAdminContactsComponent {
    set customerKey(customerKey) {
        this._customerKey = customerKey;
        this.contactsStore.loadAllItems(customerKey);
        this.locationsStore.loadAllItems(customerKey);
    }
    constructor(contactsStore, locationsStore) {
        this.contactsStore = contactsStore;
        this.locationsStore = locationsStore;
        this.contacts$ = this.contactsStore.allItems$;
        this.locations$ = this.locationsStore.allItems$;
        this.selectedContact$ = this.contactsStore.selectedItem$;
    }
    addClicked() {
        this.editContactModal.open();
    }
    select(department) {
        this.contactsStore.selectItem(department);
        this.editContactModal.open();
    }
    deselect() {
        this.contactsStore.selectItem(undefined);
        this.editContactModal.close();
    }
    update(contact) {
        const casted = contact;
        this.contactsStore.update(casted);
        this.deselect();
    }
    add(contact) {
        if (!this._customerKey) {
            throw e11Error({ title: 'Invalid configuration', message: 'No customerKey', type: 'customer-admin/no-customer-key' });
        }
        const customerContact = { ...contact, customerKey: this._customerKey };
        this.contactsStore.add(customerContact);
        this.deselect();
    }
    delete(id) {
        this.contactsStore.delete(id);
    }
    cancelEdit() {
        this.deselect();
        this.editContactModal.close();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminContactsComponent, deps: [{ token: PlatformAdminContactStore }, { token: PlatformAdminLocationStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PlatformAdminContactsComponent, selector: "sdk-customer-admin-contacts", inputs: { customerKey: "customerKey" }, viewQueries: [{ propertyName: "editContactModal", first: true, predicate: ["editContact"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="contacts$ as contacts; suspenseTpl: loading">
      <sdk-customer-list-header
        [headerText]="'Manage Contacts'"
        [buttonText]="'Add Contact'"
        [disabled]="false"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>
      <sdk-contact-list
        [contacts]="contacts"
        [disabled]="false"
        (contactClicked)="select($event)"
        (addContactClicked)="addClicked()"
      ></sdk-contact-list>
    </ng-container>
    <e11-modal
      #editContact
      [darkMode]="false"
      [title]="'Edit Contact' | translate"
      [showHeader]="true"
      [showFooter]="true"
      [hideCloseButton]="false"
      [width]="'lg'"
    >
      <div modal-body *ngrxLet="locations$ as locations; suspenseTpl: loading">
        <ng-container *ngrxLet="selectedContact$ as selectedContact; suspenseTpl: loading">
          <sdk-contact-form
            [currentContact]="selectedContact"
            [locations]="locations"
            (addContact)="add($event)"
            (updateContact)="update($event)"
            (cancelled)="editContact.close()"
            (deleteContact)="delete($event)"
          ></sdk-contact-form>
        </ng-container>
      </div>
    </e11-modal>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: ContactFormComponent, selector: "sdk-contact-form", inputs: ["currentContact", "locations"], outputs: ["cancelled", "deleteClicked", "addContact", "updateContact", "deleteContact"] }, { kind: "component", type: ContactListComponent, selector: "sdk-contact-list", inputs: ["contacts", "disabled", "disabledText"], outputs: ["contactClicked", "addContactClicked"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminContactsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-admin-contacts',
                    template: `
    <ng-container *ngrxLet="contacts$ as contacts; suspenseTpl: loading">
      <sdk-customer-list-header
        [headerText]="'Manage Contacts'"
        [buttonText]="'Add Contact'"
        [disabled]="false"
        (addClicked)="addClicked()"
      ></sdk-customer-list-header>
      <sdk-contact-list
        [contacts]="contacts"
        [disabled]="false"
        (contactClicked)="select($event)"
        (addContactClicked)="addClicked()"
      ></sdk-contact-list>
    </ng-container>
    <e11-modal
      #editContact
      [darkMode]="false"
      [title]="'Edit Contact' | translate"
      [showHeader]="true"
      [showFooter]="true"
      [hideCloseButton]="false"
      [width]="'lg'"
    >
      <div modal-body *ngrxLet="locations$ as locations; suspenseTpl: loading">
        <ng-container *ngrxLet="selectedContact$ as selectedContact; suspenseTpl: loading">
          <sdk-contact-form
            [currentContact]="selectedContact"
            [locations]="locations"
            (addContact)="add($event)"
            (updateContact)="update($event)"
            (cancelled)="editContact.close()"
            (deleteContact)="delete($event)"
          ></sdk-contact-form>
        </ng-container>
      </div>
    </e11-modal>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: PlatformAdminContactStore }, { type: PlatformAdminLocationStore }], propDecorators: { editContactModal: [{
                type: ViewChild,
                args: ['editContact']
            }], customerKey: [{
                type: Input
            }] } });

class PlatformAdminCustomerDetailComponent {
    set customerKey(customerKey) {
        if (customerKey) {
            this._customerKey = customerKey;
            this.customerStore.getItem(customerKey);
        }
    }
    constructor(customerStore) {
        this.customerStore = customerStore;
        this.backToSearch = new EventEmitter();
        this.customer$ = this.customerStore.selectedItem$;
    }
    makeEditableBusiness(combinedCustomer) {
        if (combinedCustomer && combinedCustomer.customerType === CustomerType.Business) {
            return combinedCustomer;
        }
        return undefined;
    }
    async onCompanyUpdated(editableBusiness) {
        const customer = editableBusiness;
        this.customerStore.update(customer);
    }
    cancel() {
        this.backToSearch.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminCustomerDetailComponent, deps: [{ token: PlatformAdminCustomerStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PlatformAdminCustomerDetailComponent, selector: "sdk-customer-admin-customer-detail", inputs: { customerKey: "customerKey" }, outputs: { backToSearch: "backToSearch" }, ngImport: i0, template: `
    <ng-container *ngrxLet="customer$ as customer; suspenseTpl: loading">
      <sdk-form-company-detail
        [business]="makeEditableBusiness(customer)"
        [loading]="!customer"
        [cancelText]="'Back to Search'"
        (cancelled)="cancel()"
        (companyUpdated)="onCompanyUpdated($event)"
      ></sdk-form-company-detail>
    </ng-container>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: FormCompanyDetailComponent, selector: "sdk-form-company-detail", inputs: ["business", "loading", "loadingSubmit", "cancelText", "disabled", "disabledText", "isClient"], outputs: ["companyAdded", "companyUpdated", "cancelled"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminCustomerDetailComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-admin-customer-detail',
                    template: `
    <ng-container *ngrxLet="customer$ as customer; suspenseTpl: loading">
      <sdk-form-company-detail
        [business]="makeEditableBusiness(customer)"
        [loading]="!customer"
        [cancelText]="'Back to Search'"
        (cancelled)="cancel()"
        (companyUpdated)="onCompanyUpdated($event)"
      ></sdk-form-company-detail>
    </ng-container>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: PlatformAdminCustomerStore }], propDecorators: { customerKey: [{
                type: Input
            }], backToSearch: [{
                type: Output
            }] } });

class CustomerClientService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.restClient = new RestApiClient({
            baseUrl: this.configProvider.config.baseUrl,
            token: this.configProvider.config.token$.pipe(filter$1(isNotNil)),
            throwNon200s: true,
        });
    }
    get(clientId) {
        return this.restClient.get(`clients/${clientId}`).pipe(map$1((client) => client.data));
    }
    getCustomer(clientId, customerKey) {
        return this.restClient
            .get(`clients/${clientId}/customer/${customerKey}`)
            .pipe(map$1((client) => (client.data ? DateService.convertAllDateFields(client.data) : client.data)));
    }
    add(customerClient) {
        return this.restClient.post('clients', customerClient).pipe(map$1((client) => client.data));
    }
    update(customerClient) {
        return this.restClient.put(`clients/${customerClient.id}`, customerClient).pipe(map$1((client) => client.data));
    }
    disable(id) {
        return this.restClient.put(`clients/${id}/disabled`, {}).pipe(map$1((client) => client.data));
    }
    delete(id) {
        return this.restClient.delete(`clients/${id}]`).pipe(map$1((client) => client.data));
    }
    searchKeyPackage() {
        return this.restClient.get(`search-keys/clients`).pipe(map$1((kp) => kp.data));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientService, deps: [{ token: BaseCustomerConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: BaseCustomerConfigProvider }] });

class CustomerClientListComponent {
    constructor() {
        this.clientSelected = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientListComponent, selector: "sdk-customer-client-list", inputs: { clients: "clients" }, outputs: { clientSelected: "clientSelected" }, ngImport: i0, template: `
    <div class="e11-grid e11-grid-cols-5 e11-w-full e11-px-4 e11-py-4 e11-text-sm md:e11-text-base e11-border-b e11-border-skin-app-borders">
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'Name' | translate }}
      </div>
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'Phone' | translate }}
      </div>
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'City' | translate }}
      </div>
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'State' | translate }}
      </div>
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'Has Account' | translate }}
      </div>
    </div>

    <div
      class="e11-grid e11-grid-cols-5 e11-w-full e11-text-sm md:e11-text-base e11-px-4 e11-py-4 e11-border-b e11-border-skin-app-borders e11-transition e11-duration-200 e11-ease-in-out e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 odd:e11-bg-skin-grey/10"
      *ngFor="let client of clients; let i = index"
      (click)="clientSelected.emit(client)"
    >
      <div class="e11-truncate">{{ client.name }}</div>
      <div class="e11-truncate">{{ client.phone }}</div>
      <div class="e11-truncate">{{ client.city }}</div>
      <div class="e11-truncate">{{ client.state }}</div>
      <span class="e11-block material-icons-outlined e11-text-skin-success" *ngIf="client.clientCustomerKey"> task_alt </span>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-list',
                    template: `
    <div class="e11-grid e11-grid-cols-5 e11-w-full e11-px-4 e11-py-4 e11-text-sm md:e11-text-base e11-border-b e11-border-skin-app-borders">
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'Name' | translate }}
      </div>
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'Phone' | translate }}
      </div>
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'City' | translate }}
      </div>
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'State' | translate }}
      </div>
      <div class="e11-font-primary-demibold e11-w-fit">
        {{ 'Has Account' | translate }}
      </div>
    </div>

    <div
      class="e11-grid e11-grid-cols-5 e11-w-full e11-text-sm md:e11-text-base e11-px-4 e11-py-4 e11-border-b e11-border-skin-app-borders e11-transition e11-duration-200 e11-ease-in-out e11-cursor-pointer hover:e11-bg-skin-primary-accent/10 odd:e11-bg-skin-grey/10"
      *ngFor="let client of clients; let i = index"
      (click)="clientSelected.emit(client)"
    >
      <div class="e11-truncate">{{ client.name }}</div>
      <div class="e11-truncate">{{ client.phone }}</div>
      <div class="e11-truncate">{{ client.city }}</div>
      <div class="e11-truncate">{{ client.state }}</div>
      <span class="e11-block material-icons-outlined e11-text-skin-success" *ngIf="client.clientCustomerKey"> task_alt </span>
    </div>
  `,
                }]
        }], propDecorators: { clients: [{
                type: Input
            }], clientSelected: [{
                type: Output
            }] } });

class CustomerClientSearchComponent {
    set searchKeyPackage(keys) {
        this.algoliaConfig = {
            indexName: SEARCH_INDICES.CUSTOMER_CLIENT,
            searchClient: algoliasearch(keys.searchAppId, keys.searchKey),
        };
    }
    constructor(viewportService, customerClientService, logger) {
        this.viewportService = viewportService;
        this.customerClientService = customerClientService;
        this.logger = logger;
        this.selectedClient = new EventEmitter();
        this.addingClient = new EventEmitter();
        this.viewContext = 'search';
        this.searchParams = { hitsPerPage: 20 };
        this.showAddButton = true;
        this.mdBreakpoint$ = this.viewportService.aboveBreakpoint('md');
    }
    ngOnInit() { }
    select(client) {
        this.selectedClient.emit(client);
    }
    addingNewClient() {
        this.addingClient.emit();
    }
    refresh() {
        const REFRESH_DELAY = 5000;
        // this.logger.log('CustomerClientSearchComponent - refreshing')
        this.searchRefresh.refresh({ delayMs: REFRESH_DELAY });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientSearchComponent, deps: [{ token: i1$1.ViewportService }, { token: CustomerClientService }, { token: i1$3.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientSearchComponent, selector: "sdk-customer-client-search", inputs: { searchKeyPackage: "searchKeyPackage", showAddButton: "showAddButton" }, outputs: { selectedClient: "selectedClient", addingClient: "addingClient" }, viewQueries: [{ propertyName: "searchRefresh", first: true, predicate: ["searchRefresh"], descendants: true }], ngImport: i0, template: "<e11-loader-dots *ngIf=\"!algoliaConfig\" [color]=\"'e11-bg-skin-primary-accent'\" label=\"{{ 'Retrieving clients...' | translate }}\"></e11-loader-dots>\n\n<ng-container *ngIf=\"algoliaConfig\">\n  <ais-instantsearch #instantSearch [config]=\"algoliaConfig\">\n    <ais-configure [searchParameters]=\"searchParams\"></ais-configure>\n    <search-refresh #searchRefresh></search-refresh>\n    <div class=\"e11-w-full e11-mb-16\">\n      <ais-hits>\n        <ng-template let-hits=\"hits\" let-results=\"results\">\n          <!-- Filter / Search / CTA -->\n          <div class=\"e11-w-full e11-block md:e11-flex e11-mb-8\">\n            <div class=\"e11-grow md:e11-mr-6\">\n              <div class=\"e11-max-w-lg\">\n                <ais-search-box\n                  placeholder=\"{{ 'Search Clients' | translate }}\"\n                  submitTitle=\"string\"\n                  resetTitle=\"string\"\n                  [searchAsYouType]=\"true\"\n                ></ais-search-box>\n\n                <!-- Results count -->\n                <div *ngIf=\"results\" class=\"e11-flex e11-w-full e11-mb-2 e11-text-xs e11-text-skin-light e11-justify-end\">\n                  <ais-stats>\n                    <ng-template let-state=\"state\">\n                      {{ state.nbHits }} {{ state.nbHits === 1 ? \"record found.\" : (\"records found.\" | translate) }}\n                    </ng-template>\n                  </ais-stats>\n                </div>\n              </div>\n            </div>\n            <div class=\"e11-block md:e11-flex e11-grow md:e11-shrink md:e11-justify-end\">\n              <ng-container *ngrxLet=\"mdBreakpoint$ as mdBreakpoint\">\n                <e11-button\n                  *ngIf=\"showAddButton\"\n                  id=\"submit_formCompany\"\n                  value=\"{{ 'Add A New Client' | translate }}\"\n                  (click)=\"addingNewClient()\"\n                  [color]=\"'primary-accent'\"\n                  [display]=\"'block'\"\n                >\n                </e11-button>\n              </ng-container>\n            </div>\n          </div>\n\n          <ng-container *ngIf=\"results && hits.length\">\n            <sdk-customer-client-list [clients]=\"hits\" (clientSelected)=\"select($event)\"></sdk-customer-client-list>\n          </ng-container>\n\n          <!-- Empty State / NOT clickable -->\n          <e11-empty-state\n            *ngIf=\"results && hits.length === 0\"\n            [icon]=\"'people'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No Clients Found' | translate }}\"\n            subtitle=\"{{ 'There are either no records or nothing matching your search criteria.' | translate }}\"\n            [clickable]=\"false\"\n          >\n          </e11-empty-state>\n\n          <ais-stats>\n            <ng-template let-state=\"state\">\n              <div class=\"e11-w-full e11-mb-8\" *ngIf=\"state.nbHits && searchParams.hitsPerPage && state.nbHits > searchParams.hitsPerPage\">\n                <ais-pagination></ais-pagination>\n              </div>\n            </ng-template>\n          </ais-stats>\n        </ng-template>\n      </ais-hits>\n    </div>\n  </ais-instantsearch>\n</ng-container>\n", styles: [":host ::ng-deep .ais-Pagination{text-align:center;justify-content:center;display:flex}:host ::ng-deep .ais-Pagination-item{display:inline-block}:host ::ng-deep .ais-Pagination-item a{color:#000;float:left;padding:8px 16px;text-decoration:none;transition:background-color .3s;border:1px solid #ddd;margin:10px 0}:host ::ng-deep .ais-SearchBox-form{display:flex}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit{display:none;height:30px;line-height:normal;padding:5px 10px;border-radius:2px;border:1px solid;border-left:none}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit .ais-SearchBox-submitIcon{height:15px}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-input{display:block;padding:10px;width:100%;border-radius:2px;border:1px solid}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-reset{display:none}\n"], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: i6.NgAisInstantSearch, selector: "ais-instantsearch", inputs: ["config", "instanceName"], outputs: ["change"] }, { kind: "component", type: i6.NgAisHits, selector: "ais-hits", inputs: ["escapeHTML", "transformItems"] }, { kind: "component", type: i6.NgAisSearchBox, selector: "ais-search-box", inputs: ["placeholder", "submitTitle", "resetTitle", "searchAsYouType", "autofocus", "showLoadingIndicator"], outputs: ["submit", "reset", "change", "focus", "blur"] }, { kind: "component", type: i6.NgAisPagination, selector: "ais-pagination", inputs: ["showFirst", "showLast", "showPrevious", "showNext", "padding", "totalPages"] }, { kind: "component", type: i6.NgAisStats, selector: "ais-stats" }, { kind: "component", type: i6.NgAisConfigure, selector: "ais-configure", inputs: ["searchParameters"] }, { kind: "component", type: i7$1.RefreshComponent, selector: "search-refresh" }, { kind: "component", type: CustomerClientListComponent, selector: "sdk-customer-client-list", inputs: ["clients"], outputs: ["clientSelected"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'sdk-customer-client-search', template: "<e11-loader-dots *ngIf=\"!algoliaConfig\" [color]=\"'e11-bg-skin-primary-accent'\" label=\"{{ 'Retrieving clients...' | translate }}\"></e11-loader-dots>\n\n<ng-container *ngIf=\"algoliaConfig\">\n  <ais-instantsearch #instantSearch [config]=\"algoliaConfig\">\n    <ais-configure [searchParameters]=\"searchParams\"></ais-configure>\n    <search-refresh #searchRefresh></search-refresh>\n    <div class=\"e11-w-full e11-mb-16\">\n      <ais-hits>\n        <ng-template let-hits=\"hits\" let-results=\"results\">\n          <!-- Filter / Search / CTA -->\n          <div class=\"e11-w-full e11-block md:e11-flex e11-mb-8\">\n            <div class=\"e11-grow md:e11-mr-6\">\n              <div class=\"e11-max-w-lg\">\n                <ais-search-box\n                  placeholder=\"{{ 'Search Clients' | translate }}\"\n                  submitTitle=\"string\"\n                  resetTitle=\"string\"\n                  [searchAsYouType]=\"true\"\n                ></ais-search-box>\n\n                <!-- Results count -->\n                <div *ngIf=\"results\" class=\"e11-flex e11-w-full e11-mb-2 e11-text-xs e11-text-skin-light e11-justify-end\">\n                  <ais-stats>\n                    <ng-template let-state=\"state\">\n                      {{ state.nbHits }} {{ state.nbHits === 1 ? \"record found.\" : (\"records found.\" | translate) }}\n                    </ng-template>\n                  </ais-stats>\n                </div>\n              </div>\n            </div>\n            <div class=\"e11-block md:e11-flex e11-grow md:e11-shrink md:e11-justify-end\">\n              <ng-container *ngrxLet=\"mdBreakpoint$ as mdBreakpoint\">\n                <e11-button\n                  *ngIf=\"showAddButton\"\n                  id=\"submit_formCompany\"\n                  value=\"{{ 'Add A New Client' | translate }}\"\n                  (click)=\"addingNewClient()\"\n                  [color]=\"'primary-accent'\"\n                  [display]=\"'block'\"\n                >\n                </e11-button>\n              </ng-container>\n            </div>\n          </div>\n\n          <ng-container *ngIf=\"results && hits.length\">\n            <sdk-customer-client-list [clients]=\"hits\" (clientSelected)=\"select($event)\"></sdk-customer-client-list>\n          </ng-container>\n\n          <!-- Empty State / NOT clickable -->\n          <e11-empty-state\n            *ngIf=\"results && hits.length === 0\"\n            [icon]=\"'people'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No Clients Found' | translate }}\"\n            subtitle=\"{{ 'There are either no records or nothing matching your search criteria.' | translate }}\"\n            [clickable]=\"false\"\n          >\n          </e11-empty-state>\n\n          <ais-stats>\n            <ng-template let-state=\"state\">\n              <div class=\"e11-w-full e11-mb-8\" *ngIf=\"state.nbHits && searchParams.hitsPerPage && state.nbHits > searchParams.hitsPerPage\">\n                <ais-pagination></ais-pagination>\n              </div>\n            </ng-template>\n          </ais-stats>\n        </ng-template>\n      </ais-hits>\n    </div>\n  </ais-instantsearch>\n</ng-container>\n", styles: [":host ::ng-deep .ais-Pagination{text-align:center;justify-content:center;display:flex}:host ::ng-deep .ais-Pagination-item{display:inline-block}:host ::ng-deep .ais-Pagination-item a{color:#000;float:left;padding:8px 16px;text-decoration:none;transition:background-color .3s;border:1px solid #ddd;margin:10px 0}:host ::ng-deep .ais-SearchBox-form{display:flex}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit{display:none;height:30px;line-height:normal;padding:5px 10px;border-radius:2px;border:1px solid;border-left:none}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-submit .ais-SearchBox-submitIcon{height:15px}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-input{display:block;padding:10px;width:100%;border-radius:2px;border:1px solid}:host ::ng-deep .ais-SearchBox-form .ais-SearchBox-reset{display:none}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ViewportService }, { type: CustomerClientService }, { type: i1$3.E11Logger }], propDecorators: { selectedClient: [{
                type: Output
            }], addingClient: [{
                type: Output
            }], searchRefresh: [{
                type: ViewChild,
                args: ['searchRefresh']
            }], searchKeyPackage: [{
                type: Input
            }], showAddButton: [{
                type: Input
            }] } });

class PlatformAdminClientComponent {
    set customerKey(customerKey) {
        this.getSearchKey(customerKey);
    }
    constructor(platformAdminSearchKeyService) {
        this.platformAdminSearchKeyService = platformAdminSearchKeyService;
        this.destroy$ = new Subject();
    }
    getSearchKey(customerKey) {
        this.platformAdminSearchKeyService
            .clientSearchKeyPackage(customerKey)
            .pipe(takeUntil(this.destroy$))
            .subscribe((result) => {
            this.searchKeyPackage = result;
        });
    }
    ngOnInit() { }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    addClicked() {
        // Do Nothing
    }
    select(client) {
        this.selectedClient = client;
        this.clientDetailModal.open();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminClientComponent, deps: [{ token: PlatformAdminSearchKeyService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PlatformAdminClientComponent, selector: "sdk-customer-admin-clients", inputs: { customerKey: "customerKey" }, viewQueries: [{ propertyName: "clientDetailModal", first: true, predicate: ["clientDetail"], descendants: true }], ngImport: i0, template: `
    <sdk-customer-client-search
      #clientSearch
      *ngIf="searchKeyPackage"
      [searchKeyPackage]="searchKeyPackage"
      [showAddButton]="false"
      (selectedClient)="select($event)"
      (addingClient)="addClicked()"
    ></sdk-customer-client-search>
    <e11-modal
      #clientDetail
      [darkMode]="false"
      [bodyClassOverrides]="'!e11-p-0'"
      [modalClassOverrides]="'e11-p-0'"
      [contentClassOverrides]="'e11-p-0'"
      [title]="'Client Details' | translate"
      [showHeader]="false"
      [showFooter]="false"
      [hideCloseButton]="false"
      [closer]="true"
      [width]="'sm'"
    >
      <div modal-body>
        <ng-container *ngIf="selectedClient">
          <div class="e11-bg-white e11-max-w-2xl e11-shadow e11-overflow-hidden e11-rounded-lg">
            <div class="e11-px-4 e11-py-4 sm:e11-px-6 e11-flex e11-items-center">
              <img
                *ngIf="selectedClient.logoImageURL"
                class="e11-w-16 e11-h-16 e11-rounded-full e11-mr-4"
                [src]="selectedClient.logoImageURL"
                [alt]="'Logo of ' + selectedClient.name"
              />
              <div>
                <h3 class="e11-text-lg e11-leading-6 e11-font-medium e11-text-gray-900">{{ selectedClient.name }}</h3>
                <div class="e11-mt-1 e11-max-w-2xl e11-text-sm e11-text-gray-500 e11-flex e11-gap-2">
                  <span
                    *ngIf="selectedClient.industry"
                    class="e11-inline-flex e11-items-center e11-rounded-md e11-bg-gray-50 e11-px-2 e11-py-1 e11-text-xs e11-font-medium e11-text-gray-600 e11-ring-1 e11-ring-inset e11-ring-gray-500/10"
                  >
                    {{ selectedClient.industry }}</span
                  >
                  <span
                    *ngIf="selectedClient.industryGroup"
                    class="e11-inline-flex e11-items-center e11-rounded-md e11-bg-gray-50 e11-px-2 e11-py-1 e11-text-xs e11-font-medium e11-text-gray-600 e11-ring-1 e11-ring-inset e11-ring-gray-500/10"
                  >
                    {{ selectedClient.industryGroup }}
                  </span>
                  <span
                    *ngIf="selectedClient.businessClassification"
                    class="e11-inline-flex e11-items-center e11-rounded-md e11-bg-skin-blue-50 e11-px-2 e11-py-1 e11-text-xs e11-font-medium e11-text-skin-primary e11-ring-1 e11-ring-inset e11-ring-blue-700/10"
                  >
                    {{ selectedClient.businessClassification }}</span
                  >
                  <span
                    *ngIf="selectedClient.businessSizeRange"
                    class="e11-inline-flex e11-items-center e11-rounded-md e11-bg-skin-blue-50 e11-px-2 e11-py-1 e11-text-xs e11-font-medium e11-text-skin-primary e11-ring-1 e11-ring-inset e11-ring-blue-700/10"
                  >
                    {{ selectedClient.businessSizeRange + ' (Size)' }}</span
                  >
                </div>
              </div>
            </div>
            <div class="e11-border-t e11-border-gray-200">
              <dl>
                <div class="e11-bg-gray-50 e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Address' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">
                    {{ selectedClient.address }} {{ selectedClient.address2 }} {{ selectedClient.city }} {{ selectedClient.state }}
                    {{ selectedClient.zip }}
                  </dd>
                </div>
                <div class="e11-bg-white e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Phone number' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">{{ selectedClient.phone || '-' }}</dd>
                </div>
                <div class="e11-bg-gray-50 e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Website' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">{{ selectedClient.websiteURL || '-' }}</dd>
                </div>
                <div class="e11-bg-white e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Created' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">
                    {{ (selectedClient.__createdAt | date) || '-' }}
                  </dd>
                </div>
                <div class="e11-bg-gray-50 e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Updated' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">
                    {{ (selectedClient.__createdAt | date) || '-' }}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </ng-container>
      </div>
    </e11-modal>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "component", type: CustomerClientSearchComponent, selector: "sdk-customer-client-search", inputs: ["searchKeyPackage", "showAddButton"], outputs: ["selectedClient", "addingClient"] }, { kind: "pipe", type: i1$2.DatePipe, name: "date" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PlatformAdminClientComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-admin-clients',
                    template: `
    <sdk-customer-client-search
      #clientSearch
      *ngIf="searchKeyPackage"
      [searchKeyPackage]="searchKeyPackage"
      [showAddButton]="false"
      (selectedClient)="select($event)"
      (addingClient)="addClicked()"
    ></sdk-customer-client-search>
    <e11-modal
      #clientDetail
      [darkMode]="false"
      [bodyClassOverrides]="'!e11-p-0'"
      [modalClassOverrides]="'e11-p-0'"
      [contentClassOverrides]="'e11-p-0'"
      [title]="'Client Details' | translate"
      [showHeader]="false"
      [showFooter]="false"
      [hideCloseButton]="false"
      [closer]="true"
      [width]="'sm'"
    >
      <div modal-body>
        <ng-container *ngIf="selectedClient">
          <div class="e11-bg-white e11-max-w-2xl e11-shadow e11-overflow-hidden e11-rounded-lg">
            <div class="e11-px-4 e11-py-4 sm:e11-px-6 e11-flex e11-items-center">
              <img
                *ngIf="selectedClient.logoImageURL"
                class="e11-w-16 e11-h-16 e11-rounded-full e11-mr-4"
                [src]="selectedClient.logoImageURL"
                [alt]="'Logo of ' + selectedClient.name"
              />
              <div>
                <h3 class="e11-text-lg e11-leading-6 e11-font-medium e11-text-gray-900">{{ selectedClient.name }}</h3>
                <div class="e11-mt-1 e11-max-w-2xl e11-text-sm e11-text-gray-500 e11-flex e11-gap-2">
                  <span
                    *ngIf="selectedClient.industry"
                    class="e11-inline-flex e11-items-center e11-rounded-md e11-bg-gray-50 e11-px-2 e11-py-1 e11-text-xs e11-font-medium e11-text-gray-600 e11-ring-1 e11-ring-inset e11-ring-gray-500/10"
                  >
                    {{ selectedClient.industry }}</span
                  >
                  <span
                    *ngIf="selectedClient.industryGroup"
                    class="e11-inline-flex e11-items-center e11-rounded-md e11-bg-gray-50 e11-px-2 e11-py-1 e11-text-xs e11-font-medium e11-text-gray-600 e11-ring-1 e11-ring-inset e11-ring-gray-500/10"
                  >
                    {{ selectedClient.industryGroup }}
                  </span>
                  <span
                    *ngIf="selectedClient.businessClassification"
                    class="e11-inline-flex e11-items-center e11-rounded-md e11-bg-skin-blue-50 e11-px-2 e11-py-1 e11-text-xs e11-font-medium e11-text-skin-primary e11-ring-1 e11-ring-inset e11-ring-blue-700/10"
                  >
                    {{ selectedClient.businessClassification }}</span
                  >
                  <span
                    *ngIf="selectedClient.businessSizeRange"
                    class="e11-inline-flex e11-items-center e11-rounded-md e11-bg-skin-blue-50 e11-px-2 e11-py-1 e11-text-xs e11-font-medium e11-text-skin-primary e11-ring-1 e11-ring-inset e11-ring-blue-700/10"
                  >
                    {{ selectedClient.businessSizeRange + ' (Size)' }}</span
                  >
                </div>
              </div>
            </div>
            <div class="e11-border-t e11-border-gray-200">
              <dl>
                <div class="e11-bg-gray-50 e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Address' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">
                    {{ selectedClient.address }} {{ selectedClient.address2 }} {{ selectedClient.city }} {{ selectedClient.state }}
                    {{ selectedClient.zip }}
                  </dd>
                </div>
                <div class="e11-bg-white e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Phone number' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">{{ selectedClient.phone || '-' }}</dd>
                </div>
                <div class="e11-bg-gray-50 e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Website' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">{{ selectedClient.websiteURL || '-' }}</dd>
                </div>
                <div class="e11-bg-white e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Created' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">
                    {{ (selectedClient.__createdAt | date) || '-' }}
                  </dd>
                </div>
                <div class="e11-bg-gray-50 e11-px-4 e11-py-4 sm:e11-grid sm:e11-grid-cols-3 e11-gap-4 sm:e11-px-6">
                  <dt class="e11-text-sm e11-font-medium e11-text-gray-500">{{ 'Updated' | translate }}</dt>
                  <dd class="e11-mt-1 e11-text-sm e11-text-gray-900 sm:e11-mt-0 sm:e11-col-span-2">
                    {{ (selectedClient.__createdAt | date) || '-' }}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </ng-container>
      </div>
    </e11-modal>

    <ng-template #loading>
      <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: PlatformAdminSearchKeyService }], propDecorators: { clientDetailModal: [{
                type: ViewChild,
                args: ['clientDetail']
            }], customerKey: [{
                type: Input
            }] } });

const initialState$1 = {
    clientLoading: false,
    clientCustomerLoaded: false,
    addingClient: false,
    updatingClient: false,
};
class CustomerClientStore extends ComponentStore {
    constructor(logger, errorHandler, customerClientService, notificationService) {
        super(initialState$1);
        this.logger = logger;
        this.errorHandler = errorHandler;
        this.customerClientService = customerClientService;
        this.notificationService = notificationService;
        this.clientAdded$ = new Subject();
        this.clientUpdated$ = new Subject();
        // selectors
        this.state$ = this.select((s) => s);
        this.selectedClient$ = this.select((s) => s.selectedClient);
        this.clientLoading$ = this.select((s) => s.clientLoading);
        this.selectedCustomer$ = this.select((s) => s.clientCustomer);
        this.customerLoaded$ = this.select((s) => s.clientCustomerLoaded);
        this.addingClient$ = this.select((s) => s.addingClient);
        this.updatingClient$ = this.select((s) => s.updatingClient);
        this.getState = this.select((s) => s);
        /** This will force a fetch for the clientId, regardless of whether it has already been fetched */
        this.getClient = this.effect((id$) => id$.pipe(tap((id) => (id ? null : this.clearSelected())), filter$1(isNotNil), switchMap((id) => {
            this.setClientLoading(true);
            return this.customerClientService.get(id).pipe(tapResponse((client) => {
                this.setClientLoading(false);
                this.setSelectedClient(client);
            }, (e) => {
                this.setClientLoading(false);
                this.errorHandler.handleError(e);
                this.notificationService.popNotificationFromError(e, { title: 'Could not load client record' });
            }));
        })));
        /** Call this if you do not want to re-fetch if you already have the client selected */
        this.getClientIfDistinct = this.effect((id$) => id$.pipe(distinctUntilChanged(), withLatestFrom(this.selectedClient$), tap(([id, currentClient]) => {
            if (id && id === currentClient?.id)
                return;
            this.getClient(id);
        })));
        this.addClient = this.effect((client$) => client$.pipe(switchMap((client) => {
            this.setAddingClient(true);
            return this.customerClientService.add(client).pipe(tapResponse((client) => {
                this.clientAdded$.next(client);
                this.setSelectedClient(client);
                this.notifySuccess(`${client.name} was added`);
            }, (err) => this.errorHandler.handleError(err, { alertUser: true })), finalize$1(() => this.setAddingClient(false)));
        })));
        this.updateClient = this.effect((client$) => client$.pipe(switchMap((client) => {
            this.setUpdatingClient(true);
            return this.customerClientService.update(client).pipe(tapResponse((response) => {
                const newClientData = { ...client, ...response }; // Need to merge current state and response - not all fields can be updated, but we don't want all fields overwritten
                this.clientUpdated$.next(newClientData);
                this.setSelectedClient(newClientData);
                this.notifySuccess(`${newClientData.name} was updated`);
            }, (err) => this.errorHandler.handleError(err, { alertUser: true })), finalize$1(() => this.setUpdatingClient(false)));
        })));
        /** ! Creates subscription to selectedClient$ - should only run once unless refactored */
        this.loadCustomer = this.effect((_$) => _$.pipe(mergeMap(() => this.selectedClient$), tap((customerClient) => {
            if (!customerClient?.clientCustomerKey)
                return this.setSelectedClientCustomer(undefined);
            this.logger.log('CustomerClientStore - loadCustomer', customerClient.id, customerClient.clientCustomerKey);
            return this.getCustomerForClient({ clientId: customerClient.id, clientCustomerKey: customerClient.clientCustomerKey });
        })));
        this.getCustomerForClient = this.effect((req$) => req$.pipe(switchMap((req) => {
            this.setCustomerLoaded(false);
            return this.customerClientService.getCustomer(req.clientId, req.clientCustomerKey).pipe(tapResponse((customer) => {
                this.setSelectedClientCustomer(customer);
            }, (e) => {
                this.errorHandler.handleError(e);
                this.notificationService.popNotificationFromError(e, { title: 'Could not load customer record' });
            }), finalize$1(() => this.setCustomerLoaded(true)));
        })));
        // Updaters
        this.setSelectedClient = this.updater((state, selectedClient) => ({ ...state, selectedClient }));
        this.setSelectedClientCustomer = this.updater((state, customer) => ({
            ...state,
            clientCustomer: customer,
            clientCustomerLoaded: true,
        }));
        this.clearSelected = this.updater((state) => ({ ...state, selectedClient: undefined, clientCustomer: undefined }));
        this.setClientLoading = this.updater((state, clientLoading) => ({ ...state, clientLoading }));
        this.setAddingClient = this.updater((state, addingClient) => ({ ...state, addingClient }));
        this.setUpdatingClient = this.updater((state, updatingClient) => ({ ...state, updatingClient }));
        this.setCustomerLoaded = this.updater((state, clientCustomerLoaded) => ({ ...state, clientCustomerLoaded }));
        this.loadCustomer();
    }
    notifySuccess(text) {
        const message = { title: 'Success', message: text, type: 'success', autoClose: true, dismissOnRouteChange: false };
        this.notificationService.popNotification(message);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientStore, deps: [{ token: i1$3.E11Logger }, { token: i1$3.E11ErrorHandlerService }, { token: CustomerClientService }, { token: i2$5.NotificationService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$3.E11Logger }, { type: i1$3.E11ErrorHandlerService }, { type: CustomerClientService }, { type: i2$5.NotificationService }] });

class CustomerClientDepartmentsComponent {
    set clientId(clientId) {
        this._clientId = clientId;
        this.clientStore.getClientIfDistinct(clientId);
        this.departmentStore.loadAllItems(clientId);
    }
    constructor(clientStore, departmentStore, permissionStore) {
        this.clientStore = clientStore;
        this.departmentStore = departmentStore;
        this.permissionStore = permissionStore;
        this.suppressHeader = false;
        this.departments$ = this.departmentStore.allItems$;
        this.client$ = this.clientStore.selectedClient$;
        this.selectedDepartment$ = this.departmentStore.selectedItem$.pipe(map$1((department) => department));
        this.loaded$ = this.departmentStore.loaded$;
        this.canEdit$ = this.permissionStore.userPermissions$.pipe(map$1((permissions) => permissions?.has(CustomerPermissions.EditClient) ?? false));
    }
    ngOnInit() { }
    ngOnDestroy() { }
    select(department) {
        this.departmentStore.selectItem(department);
        this.editDepartmentModal.open();
    }
    deselect() {
        this.departmentStore.selectItem(undefined);
        this.editDepartmentModal.close();
    }
    cancelEdit() {
        this.deselect();
    }
    addClicked() {
        this.departmentStore.selectItem(undefined);
        this.editDepartmentModal.open();
    }
    update(department) {
        const casted = department;
        if (!this._clientId) {
            throw e11Error({ title: 'Invalid configuration', message: 'No client Id', type: 'customer/no-client-id' });
        }
        this.departmentStore.update(casted);
        this.deselect();
    }
    add(department, client) {
        if (!client) {
            throw e11Error({ title: 'No Client Selected', message: 'No client selected', type: 'customer/no-client-selected' });
        }
        const clientDepartment = { ...department, clientId: client.id, customerKey: client.customerKey };
        this.departmentStore.add(clientDepartment);
        this.deselect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDepartmentsComponent, deps: [{ token: CustomerClientStore }, { token: CustomerClientDepartmentStore }, { token: i3$1.PermissionStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientDepartmentsComponent, selector: "sdk-customer-client-departments", inputs: { suppressHeader: "suppressHeader", clientId: "clientId" }, viewQueries: [{ propertyName: "editDepartmentModal", first: true, predicate: ["editDepartment"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else departments" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #departments>
      <ng-container *ngrxLet="client$ as client">
        <sdk-customer-list-header
          *ngIf="!suppressHeader"
          [headerText]="'Manage Departments'"
          [buttonText]="'Add Department'"
          [disabled]="(canEdit$ | async) === false"
          (addClicked)="addClicked()"
        ></sdk-customer-list-header>
        <sdk-department-list
          [departments]="(departments$ | async) ?? undefined"
          [disabled]="(canEdit$ | async) === false"
          (departmentSelected)="select($event)"
          (addDepartmentClicked)="addClicked()"
        ></sdk-department-list>

        <e11-modal #editDepartment [title]="'Manage Department' | translate" [showHeader]="true" [width]="'lg'" [bodyHeight]="'auto'">
          <div modal-body>
            <sdk-form-department
              [department]="(selectedDepartment$ | async) ?? undefined"
              (cancelled)="cancelEdit()"
              (departmentAdded)="add($event, client)"
              (departmentUpdated)="update($event)"
            ></sdk-form-department>
          </div>

          <div modal-footer>
            <div class="e11-flex e11-justify-start e11-font-bold">{{ client?.name }}</div>
          </div>
        </e11-modal>
      </ng-container>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: FormDepartmentDetailComponent, selector: "sdk-form-department", inputs: ["activeInfo", "department"], outputs: ["departmentAdded", "departmentUpdated", "cancelled"] }, { kind: "component", type: CompanyDepartmentsListComponent, selector: "sdk-department-list", inputs: ["departments", "disabled", "disabledText"], outputs: ["departmentSelected", "addDepartmentClicked"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDepartmentsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-departments',
                    template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else departments" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #departments>
      <ng-container *ngrxLet="client$ as client">
        <sdk-customer-list-header
          *ngIf="!suppressHeader"
          [headerText]="'Manage Departments'"
          [buttonText]="'Add Department'"
          [disabled]="(canEdit$ | async) === false"
          (addClicked)="addClicked()"
        ></sdk-customer-list-header>
        <sdk-department-list
          [departments]="(departments$ | async) ?? undefined"
          [disabled]="(canEdit$ | async) === false"
          (departmentSelected)="select($event)"
          (addDepartmentClicked)="addClicked()"
        ></sdk-department-list>

        <e11-modal #editDepartment [title]="'Manage Department' | translate" [showHeader]="true" [width]="'lg'" [bodyHeight]="'auto'">
          <div modal-body>
            <sdk-form-department
              [department]="(selectedDepartment$ | async) ?? undefined"
              (cancelled)="cancelEdit()"
              (departmentAdded)="add($event, client)"
              (departmentUpdated)="update($event)"
            ></sdk-form-department>
          </div>

          <div modal-footer>
            <div class="e11-flex e11-justify-start e11-font-bold">{{ client?.name }}</div>
          </div>
        </e11-modal>
      </ng-container>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerClientStore }, { type: CustomerClientDepartmentStore }, { type: i3$1.PermissionStore }], propDecorators: { suppressHeader: [{
                type: Input
            }], clientId: [{
                type: Input
            }], editDepartmentModal: [{
                type: ViewChild,
                args: ['editDepartment']
            }] } });

var ClientPages;
(function (ClientPages) {
    ClientPages["Search"] = "Search";
    ClientPages["Detail"] = "Detail";
    ClientPages["Logo"] = "Logo";
    ClientPages["Departments"] = "Departments";
    ClientPages["Locations"] = "Locations";
    ClientPages["Contacts"] = "Contacts";
    // Account = 'Account',
})(ClientPages || (ClientPages = {}));
class CustomerClientNavigationService {
    constructor(route, router) {
        this.route = route;
        this.router = router;
        this.clientId$ = this.route.queryParams.pipe(map$1((qps) => qps.clientId));
        this.clientPage$ = this.route.queryParams.pipe(map$1((qps) => (isValidPage(qps.clientPage) ? qps.clientPage : ClientPages.Search)));
    }
    toClient(clientId) {
        const queryParams = { clientId, clientPage: ClientPages.Detail };
        this.updateQueryParams(queryParams);
    }
    toPage(clientPage) {
        const queryParams = clientPage === ClientPages.Search ? { clientPage, clientId: undefined } : { clientPage };
        this.updateQueryParams(queryParams);
    }
    updateQueryParams(queryParams) {
        this.router.navigate([], { relativeTo: this.route, queryParams, queryParamsHandling: 'merge' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientNavigationService, deps: [{ token: i2$1.ActivatedRoute }, { token: i2$1.Router }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientNavigationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientNavigationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i2$1.ActivatedRoute }, { type: i2$1.Router }] });
function isValidPage(page) {
    return getEnumValues(ClientPages).includes(page);
}

class CustomerClientImageDataNotFoundComponent {
    constructor(logger) {
        this.logger = logger;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientImageDataNotFoundComponent, deps: [{ token: i1$3.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientImageDataNotFoundComponent, selector: "sdk-customer-client-image-data-not-found", ngImport: i0, template: `
    <div class="e11-mb-8 e11-p-6">
      <svg
        class="e11-text-skin-primary-accent"
        fill="currentColor"
        stroke="currentColor"
        width="327px"
        height="144px"
        viewBox="0 0 327 144"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="Glasses">
          <g id="Medium-Copy-2" transform="translate(-264, -325)">
            <g id="Group" transform="translate(264, 325)">
              <g id="Combined-Shape-2">
                <path
                  d="M72,0 C111.764502,0 144,32.235498 144,72 C144,111.764502 111.764502,144 72,144 C32.235498,144 0,111.764502 0,72 C0,32.235498 32.235498,0 72,0 Z M72,8.38095238 C36.8641702,8.38095238 8.38095238,36.8641702 8.38095238,72 C8.38095238,107.13583 36.8641702,135.619048 72,135.619048 C107.13583,135.619048 135.619048,107.13583 135.619048,72 C135.619048,36.8641702 107.13583,8.38095238 72,8.38095238 Z"
                  id="Combined-Shape"
                ></path>
              </g>
              <path
                d="M164.500199,51 C179.566825,51 191.80373,63.5014541 192.000003,79.000004 L185.40187,79 C185.40187,67.297534 176.208049,57.8108108 164.866895,57.8108108 C153.525742,57.8108108 144.331921,67.297534 144.331921,79 L137.001,79 L137.001686,78.90909 C137.244552,63.4525947 149.463045,51 164.500199,51 Z"
                id="Combined-Shape"
              ></path>
              <g id="Combined-Shape-2" transform="translate(183, 0)">
                <path
                  d="M72,0 C111.764502,0 144,32.235498 144,72 C144,111.764502 111.764502,144 72,144 C32.235498,144 0,111.764502 0,72 C0,32.235498 32.235498,0 72,0 Z M72,8.38095238 C36.8641702,8.38095238 8.38095238,36.8641702 8.38095238,72 C8.38095238,107.13583 36.8641702,135.619048 72,135.619048 C107.13583,135.619048 135.619048,107.13583 135.619048,72 C135.619048,36.8641702 107.13583,8.38095238 72,8.38095238 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientImageDataNotFoundComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-image-data-not-found',
                    template: `
    <div class="e11-mb-8 e11-p-6">
      <svg
        class="e11-text-skin-primary-accent"
        fill="currentColor"
        stroke="currentColor"
        width="327px"
        height="144px"
        viewBox="0 0 327 144"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="Glasses">
          <g id="Medium-Copy-2" transform="translate(-264, -325)">
            <g id="Group" transform="translate(264, 325)">
              <g id="Combined-Shape-2">
                <path
                  d="M72,0 C111.764502,0 144,32.235498 144,72 C144,111.764502 111.764502,144 72,144 C32.235498,144 0,111.764502 0,72 C0,32.235498 32.235498,0 72,0 Z M72,8.38095238 C36.8641702,8.38095238 8.38095238,36.8641702 8.38095238,72 C8.38095238,107.13583 36.8641702,135.619048 72,135.619048 C107.13583,135.619048 135.619048,107.13583 135.619048,72 C135.619048,36.8641702 107.13583,8.38095238 72,8.38095238 Z"
                  id="Combined-Shape"
                ></path>
              </g>
              <path
                d="M164.500199,51 C179.566825,51 191.80373,63.5014541 192.000003,79.000004 L185.40187,79 C185.40187,67.297534 176.208049,57.8108108 164.866895,57.8108108 C153.525742,57.8108108 144.331921,67.297534 144.331921,79 L137.001,79 L137.001686,78.90909 C137.244552,63.4525947 149.463045,51 164.500199,51 Z"
                id="Combined-Shape"
              ></path>
              <g id="Combined-Shape-2" transform="translate(183, 0)">
                <path
                  d="M72,0 C111.764502,0 144,32.235498 144,72 C144,111.764502 111.764502,144 72,144 C32.235498,144 0,111.764502 0,72 C0,32.235498 32.235498,0 72,0 Z M72,8.38095238 C36.8641702,8.38095238 8.38095238,36.8641702 8.38095238,72 C8.38095238,107.13583 36.8641702,135.619048 72,135.619048 C107.13583,135.619048 135.619048,107.13583 135.619048,72 C135.619048,36.8641702 107.13583,8.38095238 72,8.38095238 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$3.E11Logger }] });

class CustomerClientDataNotFoundComponent {
    constructor(logger, navigationService) {
        this.logger = logger;
        this.navigationService = navigationService;
    }
    ngOnInit() { }
    backToSearch() {
        this.navigationService.toPage(ClientPages.Search);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDataNotFoundComponent, deps: [{ token: i1$3.E11Logger }, { token: CustomerClientNavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientDataNotFoundComponent, selector: "sdk-customer-client-data-not-found", ngImport: i0, template: `
    <div class="view e11-flex e11-flex-col e11-justify-center e11-pt-12">
      <div class="sm:e11-mx-auto sm:e11-w-full sm:e11-max-w-md">
        <e11-panel [hasBorder]="true" [hasShadow]="false" [bgOpacity]="90">
          <div class="e11-flex-inline e11-items-center e11-justify-center e11-text-center">
            <div class="e11-flex e11-flex-col e11-items-center e11-p-4">
              <h2 class="e11-mb-2">{{ 'OH NO!' | translate }}</h2>
              <h2 class="e11-mb-8 e11-font-extrabold">{{ "We can't find what you're looking for." | translate }}</h2>

              <sdk-customer-client-image-data-not-found></sdk-customer-client-image-data-not-found>
              <p class="e11-text-sm">
                {{ 'It appears the link or address you used is invalid. Please check your link or URL again.' | translate }}
              </p>
            </div>
          </div>
        </e11-panel>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "component", type: i5$1.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: CustomerClientImageDataNotFoundComponent, selector: "sdk-customer-client-image-data-not-found" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDataNotFoundComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-data-not-found',
                    template: `
    <div class="view e11-flex e11-flex-col e11-justify-center e11-pt-12">
      <div class="sm:e11-mx-auto sm:e11-w-full sm:e11-max-w-md">
        <e11-panel [hasBorder]="true" [hasShadow]="false" [bgOpacity]="90">
          <div class="e11-flex-inline e11-items-center e11-justify-center e11-text-center">
            <div class="e11-flex e11-flex-col e11-items-center e11-p-4">
              <h2 class="e11-mb-2">{{ 'OH NO!' | translate }}</h2>
              <h2 class="e11-mb-8 e11-font-extrabold">{{ "We can't find what you're looking for." | translate }}</h2>

              <sdk-customer-client-image-data-not-found></sdk-customer-client-image-data-not-found>
              <p class="e11-text-sm">
                {{ 'It appears the link or address you used is invalid. Please check your link or URL again.' | translate }}
              </p>
            </div>
          </div>
        </e11-panel>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: i1$3.E11Logger }, { type: CustomerClientNavigationService }] });

class CustomerClientDetailComponent extends E11TemplateMap {
    set clientId(id) {
        this.store.getClientIfDistinct(id);
        this._clientId = id;
    }
    constructor(configProvider, store, permissionStore, logger) {
        super();
        this.configProvider = configProvider;
        this.store = store;
        this.permissionStore = permissionStore;
        this.logger = logger;
        this.cancelText = 'Back to search';
        this.clientUpdated = new EventEmitter();
        this.clientAdded = new EventEmitter();
        this.clientCancelled = new EventEmitter();
        this.disabledText = EDIT_CLIENT_PERMISSION_MISSING;
        this.selectedClient$ = this.store.selectedClient$;
        this.clientCustomer$ = this.store.selectedCustomer$;
        this.customerKey$ = this.configProvider.config.customerKey$.pipe(filter$1(isNotNil));
        this.loading$ = this.store.clientLoading$;
        this.loadingSubmit$ = combineLatest([this.store.addingClient$, this.store.updatingClient$]).pipe(map$1((loaders) => loaders.some((loading) => loading)));
        this.canEdit$ = this.permissionStore.userPermissions$.pipe(map$1((permissions) => permissions?.has(CustomerPermissions.EditClient) ?? false));
    }
    ngOnInit() { }
    async updated(editableClient) {
        this.store.updateClient(editableClient);
        const updatedClient = await firstValueFrom(this.store.clientUpdated$);
        this.logger.log({ updatedClient });
        this.clientUpdated.emit(updatedClient);
    }
    async added(editableClient) {
        const customerKey = await firstValueFrom(this.customerKey$);
        if (!customerKey)
            throw e11Error({ title: 'Error', message: 'No customer key found', type: 'customer/no-customer-key' });
        const client = editableClient;
        client.customerKey = customerKey;
        this.store.addClient(client);
        const clientAdded = await firstValueFrom(this.store.clientAdded$);
        this.logger.log({ clientAdded });
        this.clientAdded.emit(clientAdded);
    }
    cancelled() {
        this.clientCancelled.emit(true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDetailComponent, deps: [{ token: BaseCustomerConfigProvider }, { token: CustomerClientStore }, { token: i3$1.PermissionStore }, { token: i1$3.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientDetailComponent, selector: "sdk-customer-client-detail", inputs: { clientId: "clientId", cancelText: "cancelText" }, outputs: { clientUpdated: "clientUpdated", clientAdded: "clientAdded", clientCancelled: "clientCancelled" }, usesInheritance: true, ngImport: i0, template: `
    <ng-container *ngrxLet="loading$ as loading">
      <ng-container *ngrxLet="selectedClient$ as selectedClient">
        <ng-container *ngIf="!loading && !selectedClient && _clientId">
          <sdk-customer-client-data-not-found></sdk-customer-client-data-not-found>
        </ng-container>
        <sdk-form-company-detail
          *ngIf="selectedClient || !_clientId || loading"
          [business]="selectedClient"
          [cancelText]="cancelText"
          [loading]="loading"
          [loadingSubmit]="(loadingSubmit$ | async) ?? false"
          [disabled]="(canEdit$ | async) === false"
          [disabledText]="disabledText"
          [isClient]="true"
          (cancelled)="cancelled()"
          (companyUpdated)="updated($event)"
          (companyAdded)="added($event)"
        ></sdk-form-company-detail>
      </ng-container>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: FormCompanyDetailComponent, selector: "sdk-form-company-detail", inputs: ["business", "loading", "loadingSubmit", "cancelText", "disabled", "disabledText", "isClient"], outputs: ["companyAdded", "companyUpdated", "cancelled"] }, { kind: "component", type: CustomerClientDataNotFoundComponent, selector: "sdk-customer-client-data-not-found" }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientDetailComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-detail',
                    template: `
    <ng-container *ngrxLet="loading$ as loading">
      <ng-container *ngrxLet="selectedClient$ as selectedClient">
        <ng-container *ngIf="!loading && !selectedClient && _clientId">
          <sdk-customer-client-data-not-found></sdk-customer-client-data-not-found>
        </ng-container>
        <sdk-form-company-detail
          *ngIf="selectedClient || !_clientId || loading"
          [business]="selectedClient"
          [cancelText]="cancelText"
          [loading]="loading"
          [loadingSubmit]="(loadingSubmit$ | async) ?? false"
          [disabled]="(canEdit$ | async) === false"
          [disabledText]="disabledText"
          [isClient]="true"
          (cancelled)="cancelled()"
          (companyUpdated)="updated($event)"
          (companyAdded)="added($event)"
        ></sdk-form-company-detail>
      </ng-container>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: BaseCustomerConfigProvider }, { type: CustomerClientStore }, { type: i3$1.PermissionStore }, { type: i1$3.E11Logger }], propDecorators: { clientId: [{
                type: Input
            }], cancelText: [{
                type: Input
            }], clientUpdated: [{
                type: Output
            }], clientAdded: [{
                type: Output
            }], clientCancelled: [{
                type: Output
            }] } });

const pageToTextMap = {
    [ClientPages.Search]: 'Search',
    [ClientPages.Detail]: 'Detail',
    [ClientPages.Logo]: 'Logo',
    [ClientPages.Departments]: 'Departments',
    [ClientPages.Contacts]: 'Contacts',
    [ClientPages.Locations]: 'Locations',
    // [ClientPages.Account]: 'Account',
};
class CustomerClientNavUIComponent {
    constructor() {
        this.pageToTextMap = pageToTextMap;
        this.ClientPages = ClientPages;
        this.currentPage = ClientPages.Search;
        this.maintainEnumOrder = (a, b) => {
            return 0;
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientNavUIComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientNavUIComponent, selector: "sdk-customer-client-nav-ui", inputs: { clientId: "clientId", currentPage: "currentPage" }, ngImport: i0, template: `
    <ng-container *ngFor="let page of ClientPages | keyvalue: maintainEnumOrder">
      <e11-nav-item
        *ngIf="page.value === ClientPages.Search || clientId"
        [nav]="{
          name: pageToTextMap[page.value] | translate,
          route: [],
          navigationExtras: {
            queryParams: {
              clientPage: page.value,
              clientId: page.value === ClientPages.Search ? undefined : clientId
            },
            queryParamsHandling: 'merge'
          }
        }"
      ></e11-nav-item>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$6.E11NavItemComponent, selector: "e11-nav-item", inputs: ["e11TemplateMap", "nav", "isChildren", "iconOnly"], outputs: ["close"] }, { kind: "pipe", type: i1$2.KeyValuePipe, name: "keyvalue" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientNavUIComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-nav-ui',
                    template: `
    <ng-container *ngFor="let page of ClientPages | keyvalue: maintainEnumOrder">
      <e11-nav-item
        *ngIf="page.value === ClientPages.Search || clientId"
        [nav]="{
          name: pageToTextMap[page.value] | translate,
          route: [],
          navigationExtras: {
            queryParams: {
              clientPage: page.value,
              clientId: page.value === ClientPages.Search ? undefined : clientId
            },
            queryParamsHandling: 'merge'
          }
        }"
      ></e11-nav-item>
    </ng-container>
  `,
                }]
        }], propDecorators: { clientId: [{
                type: Input
            }], currentPage: [{
                type: Input
            }] } });

class CustomerClientNavigationComponent {
    constructor(navigationService) {
        this.navigationService = navigationService;
        this.ClientPages = ClientPages;
        this.clientId$ = this.navigationService.clientId$;
        this.clientPage$ = this.navigationService.clientPage$;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientNavigationComponent, deps: [{ token: CustomerClientNavigationService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientNavigationComponent, selector: "sdk-customer-client-navigation", ngImport: i0, template: `
    <ng-container *ngrxLet="clientPage$ as currentPage">
      <ng-container *ngrxLet="clientId$ as clientId">
        <sdk-customer-client-nav-ui [currentPage]="currentPage" [clientId]="clientId"></sdk-customer-client-nav-ui>
      </ng-container>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerClientNavUIComponent, selector: "sdk-customer-client-nav-ui", inputs: ["clientId", "currentPage"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientNavigationComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-navigation',
                    template: `
    <ng-container *ngrxLet="clientPage$ as currentPage">
      <ng-container *ngrxLet="clientId$ as clientId">
        <sdk-customer-client-nav-ui [currentPage]="currentPage" [clientId]="clientId"></sdk-customer-client-nav-ui>
      </ng-container>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerClientNavigationService }] });

class CustomerClientLocationsComponent {
    set clientId(clientId) {
        this._clientId = clientId;
        this.clientStore.getClientIfDistinct(clientId);
        this.locationStore.loadAllItems(clientId);
    }
    constructor(clientStore, locationStore, permissionStore) {
        this.clientStore = clientStore;
        this.locationStore = locationStore;
        this.permissionStore = permissionStore;
        this.suppressHeader = false;
        this.client$ = this.clientStore.selectedClient$;
        this.locations$ = this.locationStore.allItems$;
        this.loaded$ = this.locationStore.loaded$;
        this.selectedLocation$ = this.locationStore.selectedItem$.pipe(map$1((location) => location));
        this.canEdit$ = this.permissionStore.userPermissions$.pipe(map$1((permissions) => permissions?.has(CustomerPermissions.EditClient) ?? false));
    }
    ngOnInit() {
        this.client$ = this.clientStore.selectedClient$;
    }
    ngOnDestroy() { }
    select(location) {
        this.locationStore.selectItem(location);
        this.editLocationModal.open();
    }
    deselect() {
        this.locationStore.selectItem(undefined);
        this.editLocationModal.close();
    }
    cancelEdit() {
        this.deselect();
    }
    addClicked() {
        this.locationStore.selectItem(undefined);
        this.editLocationModal.open();
    }
    update(location) {
        const casted = location;
        if (!this._clientId) {
            throw e11Error({ title: 'Invalid configuration', message: 'No client Id', type: 'customer/no-client-id' });
        }
        this.locationStore.update(casted);
        this.deselect();
    }
    delete(location) {
        const casted = location;
        this.locationStore.delete(casted.id);
        this.deselect();
    }
    add(location, client) {
        if (!client)
            throw e11Error({ title: 'No Client Selected', message: 'No client selected', type: 'customer/no-client-selected' });
        const casted = location;
        casted.clientId = client.id;
        casted.customerKey = client.customerKey;
        this.locationStore.add(casted);
        this.deselect();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLocationsComponent, deps: [{ token: CustomerClientStore }, { token: CustomerClientLocationStore }, { token: i3$1.PermissionStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientLocationsComponent, selector: "sdk-customer-client-locations", inputs: { suppressHeader: "suppressHeader", clientId: "clientId" }, viewQueries: [{ propertyName: "editLocationModal", first: true, predicate: ["editLocation"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else locations" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #locations>
      <ng-container *ngrxLet="client$ as client">
        <sdk-customer-list-header
          *ngIf="!suppressHeader"
          [headerText]="'Manage Locations'"
          [buttonText]="'Add Location'"
          [disabled]="(canEdit$ | async) === false"
          (addClicked)="addClicked()"
        ></sdk-customer-list-header>
        <sdk-location-list
          [locations]="(locations$ | async) ?? undefined"
          [disabled]="(canEdit$ | async) === false"
          (locationSelected)="select($event)"
          (addLocationClicked)="addClicked()"
        ></sdk-location-list>

        <e11-modal #editLocation [title]="'Manage Location' | translate" [showHeader]="true" [width]="'lg'" [bodyHeight]="'large'">
          <div modal-body>
            <sdk-form-location
              [location]="(selectedLocation$ | async) ?? undefined"
              (cancelled)="cancelEdit()"
              (locationAdded)="add($event, client)"
              (locationDeleted)="delete($event)"
              (locationUpdated)="update($event)"
            ></sdk-form-location>
          </div>
        </e11-modal>
      </ng-container>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: LocationFormComponent, selector: "sdk-form-location", inputs: ["location", "STATE_REQUIRED_LENGTH", "activeInfo"], outputs: ["locationAdded", "locationUpdated", "locationDeleted", "cancelled"] }, { kind: "component", type: CompanyLocationListComponent, selector: "sdk-location-list", inputs: ["showSearch", "locations", "disabled", "disabledText"], outputs: ["locationSelected", "addLocationClicked"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLocationsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-locations',
                    template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else locations" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #locations>
      <ng-container *ngrxLet="client$ as client">
        <sdk-customer-list-header
          *ngIf="!suppressHeader"
          [headerText]="'Manage Locations'"
          [buttonText]="'Add Location'"
          [disabled]="(canEdit$ | async) === false"
          (addClicked)="addClicked()"
        ></sdk-customer-list-header>
        <sdk-location-list
          [locations]="(locations$ | async) ?? undefined"
          [disabled]="(canEdit$ | async) === false"
          (locationSelected)="select($event)"
          (addLocationClicked)="addClicked()"
        ></sdk-location-list>

        <e11-modal #editLocation [title]="'Manage Location' | translate" [showHeader]="true" [width]="'lg'" [bodyHeight]="'large'">
          <div modal-body>
            <sdk-form-location
              [location]="(selectedLocation$ | async) ?? undefined"
              (cancelled)="cancelEdit()"
              (locationAdded)="add($event, client)"
              (locationDeleted)="delete($event)"
              (locationUpdated)="update($event)"
            ></sdk-form-location>
          </div>
        </e11-modal>
      </ng-container>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerClientStore }, { type: CustomerClientLocationStore }, { type: i3$1.PermissionStore }], propDecorators: { suppressHeader: [{
                type: Input
            }], clientId: [{
                type: Input
            }], editLocationModal: [{
                type: ViewChild,
                args: ['editLocation']
            }] } });

class CustomerClientContactsComponent {
    set clientId(clientId) {
        this._clientId = clientId;
        this.clientStore.getClientIfDistinct(clientId);
        this.contactStore.loadAllItems(clientId);
        this.locationStore.loadAllItems(clientId);
    }
    constructor(clientStore, contactStore, locationStore, permissionStore) {
        this.clientStore = clientStore;
        this.contactStore = contactStore;
        this.locationStore = locationStore;
        this.permissionStore = permissionStore;
        this.suppressHeader = false;
        this.client$ = this.clientStore.selectedClient$;
        this.contacts$ = this.contactStore.allItems$;
        this.selectedItem$ = this.contactStore.selectedItem$;
        this.loaded$ = this.contactStore.loaded$;
        this.canEdit$ = this.permissionStore.userPermissions$.pipe(map$1((permissions) => permissions?.has(CustomerPermissions.EditClient) ?? false));
        this.locations$ = this.locationStore.allItems$;
        this.logger = inject(E11Logger);
    }
    ngOnInit() { }
    ngOnDestroy() { }
    select(contact) {
        this.contactStore.selectItem({ ...contact, clientId: this._clientId });
        this.editContactModal.open();
    }
    addClicked() {
        this.contactStore.selectItem(undefined);
        this.editContactModal.open();
    }
    addContact(contact, client) {
        this.contactStore.add({ ...contact, clientId: client.id, customerKey: client.customerKey });
    }
    updateContact(contact, client) {
        const model = { ...contact, clientId: client.id, customerKey: client.customerKey, id: contact.id };
        this.contactStore.update(model);
    }
    deleteContact(contactId) {
        this.contactStore.delete(contactId);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientContactsComponent, deps: [{ token: CustomerClientStore }, { token: CustomerClientContactStore }, { token: CustomerClientLocationStore }, { token: i3$1.PermissionStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientContactsComponent, selector: "sdk-customer-client-contacts", inputs: { suppressHeader: "suppressHeader", clientId: "clientId" }, viewQueries: [{ propertyName: "editContactModal", first: true, predicate: ["editContact"], descendants: true }], ngImport: i0, template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else departments" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #departments>
      <ng-container *ngrxLet="client$ as client">
        <sdk-customer-list-header
          *ngIf="!suppressHeader"
          [headerText]="'Manage Contacts'"
          [buttonText]="'Add Contact'"
          [disabled]="(canEdit$ | async) === false"
          (addClicked)="addClicked()"
        ></sdk-customer-list-header>
        <sdk-contact-list
          [contacts]="(contacts$ | async) ?? []"
          [disabled]="(canEdit$ | async) === false"
          (contactClicked)="select($event)"
          (addContactClicked)="addClicked()"
        ></sdk-contact-list>

        <e11-modal #editContact [title]="'Manage Contact' | translate" [showHeader]="true" [width]="'lg'" [bodyHeight]="'half'">
          <div modal-body>
            <sdk-contact-form
              [currentContact]="(selectedItem$ | async) ?? undefined"
              [locations]="(locations$ | async) ?? undefined"
              (addContact)="addContact($event, client!)"
              (updateContact)="updateContact($event, client!)"
              (cancelled)="editContact.close()"
              (deleteContact)="deleteContact($event)"
            ></sdk-contact-form>
          </div>

          <div modal-footer>
            <div class="e11-flex e11-justify-start e11-font-bold">{{ client?.name }}</div>
          </div>
        </e11-modal>
      </ng-container>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: CustomerListHeaderComponent, selector: "sdk-customer-list-header", inputs: ["headerText", "buttonText", "disabled", "disabledText"], outputs: ["addClicked"] }, { kind: "component", type: ContactFormComponent, selector: "sdk-contact-form", inputs: ["currentContact", "locations"], outputs: ["cancelled", "deleteClicked", "addContact", "updateContact", "deleteContact"] }, { kind: "component", type: ContactListComponent, selector: "sdk-contact-list", inputs: ["contacts", "disabled", "disabledText"], outputs: ["contactClicked", "addContactClicked"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientContactsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-contacts',
                    template: `
    <ng-container *ngrxLet="loaded$ as loaded">
      <e11-loader-dots *ngIf="!loaded; else departments" [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <ng-template #departments>
      <ng-container *ngrxLet="client$ as client">
        <sdk-customer-list-header
          *ngIf="!suppressHeader"
          [headerText]="'Manage Contacts'"
          [buttonText]="'Add Contact'"
          [disabled]="(canEdit$ | async) === false"
          (addClicked)="addClicked()"
        ></sdk-customer-list-header>
        <sdk-contact-list
          [contacts]="(contacts$ | async) ?? []"
          [disabled]="(canEdit$ | async) === false"
          (contactClicked)="select($event)"
          (addContactClicked)="addClicked()"
        ></sdk-contact-list>

        <e11-modal #editContact [title]="'Manage Contact' | translate" [showHeader]="true" [width]="'lg'" [bodyHeight]="'half'">
          <div modal-body>
            <sdk-contact-form
              [currentContact]="(selectedItem$ | async) ?? undefined"
              [locations]="(locations$ | async) ?? undefined"
              (addContact)="addContact($event, client!)"
              (updateContact)="updateContact($event, client!)"
              (cancelled)="editContact.close()"
              (deleteContact)="deleteContact($event)"
            ></sdk-contact-form>
          </div>

          <div modal-footer>
            <div class="e11-flex e11-justify-start e11-font-bold">{{ client?.name }}</div>
          </div>
        </e11-modal>
      </ng-container>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerClientStore }, { type: CustomerClientContactStore }, { type: CustomerClientLocationStore }, { type: i3$1.PermissionStore }], propDecorators: { editContactModal: [{
                type: ViewChild,
                args: ['editContact']
            }], suppressHeader: [{
                type: Input
            }], clientId: [{
                type: Input
            }] } });

var ClientHeaderState;
(function (ClientHeaderState) {
    ClientHeaderState["Search"] = "Search";
    ClientHeaderState["Manage"] = "Manage";
    ClientHeaderState["Add"] = "Add";
})(ClientHeaderState || (ClientHeaderState = {}));
class ClientHeaderComponent {
    constructor(customerStore) {
        this.customerStore = customerStore;
        this.ClientHeaderState = ClientHeaderState;
        this.state = ClientHeaderState.Search;
        this.currentCustomer$ = this.customerStore.currentCustomer$.pipe(filter$1(isNotNil));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientHeaderComponent, deps: [{ token: CustomerStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ClientHeaderComponent, selector: "sdk-client-header", inputs: { state: "state", client: "client" }, ngImport: i0, template: `
    <div class="e11-w-full e11-mb-4" *ngrxLet="currentCustomer$ as currentCustomer">
      <div *ngIf="client && client.name" class="e11-w-full e11-flex e11-items-center">
        <!-- <img
          *ngIf="(client?.logoImage || client?.logoImageURL) && state !== ClientHeaderState.Search"
          class="e11-max-h-8 e11-mr-2"
          src="{{ client?.logoImage?.url ?? client?.logoImageURL ?? undefined }}"
        /> -->
        <h2 class="e11-text-skin-primary-accent">{{ (state === ClientHeaderState.Search ? 'Client Search' : client!.name) | translate }}</h2>
      </div>
      <div *ngIf="client && client.name" class="e11-w-full e11-flex e11-items-center">
        <span class="e11-text-sm e11-mr-1">{{ 'Learn more about this data' | translate }}</span>
        <e11-tooltip
          [color]="'dark'"
          [tooltipText]="
            'The information managed on these tabs is for your records only and will not change your clients data. If ' +
              client!.name +
              ' wants to make changes to their logo, company details, departments or locations, an Admin from the company will need to log into their account to make those changes.'
              | translate
          "
        >
          <span class="material-icons-outlined md-18 e11-cursor-default">info</span>
        </e11-tooltip>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: i3$3.E11TooltipComponent, selector: "e11-tooltip", inputs: ["tooltipText", "tooltipClassOverrides", "hideTooltip", "color", "tooltipContent", "position", "interactive", "maxWidth", "delay"], outputs: ["tooltipClick"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-client-header',
                    template: `
    <div class="e11-w-full e11-mb-4" *ngrxLet="currentCustomer$ as currentCustomer">
      <div *ngIf="client && client.name" class="e11-w-full e11-flex e11-items-center">
        <!-- <img
          *ngIf="(client?.logoImage || client?.logoImageURL) && state !== ClientHeaderState.Search"
          class="e11-max-h-8 e11-mr-2"
          src="{{ client?.logoImage?.url ?? client?.logoImageURL ?? undefined }}"
        /> -->
        <h2 class="e11-text-skin-primary-accent">{{ (state === ClientHeaderState.Search ? 'Client Search' : client!.name) | translate }}</h2>
      </div>
      <div *ngIf="client && client.name" class="e11-w-full e11-flex e11-items-center">
        <span class="e11-text-sm e11-mr-1">{{ 'Learn more about this data' | translate }}</span>
        <e11-tooltip
          [color]="'dark'"
          [tooltipText]="
            'The information managed on these tabs is for your records only and will not change your clients data. If ' +
              client!.name +
              ' wants to make changes to their logo, company details, departments or locations, an Admin from the company will need to log into their account to make those changes.'
              | translate
          "
        >
          <span class="material-icons-outlined md-18 e11-cursor-default">info</span>
        </e11-tooltip>
      </div>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerStore }], propDecorators: { state: [{
                type: Input
            }], client: [{
                type: Input
            }] } });

class CustomerClientLogoComponent {
    set clientId(id) {
        this.store.getClientIfDistinct(id);
        this._clientId = id;
    }
    constructor(configProvider, store, permissionStore) {
        this.configProvider = configProvider;
        this.store = store;
        this.permissionStore = permissionStore;
        this.headerText = CLIENT_LOGO_DEFAULTS.headerText;
        this.subHeaderText = CLIENT_LOGO_DEFAULTS.subHeaderText;
        this.logoInfo = CLIENT_LOGO_DEFAULTS.logoInfo;
        this.flexDirection = 'row';
        this.canEdit$ = this.permissionStore.userPermissions$.pipe(map$1((permissions) => permissions?.has(CustomerPermissions.EditClient) ?? false));
        this.customerClient$ = this.store.selectedClient$;
        this.customerKey$ = this.configProvider.config.customerKey$.pipe(filter$1(isNotNil));
        this.loading$ = this.store.clientLoading$;
    }
    ngOnInit() { }
    async logoUpdated(logo, client) {
        this.store.updateClient({ ...client, logoImageURL: logo.url, logoImage: logo });
    }
    async logoDeleted(client) {
        this.store.updateClient({ ...client, logoImageURL: null, logoImage: null });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLogoComponent, deps: [{ token: BaseCustomerConfigProvider }, { token: CustomerClientStore }, { token: i3$1.PermissionStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CustomerClientLogoComponent, selector: "sdk-customer-client-logo", inputs: { headerText: "headerText", subHeaderText: "subHeaderText", logoInfo: "logoInfo", clientId: "clientId", flexDirection: "flexDirection" }, ngImport: i0, template: `
    <ng-container *ngrxLet="loading$ as loading">
      <e11-loader-dots *ngIf="loading; else logoManage" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <div class="e11-grow e11-flex e11-items-center e11-justify-end">
      <ng-template #logoManage>
        <ng-container *ngrxLet="customerClient$ as customerClient">
          <sdk-logo-manage
            *ngrxLet="customerKey$ as customerKey"
            [showHeaderTitle]="flexDirection === 'row'"
            [disabled]="(canEdit$ | async) === false"
            [disabledText]="'You do not have permission to manage clients' | translate"
            [headerText]="headerText"
            [subHeaderText]="subHeaderText"
            [flexDirection]="flexDirection"
            [logoInfo]="logoInfo"
            [customerKey]="customerKey"
            [logoUrl]="customerClient?.logoImage?.url ?? customerClient?.logoImageURL ?? undefined"
            (logoUploaded)="logoUpdated($event, customerClient!)"
            (logoDeleted)="logoDeleted(customerClient!)"
          ></sdk-logo-manage>
        </ng-container>
      </ng-template>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: LogoManageComponent, selector: "sdk-logo-manage", inputs: ["logoUrl", "customerKey", "headerText", "subHeaderText", "logoInfo", "disabled", "disabledText", "showHeaderTitle", "flexDirection", "deleteDurationDays"], outputs: ["logoUploaded", "logoDeleted"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientLogoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-customer-client-logo',
                    template: `
    <ng-container *ngrxLet="loading$ as loading">
      <e11-loader-dots *ngIf="loading; else logoManage" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
    </ng-container>

    <div class="e11-grow e11-flex e11-items-center e11-justify-end">
      <ng-template #logoManage>
        <ng-container *ngrxLet="customerClient$ as customerClient">
          <sdk-logo-manage
            *ngrxLet="customerKey$ as customerKey"
            [showHeaderTitle]="flexDirection === 'row'"
            [disabled]="(canEdit$ | async) === false"
            [disabledText]="'You do not have permission to manage clients' | translate"
            [headerText]="headerText"
            [subHeaderText]="subHeaderText"
            [flexDirection]="flexDirection"
            [logoInfo]="logoInfo"
            [customerKey]="customerKey"
            [logoUrl]="customerClient?.logoImage?.url ?? customerClient?.logoImageURL ?? undefined"
            (logoUploaded)="logoUpdated($event, customerClient!)"
            (logoDeleted)="logoDeleted(customerClient!)"
          ></sdk-logo-manage>
        </ng-container>
      </ng-template>
    </div>
  `,
                }]
        }], ctorParameters: () => [{ type: BaseCustomerConfigProvider }, { type: CustomerClientStore }, { type: i3$1.PermissionStore }], propDecorators: { headerText: [{
                type: Input
            }], subHeaderText: [{
                type: Input
            }], logoInfo: [{
                type: Input
            }], clientId: [{
                type: Input
            }], flexDirection: [{
                type: Input
            }] } });

/**
 * The "Batteries Included" implementation of customer client management - individual components can be brought in a la carte and opt out of using the navigation system
 */
class ClientManageComponent extends E11TemplateMap {
    #dynamicComponentService;
    #customerStore;
    constructor(navigationService, notificationService, store, customerClientService, logger) {
        super();
        this.navigationService = navigationService;
        this.notificationService = notificationService;
        this.store = store;
        this.customerClientService = customerClientService;
        this.logger = logger;
        this.#dynamicComponentService = inject(DynamicComponentService);
        this.#customerStore = inject(CustomerStore);
        this.dynamicTabs = this.#dynamicComponentService.dynamicTabs || [];
        this.dynamicComponentCount = 0; // Used to prevent bug where DOM loading after tab change will cause component to not be mapped
        this.ClientPages = ClientPages;
        this.ClientHeaderState = ClientHeaderState;
        this.loading = true;
        this.clientId$ = this.navigationService.clientId$.pipe(tap((clientId) => {
            this._clientId = clientId;
            this.mapComponents(this.#dynamicComponentService.dynamicTabs.map((tab) => tab.component));
        }));
        this.clientPage$ = this.navigationService.clientPage$;
        this.client$ = this.store.selectedClient$.pipe(tap((customer) => {
            this._customer = customer;
            this.mapComponents(this.#dynamicComponentService.dynamicTabs.map((tab) => tab.component));
        }));
        this.currentParentCustomer$ = this.#customerStore.currentCustomer$.pipe(tap((customer) => (this._currentParentCustomer = customer)));
        this.headerState$ = combineLatest([this.clientPage$, this.clientId$]).pipe(map$1(([clientPage, clientId]) => getHeaderState(clientPage, clientId)));
    }
    ngOnInit() {
        this.loading = true;
        this.customerClientService
            .searchKeyPackage()
            .pipe(filter$1(isNotNil), take(1))
            .subscribe((keyPackage) => {
            this.searchKeyPackage = keyPackage;
            this.loading = false;
        });
    }
    mapComponents(dynamicComponents) {
        this.dynamicComponentCount = 0;
        if (!dynamicComponents)
            return;
        this.dynamicComponentPlaceholders.forEach((viewContainerRef, index) => {
            const componentConfig = dynamicComponents[index];
            if (!componentConfig)
                return; // Guard in case there are more placeholders than configs
            const componentRef = viewContainerRef.createComponent(componentConfig);
            this.dynamicComponentCount++;
            // You can use this componentRef to interact with the component: Inputs, Outputs, etc.
            const config = { customerKey: this._customer?.clientCustomerKey, bootstrapTenantKey: this._currentParentCustomer?.bootstrapTenantKey };
            componentRef.setInput('config', config);
        });
    }
    selectedTabChanged(selectedTab) {
        if (this.dynamicComponentPlaceholders.length > this.dynamicComponentCount &&
            this.#dynamicComponentService.dynamicTabs.some((tab) => tab.id === selectedTab.tabId)) {
            this.mapComponents(this.#dynamicComponentService.dynamicTabs.map((tab) => tab.component));
        }
    }
    selectedClient(client) {
        this.navigationService.toClient(client.id);
    }
    addingClient() {
        this.navigationService.toPage(ClientPages.Detail);
    }
    clientUpdated(client) {
        this.clientSearch?.refresh();
    }
    clientAdded(client) {
        this.clientSearch?.refresh();
        this.navigationService.toClient(client.id); // Update route wrt client we just added
    }
    cancel() {
        this.toSearch();
    }
    toSearch() {
        this.navigationService.toPage(ClientPages.Search);
    }
    notifySuccess(text) {
        const message = {
            title: 'Success',
            message: text,
            type: 'success',
            autoClose: true,
            dismissOnRouteChange: false,
        };
        this.notificationService.popNotificationMessage(message);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientManageComponent, deps: [{ token: CustomerClientNavigationService }, { token: i3.E11NotificationsService }, { token: CustomerClientStore }, { token: CustomerClientService }, { token: i1$3.E11Logger }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.9", type: ClientManageComponent, selector: "sdk-client-manage", viewQueries: [{ propertyName: "clientSearch", first: true, predicate: ["clientSearch"], descendants: true }, { propertyName: "dynamicComponentPlaceholders", predicate: ["dynamicComponentPlaceholder"], descendants: true, read: ViewContainerRef }], usesInheritance: true, ngImport: i0, template: `
    <ng-container *ngrxLet="currentParentCustomer$ as currentParentCustomer">
      <ng-container *ngIf="!loading; else loader">
        <ng-container *ngrxLet="clientId$ as clientId">
          <ng-container *ngrxLet="clientPage$ as clientPage">
            <e11-panel [hidden]="clientPage !== ClientPages.Search">
              <sdk-customer-client-search
                #clientSearch
                *ngIf="searchKeyPackage"
                [hidden]="clientPage !== ClientPages.Search"
                [searchKeyPackage]="searchKeyPackage"
                (selectedClient)="selectedClient($event)"
                (addingClient)="addingClient()"
              ></sdk-customer-client-search>
            </e11-panel>
            <ng-container *ngIf="clientPage !== ClientPages.Search">
              <div class="e11-flex e11-flex-col lg:e11-flex-row e11-gap-4">
                <div class="e11-w-full lg:e11-w-1/5 e11-flex e11-flex-col e11-gap-4">
                  <div class="e11-flex e11-justify-between e11-items-center e11-py-2">
                    <div (click)="toSearch()" class="e11-flex e11-items-center e11-gap-2 e11-cursor-pointer">
                      <span class="material-icons-outlined e11-text-skin-primary"> arrow_back </span>
                      <a role="button" class="e11-text-skin-primary">{{ 'All Clients' | translate }}</a>
                    </div>
                    <div class="e11-flex e11-gap-4"></div>
                  </div>
                  <sdk-client-header
                    [state]="(headerState$ | async) ?? ClientHeaderState.Search"
                    [client]="(client$ | async) ?? undefined"
                  ></sdk-client-header>
                  <sdk-customer-client-logo *ngIf="clientId" [clientId]="clientId" [flexDirection]="'column'"></sdk-customer-client-logo>
                </div>
                <div class="e11-w-full lg:e11-w-4/5 e11-bg-skin-white e11-p-4">
                  <e11-tabs
                    [selectedTabId]="'Attributes'"
                    [tabTitleOverrides]="'e11-font-medium e11-px-2'"
                    [tabsClassOverrides]="'e11-ml-0 e11-border-b'"
                    (selectedTabChanged)="selectedTabChanged($event)"
                  >
                    <e11-tab [title]="'Company Detail' | translate" [tabId]="'Company Detail'" [contentClassOverrides]="'e11-py-4'">
                      <div class="e11-p-4">
                        <sdk-customer-client-detail
                          [clientId]="clientId"
                          (clientAdded)="clientAdded($event)"
                          (clientUpdated)="clientUpdated($event)"
                          (clientCancelled)="cancel()"
                        ></sdk-customer-client-detail>
                        <ng-container *ngTemplateOutlet="e11TemplateMap['account']"></ng-container>
                      </div>
                    </e11-tab>
                    <e11-tab [title]="'Departments' | translate" [tabId]="'Departments'" [contentClassOverrides]="'e11-py-4'">
                      <div class="e11-p-4">
                        @if (clientId) {
                        <sdk-customer-client-departments [clientId]="clientId"></sdk-customer-client-departments>
                        } @else {
                        <ng-container *ngTemplateOutlet="provisioningEmpty; context: { $implicit: 'Departments' }"></ng-container>
                        }
                      </div>
                    </e11-tab>
                    <e11-tab [title]="'Locations' | translate" [tabId]="'Locations'" [contentClassOverrides]="'e11-py-4'">
                      <div class="e11-p-4">
                        @if (clientId) {
                        <sdk-customer-client-locations [clientId]="clientId"></sdk-customer-client-locations>
                        } @else {
                        <ng-container *ngTemplateOutlet="provisioningEmpty; context: { $implicit: 'Locations' }"></ng-container>
                        }
                      </div>
                    </e11-tab>
                    <e11-tab [title]="'Contacts' | translate" [tabId]="'Contacts'" [contentClassOverrides]="'e11-py-4'">
                      <div class="e11-p-4">
                        @if (clientId) {
                        <sdk-customer-client-contacts [clientId]="clientId"></sdk-customer-client-contacts>
                        } @else {
                        <ng-container *ngTemplateOutlet="provisioningEmpty; context: { $implicit: 'Contacts' }"></ng-container>
                        }
                      </div>
                    </e11-tab>
                    <e11-tab
                      *ngFor="let dynamicTab of dynamicTabs"
                      [title]="dynamicTab.label"
                      [tabId]="dynamicTab.id"
                      [contentClassOverrides]="'e11-py-4'"
                    >
                      <div class="e11-p-4">
                        <ng-template #dynamicComponentPlaceholder></ng-template>
                      </div>
                    </e11-tab>
                  </e11-tabs>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #loader>
      <e11-loader-dots
        [size]="'md'"
        [color]="'e11-bg-skin-primary-accent'"
        [active]="true"
        label="{{ 'Retrieving clients...' | translate }}"
      ></e11-loader-dots>
    </ng-template>
    <ng-template #provisioningEmpty let-name>
      <e11-empty-state
        [icon]="''"
        [border]="'solid'"
        [title]="name + ' not Available'"
        [subtitle]="name + ' will be made available when Client is provisioned.'"
        [clickable]="false"
      ></e11-empty-state>
    </ng-template>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i5$1.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: i11$1.E11TabComponent, selector: "e11-tab", inputs: ["tabId", "title", "badgeValue", "contentClassOverrides", "disabled", "active"] }, { kind: "component", type: i11$1.E11TabsComponent, selector: "e11-tabs", inputs: ["selectedTabId", "showActiveStatus", "tabsLoaded", "tabsClassOverrides", "tabClassOverrides", "tabTitleOverrides", "tabsStyle", "badgeLimit", "useQueryParams"], outputs: ["selectedTabChanged"] }, { kind: "component", type: CustomerClientSearchComponent, selector: "sdk-customer-client-search", inputs: ["searchKeyPackage", "showAddButton"], outputs: ["selectedClient", "addingClient"] }, { kind: "component", type: CustomerClientContactsComponent, selector: "sdk-customer-client-contacts", inputs: ["suppressHeader", "clientId"] }, { kind: "component", type: CustomerClientDepartmentsComponent, selector: "sdk-customer-client-departments", inputs: ["suppressHeader", "clientId"] }, { kind: "component", type: CustomerClientDetailComponent, selector: "sdk-customer-client-detail", inputs: ["clientId", "cancelText"], outputs: ["clientUpdated", "clientAdded", "clientCancelled"] }, { kind: "component", type: CustomerClientLocationsComponent, selector: "sdk-customer-client-locations", inputs: ["suppressHeader", "clientId"] }, { kind: "component", type: CustomerClientLogoComponent, selector: "sdk-customer-client-logo", inputs: ["headerText", "subHeaderText", "logoInfo", "clientId", "flexDirection"] }, { kind: "component", type: ClientHeaderComponent, selector: "sdk-client-header", inputs: ["state", "client"] }, { kind: "pipe", type: i1$2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ClientManageComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-client-manage',
                    template: `
    <ng-container *ngrxLet="currentParentCustomer$ as currentParentCustomer">
      <ng-container *ngIf="!loading; else loader">
        <ng-container *ngrxLet="clientId$ as clientId">
          <ng-container *ngrxLet="clientPage$ as clientPage">
            <e11-panel [hidden]="clientPage !== ClientPages.Search">
              <sdk-customer-client-search
                #clientSearch
                *ngIf="searchKeyPackage"
                [hidden]="clientPage !== ClientPages.Search"
                [searchKeyPackage]="searchKeyPackage"
                (selectedClient)="selectedClient($event)"
                (addingClient)="addingClient()"
              ></sdk-customer-client-search>
            </e11-panel>
            <ng-container *ngIf="clientPage !== ClientPages.Search">
              <div class="e11-flex e11-flex-col lg:e11-flex-row e11-gap-4">
                <div class="e11-w-full lg:e11-w-1/5 e11-flex e11-flex-col e11-gap-4">
                  <div class="e11-flex e11-justify-between e11-items-center e11-py-2">
                    <div (click)="toSearch()" class="e11-flex e11-items-center e11-gap-2 e11-cursor-pointer">
                      <span class="material-icons-outlined e11-text-skin-primary"> arrow_back </span>
                      <a role="button" class="e11-text-skin-primary">{{ 'All Clients' | translate }}</a>
                    </div>
                    <div class="e11-flex e11-gap-4"></div>
                  </div>
                  <sdk-client-header
                    [state]="(headerState$ | async) ?? ClientHeaderState.Search"
                    [client]="(client$ | async) ?? undefined"
                  ></sdk-client-header>
                  <sdk-customer-client-logo *ngIf="clientId" [clientId]="clientId" [flexDirection]="'column'"></sdk-customer-client-logo>
                </div>
                <div class="e11-w-full lg:e11-w-4/5 e11-bg-skin-white e11-p-4">
                  <e11-tabs
                    [selectedTabId]="'Attributes'"
                    [tabTitleOverrides]="'e11-font-medium e11-px-2'"
                    [tabsClassOverrides]="'e11-ml-0 e11-border-b'"
                    (selectedTabChanged)="selectedTabChanged($event)"
                  >
                    <e11-tab [title]="'Company Detail' | translate" [tabId]="'Company Detail'" [contentClassOverrides]="'e11-py-4'">
                      <div class="e11-p-4">
                        <sdk-customer-client-detail
                          [clientId]="clientId"
                          (clientAdded)="clientAdded($event)"
                          (clientUpdated)="clientUpdated($event)"
                          (clientCancelled)="cancel()"
                        ></sdk-customer-client-detail>
                        <ng-container *ngTemplateOutlet="e11TemplateMap['account']"></ng-container>
                      </div>
                    </e11-tab>
                    <e11-tab [title]="'Departments' | translate" [tabId]="'Departments'" [contentClassOverrides]="'e11-py-4'">
                      <div class="e11-p-4">
                        @if (clientId) {
                        <sdk-customer-client-departments [clientId]="clientId"></sdk-customer-client-departments>
                        } @else {
                        <ng-container *ngTemplateOutlet="provisioningEmpty; context: { $implicit: 'Departments' }"></ng-container>
                        }
                      </div>
                    </e11-tab>
                    <e11-tab [title]="'Locations' | translate" [tabId]="'Locations'" [contentClassOverrides]="'e11-py-4'">
                      <div class="e11-p-4">
                        @if (clientId) {
                        <sdk-customer-client-locations [clientId]="clientId"></sdk-customer-client-locations>
                        } @else {
                        <ng-container *ngTemplateOutlet="provisioningEmpty; context: { $implicit: 'Locations' }"></ng-container>
                        }
                      </div>
                    </e11-tab>
                    <e11-tab [title]="'Contacts' | translate" [tabId]="'Contacts'" [contentClassOverrides]="'e11-py-4'">
                      <div class="e11-p-4">
                        @if (clientId) {
                        <sdk-customer-client-contacts [clientId]="clientId"></sdk-customer-client-contacts>
                        } @else {
                        <ng-container *ngTemplateOutlet="provisioningEmpty; context: { $implicit: 'Contacts' }"></ng-container>
                        }
                      </div>
                    </e11-tab>
                    <e11-tab
                      *ngFor="let dynamicTab of dynamicTabs"
                      [title]="dynamicTab.label"
                      [tabId]="dynamicTab.id"
                      [contentClassOverrides]="'e11-py-4'"
                    >
                      <div class="e11-p-4">
                        <ng-template #dynamicComponentPlaceholder></ng-template>
                      </div>
                    </e11-tab>
                  </e11-tabs>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #loader>
      <e11-loader-dots
        [size]="'md'"
        [color]="'e11-bg-skin-primary-accent'"
        [active]="true"
        label="{{ 'Retrieving clients...' | translate }}"
      ></e11-loader-dots>
    </ng-template>
    <ng-template #provisioningEmpty let-name>
      <e11-empty-state
        [icon]="''"
        [border]="'solid'"
        [title]="name + ' not Available'"
        [subtitle]="name + ' will be made available when Client is provisioned.'"
        [clickable]="false"
      ></e11-empty-state>
    </ng-template>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerClientNavigationService }, { type: i3.E11NotificationsService }, { type: CustomerClientStore }, { type: CustomerClientService }, { type: i1$3.E11Logger }], propDecorators: { dynamicComponentPlaceholders: [{
                type: ViewChildren,
                args: ['dynamicComponentPlaceholder', { read: ViewContainerRef }]
            }], clientSearch: [{
                type: ViewChild,
                args: ['clientSearch']
            }] } });
function getHeaderState(clientPage, clientId) {
    if (clientPage === ClientPages.Search)
        return ClientHeaderState.Search;
    if (!clientId)
        return ClientHeaderState.Add;
    return ClientHeaderState.Manage;
}

// ! Only add to declare exports if it's needed externally
const DeclareExportComponents$2 = [
    CustomerClientSearchComponent,
    CustomerClientContactsComponent,
    CustomerClientDepartmentsComponent,
    CustomerClientDetailComponent,
    CustomerClientLocationsComponent,
    CustomerClientNavigationComponent,
    ClientManageComponent,
    CustomerClientLogoComponent,
];
class CustomerClientModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientModule, declarations: [CustomerClientSearchComponent,
            CustomerClientContactsComponent,
            CustomerClientDepartmentsComponent,
            CustomerClientDetailComponent,
            CustomerClientLocationsComponent,
            CustomerClientNavigationComponent,
            ClientManageComponent,
            CustomerClientLogoComponent, ClientHeaderComponent,
            CustomerClientNavUIComponent,
            CustomerClientListComponent,
            CustomerClientDataNotFoundComponent,
            CustomerClientImageDataNotFoundComponent], imports: [CommonModule,
            SharedModule,
            EditableBusinessModule, i6.NgAisRootModule, i6.NgAisInstantSearchModule, NgAisHitsModule,
            NgAisSearchBoxModule,
            SearchModule,
            E11TooltipModule], exports: [CustomerClientSearchComponent,
            CustomerClientContactsComponent,
            CustomerClientDepartmentsComponent,
            CustomerClientDetailComponent,
            CustomerClientLocationsComponent,
            CustomerClientNavigationComponent,
            ClientManageComponent,
            CustomerClientLogoComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientModule, imports: [CommonModule,
            SharedModule,
            EditableBusinessModule,
            NgAisModule.forRoot(),
            NgAisInstantSearchModule.forRoot(),
            NgAisHitsModule,
            NgAisSearchBoxModule,
            SearchModule,
            E11TooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerClientModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ...DeclareExportComponents$2,
                        ClientHeaderComponent,
                        CustomerClientNavUIComponent,
                        CustomerClientListComponent,
                        CustomerClientDataNotFoundComponent,
                        CustomerClientImageDataNotFoundComponent,
                    ],
                    imports: [
                        CommonModule,
                        SharedModule,
                        EditableBusinessModule,
                        NgAisModule.forRoot(),
                        NgAisInstantSearchModule.forRoot(),
                        NgAisHitsModule,
                        NgAisSearchBoxModule,
                        SearchModule,
                        E11TooltipModule,
                    ],
                    exports: [...DeclareExportComponents$2],
                }]
        }] });

const DeclareExportComponents$1 = [
    SearchAllCustomersComponent,
    SearchBusinessCustomersComponent,
    SearchConsumerCustomersComponent,
    PlatformAdminLocationsComponent,
    PlatformAdminDepartmentsComponent,
    PlatformAdminContactsComponent,
    PlatformAdminCustomerDetailComponent,
    PlatformAdminClientComponent,
];
class CustomerAdminModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerAdminModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: CustomerAdminModule, declarations: [SearchAllCustomersComponent,
            SearchBusinessCustomersComponent,
            SearchConsumerCustomersComponent,
            PlatformAdminLocationsComponent,
            PlatformAdminDepartmentsComponent,
            PlatformAdminContactsComponent,
            PlatformAdminCustomerDetailComponent,
            PlatformAdminClientComponent], imports: [CommonModule,
            CompanyAccountModule,
            SharedModule,
            EditableBusinessModule, i6.NgAisRootModule, i6.NgAisInstantSearchModule, NgAisHitsModule,
            NgAisSearchBoxModule,
            SearchModule,
            E11TooltipModule,
            CustomerClientModule], exports: [SearchAllCustomersComponent,
            SearchBusinessCustomersComponent,
            SearchConsumerCustomersComponent,
            PlatformAdminLocationsComponent,
            PlatformAdminDepartmentsComponent,
            PlatformAdminContactsComponent,
            PlatformAdminCustomerDetailComponent,
            PlatformAdminClientComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerAdminModule, imports: [CommonModule,
            CompanyAccountModule,
            SharedModule,
            EditableBusinessModule,
            NgAisModule.forRoot(),
            NgAisInstantSearchModule.forRoot(),
            NgAisHitsModule,
            NgAisSearchBoxModule,
            SearchModule,
            E11TooltipModule,
            CustomerClientModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerAdminModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DeclareExportComponents$1],
                    imports: [
                        CommonModule,
                        CompanyAccountModule,
                        SharedModule,
                        EditableBusinessModule,
                        NgAisModule.forRoot(),
                        NgAisInstantSearchModule.forRoot(),
                        NgAisHitsModule,
                        NgAisSearchBoxModule,
                        SearchModule,
                        E11TooltipModule,
                        CustomerClientModule,
                    ],
                    exports: [...DeclareExportComponents$1],
                }]
        }] });

class CustomerDataPartitionService {
    constructor(configProvider) {
        this.configProvider = configProvider;
        this.api = new RestApiClient({
            baseUrl: this.configProvider.config.baseUrl,
            token: this.configProvider.config.token$.pipe(filter(isNotNil)),
            versionType: VersionType.URI,
        });
    }
    get(id) {
        return this.api.get(`partitions/${id}`, { version: '1' }).pipe(map((response) => response.data));
    }
    getAll() {
        return this.api.get('partitions', { version: '1' }).pipe(map((response) => response.data));
    }
    add(createPartitionRequest) {
        return this.api.post('partitions', createPartitionRequest, { version: '1' }).pipe(map((response) => response.data));
    }
    update(partitionToUpdate) {
        return this.api
            .put(`partitions/${partitionToUpdate.id}`, partitionToUpdate, { version: '1' })
            .pipe(map((response) => response.data));
    }
    getAllApiKeys(partitionId) {
        return this.api
            .get(`partitions/${partitionId}/api-keys`, { version: '1' })
            .pipe(map((response) => response.data));
    }
    addApiKey(createApiKeyRequest) {
        return this.api
            .post(`partitions/${createApiKeyRequest.partitionId}/api-keys`, createApiKeyRequest, { version: '1' })
            .pipe(map((response) => response.data));
    }
    rotateKey(keyRotationRequest) {
        return this.api
            .patch(`partitions/${keyRotationRequest.partitionId}/api-keys/${keyRotationRequest.keyId}/rotate`, {}, { version: '1' })
            .pipe(map((response) => response.data));
    }
    deleteKey(keyId) {
        return this.api.delete(`partitions/${keyId}/api-keys`, { version: '1' });
    }
    delete(partitionId) {
        return this.api.delete(`partitions/${partitionId}`, { version: '1' });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDataPartitionService, deps: [{ token: BaseCustomerConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDataPartitionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerDataPartitionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: BaseCustomerConfigProvider }] });

class PartitionStashRepository extends CollectionRepository {
    constructor() {
        super(...arguments);
        this.COLLECTION = COLLECTIONS.PARTITION_STASH;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionStashRepository, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionStashRepository, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionStashRepository, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const initialState = {
    loaded: false,
    selectedPartition: undefined,
    selectedPartitionKeys: [],
    customerPartitions: [],
    partitionGroups: [],
};
class ManagePartitionComponentStore extends ComponentStore {
    constructor(logger, configProvider, customerPartitionService, errorHandler, notificationService, partitionStashRepository, router, configPartitionProvider) {
        super(initialState);
        this.logger = logger;
        this.configProvider = configProvider;
        this.customerPartitionService = customerPartitionService;
        this.errorHandler = errorHandler;
        this.notificationService = notificationService;
        this.partitionStashRepository = partitionStashRepository;
        this.router = router;
        this.configPartitionProvider = configPartitionProvider;
        // Selectors
        this.state$ = this.select((s) => s);
        this.loaded$ = this.select((s) => s.loaded);
        this.selectedPartition$ = this.select((s) => s.selectedPartition);
        this.selectedPartitionKeys$ = this.select((s) => s.selectedPartitionKeys);
        this.customerPartitions$ = this.select((s) => s.customerPartitions);
        this.partitionGroups$ = this.select((s) => s.partitionGroups);
        this.selectedApiKey$ = this.select((s) => s.selectedApiKey);
        this.getState = this.select((s) => s);
        this.bootStrap = () => {
            this.init(this.configProvider.getCurrentUserAppId().pipe(filter$1(isNotNil)));
        };
        this.init = this.effect((appUserId$) => appUserId$.pipe(mergeMap((appUserId) => this.partitionStashRepository.get(appUserId)), filter$1(isNotNil), mergeMap((partitionStash) => this.customerPartitionService.get(partitionStash.partitionId)), tap((partition) => this.selectPartition(partition)), catchError((e) => {
            this.errorHandler.handleError(e);
            this.router.navigateByUrl(this.configPartitionProvider.config.listOfPartitionsUrl);
            return EMPTY;
        })));
        this.loadPartitionKeys = this.effect((partitionId$) => partitionId$.pipe(tap(() => this.setLoaded(false)), mergeMap((partitionId) => this.customerPartitionService.getAllApiKeys(partitionId)), tap((keys) => this.setPartitionKeys(keys)), tap(() => this.setLoaded(true))));
        this.loadPartitions = this.effect(() => {
            return this.customerPartitionService.getAll().pipe(tap(() => this.setLoaded(false)), tap((partitions) => this.setCustomerPartitions(partitions)), tap(() => this.setLoaded(true)), catchError((e) => {
                this.errorHandler.handleError(e);
                this.setLoaded(true);
                return EMPTY;
            }));
        });
        this.updatePartition = this.effect((partition$) => partition$.pipe(tap(() => this.setLoaded(false)), mergeMap((partition) => this.customerPartitionService.update(partition)), tap((partition) => this.setSelectedPartition(partition)), tap((partition) => this.updateCustomerPartition(partition)), tap(() => this.setLoaded(true)), tap(() => this.notificationService.popNotificationMessage({
            type: 'success',
            title: 'Project updated',
            message: 'Project update successfully',
        })), catchError((e) => {
            this.errorHandler.handleError(e);
            this.setLoaded(true);
            return EMPTY;
        })));
        this.addPartition = this.effect((partition$) => partition$.pipe(tap(() => this.setLoaded(false)), mergeMap((partition) => this.customerPartitionService.add(partition)), tap((partition) => this.addCustomerPartition(partition)), tap(() => this.setLoaded(true)), tap(() => this.notificationService.popNotificationMessage({
            type: 'success',
            title: 'Project Added',
            message: 'A new project added successfully',
        })), catchError((e) => {
            this.errorHandler.handleError(e);
            this.setLoaded(true);
            return EMPTY;
        })));
        this.selectPartition = this.effect((partition$) => combineLatest([partition$, this.configProvider.getCurrentUserAppId()]).pipe(filter$1(([partition, userId]) => isNotNil(partition) && isNotNil(userId)), tap(([partition]) => this.setSelectedPartition(partition)), tap(([partition]) => this.loadPartitionKeys(partition.id)), mergeMap(([partition, userId]) => this.partitionStashRepository.set({ id: userId, partitionId: partition.id, userId })), catchError((e) => {
            this.errorHandler.handleError(e);
            this.setLoaded(true);
            return EMPTY;
        })));
        this.deletePartition = this.effect((partition$) => partition$.pipe(tap(() => this.setLoaded(false)), tap((partition) => this.removePartition(partition)), mergeMap((partition) => this.customerPartitionService.delete(partition.id)), tap(() => this.setLoaded(true)), tap(() => this.notificationService.popNotificationMessage({
            type: 'warning',
            title: 'Project Deleted',
            message: 'Project removed successfully',
        })), catchError((e) => {
            this.errorHandler.handleError(e);
            this.setLoaded(true);
            return EMPTY;
        })));
        this.selectApiKey = this.effect((apiKey$) => apiKey$.pipe(tap((apiKey) => {
            this.setSelectedApiKey(apiKey);
        })));
        this.createApiKey = this.effect((keyRequest$) => keyRequest$.pipe(tap(() => this.setLoaded(false)), mergeMap((keyRequest) => this.customerPartitionService.addApiKey(keyRequest)), tap((key) => this.addPartitionKey(key)), tap((key) => this.setSelectedApiKey(key)), tap(() => this.setLoaded(true)), catchError((e) => {
            this.errorHandler.handleError(e);
            this.setLoaded(true);
            return EMPTY;
        })));
        this.deleteApiKey = this.effect((keyDeleteRequest$) => keyDeleteRequest$.pipe(tap(() => this.setLoaded(false)), tap((keyDeleteRequest) => this.removePartitionKey(keyDeleteRequest)), mergeMap((keyDeleteRequest) => this.customerPartitionService.deleteKey(keyDeleteRequest.keyId)), tap(() => this.setLoaded(true)), catchError((e) => {
            this.errorHandler.handleError(e);
            this.setLoaded(true);
            return EMPTY;
        })));
        this.rotatePartitionKey = this.effect((keyRotationRequest$) => keyRotationRequest$.pipe(tap(() => this.setLoaded(false)), tap((keyRotationRequest) => this.removePartitionKey(keyRotationRequest)), mergeMap((keyRotationRequest) => this.customerPartitionService.rotateKey(keyRotationRequest)), tap((key) => this.addPartitionKey(key)), tap((key) => this.setSelectedApiKey(key)), tap(() => this.setLoaded(true)), catchError((e) => {
            this.errorHandler.handleError(e);
            this.setLoaded(true);
            return EMPTY;
        })));
        // Updaters
        this.setCustomerPartitions = this.updater((state, partitions) => ({
            ...state,
            customerPartitions: partitions,
            partitionGroups: this.makeGroups(partitions),
            loaded: true,
        }));
        this.addCustomerPartition = this.updater((state, partition) => ({
            ...state,
            customerPartitions: state.customerPartitions.concat([partition]),
            partitionGroups: this.makeGroups(state.customerPartitions.concat([partition])),
            loaded: true,
        }));
        this.updateCustomerPartition = this.updater((state, partition) => ({
            ...state,
            customerPartitions: state.customerPartitions.map((p) => (p.id === partition.id ? partition : p)),
            partitionGroups: this.makeGroups(state.customerPartitions.map((p) => (p.id === partition.id ? partition : p))),
            loaded: true,
        }));
        this.removePartition = this.updater((state, partition) => ({
            ...state,
            customerPartitions: state.customerPartitions.filter((k) => k.id !== partition.id),
        }));
        this.setSelectedPartition = this.updater((state, partition) => ({
            ...state,
            selectedPartition: partition || null,
        }));
        this.setPartitionKeys = this.updater((state, keys) => ({
            ...state,
            selectedPartitionKeys: keys,
        }));
        this.setSelectedApiKey = this.updater((state, apiKey) => ({
            ...state,
            selectedApiKey: apiKey,
        }));
        this.addPartitionKey = this.updater((state, key) => ({
            ...state,
            selectedPartitionKeys: state.selectedPartitionKeys.concat([key]),
        }));
        this.removePartitionKey = this.updater((state, keyRotationRequest) => ({
            ...state,
            selectedPartitionKeys: state.selectedPartitionKeys.filter((k) => k.id !== keyRotationRequest.keyId),
        }));
        this.setLoaded = this.updater((state, loaded) => ({
            ...state,
            loaded: loaded,
        }));
    }
    // helpers
    makeGroups(partitions) {
        const groups = [];
        partitions.map((p) => (groups.includes(p.group) ? false : groups.push(p.group)));
        return groups;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManagePartitionComponentStore, deps: [{ token: LOGGER_TOKEN }, { token: BaseCustomerConfigProvider }, { token: CustomerDataPartitionService }, { token: i1$3.E11ErrorHandlerService }, { token: i3.E11NotificationsService }, { token: PartitionStashRepository }, { token: i2$1.Router }, { token: CustomerPartitionConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManagePartitionComponentStore, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ManagePartitionComponentStore, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOGGER_TOKEN]
                }] }, { type: BaseCustomerConfigProvider }, { type: CustomerDataPartitionService }, { type: i1$3.E11ErrorHandlerService }, { type: i3.E11NotificationsService }, { type: PartitionStashRepository }, { type: i2$1.Router }, { type: CustomerPartitionConfigProvider }] });

async function copyItem(item) {
    copyToClipboard(item);
    await sleep(2000);
}
/**
 * Copies the given data to the clipboard
 * @param toCopy
 */
function copyToClipboard(toCopy) {
    try {
        navigator.clipboard.writeText(toCopy);
    }
    catch (error) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = toCopy;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }
}

class ApiKeyShowComponent {
    constructor(store) {
        this.store = store;
        this.COPY_API_KEY_TEXT = 'apiKey';
        this.showCopiedMessage = false;
        this.selectedApiKey$ = this.store.selectedApiKey$;
    }
    ngOnInit() { }
    async copyApiKey(key) {
        if (key) {
            this.showCopiedMessage = true;
            await copyItem(key);
            this.showCopiedMessage = false;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ApiKeyShowComponent, deps: [{ token: ManagePartitionComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ApiKeyShowComponent, selector: "customer-api-key-show", ngImport: i0, template: "<ng-container *ngrxLet=\"selectedApiKey$ as apiKey\">\n  <div *ngIf=\"apiKey?.oneTimePlainTextKey\">\n    <div\n      role=\"button\"\n      class=\"e11-flex e11-gap-4 e11-flex-row e11-cursor-pointer e11-items-center e11 e11-flex-wrap e11-break-all\"\n      (click)=\"copyApiKey(apiKey?.oneTimePlainTextKey)\"\n    >\n      <span class=\"e11-p-2 e11-bg-gray-100 e11-rounded-lg e11-w-[70%]\">\n        {{ apiKey?.oneTimePlainTextKey }}\n      </span>\n      <span class=\"material-icons md-18\">content_copy</span>\n      <span class=\"e11-flex e11-items-center\" *ngIf=\"showCopiedMessage\">\n        <span class=\"material-icons-outlined md-18 e11-mr-1\"> done </span>\n        {{ \"Copied!\" | translate }}\n      </span>\n    </div>\n\n    <div>\n      <div class=\"e11-font-semibold e11-text-skin-error\">\n        {{ \"Please copy this API key and store it as a secret, this is the only time it be available in plain text.\" | translate }}\n      </div>\n      <div class=\"e11-font-semibold\">\n        {{\n          \"This is the admin API key. Please keep it secret and use it only from your backend: this key is used to create, update and delete your data.\"\n            | translate\n        }}\n      </div>\n    </div>\n  </div>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ApiKeyShowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-api-key-show', template: "<ng-container *ngrxLet=\"selectedApiKey$ as apiKey\">\n  <div *ngIf=\"apiKey?.oneTimePlainTextKey\">\n    <div\n      role=\"button\"\n      class=\"e11-flex e11-gap-4 e11-flex-row e11-cursor-pointer e11-items-center e11 e11-flex-wrap e11-break-all\"\n      (click)=\"copyApiKey(apiKey?.oneTimePlainTextKey)\"\n    >\n      <span class=\"e11-p-2 e11-bg-gray-100 e11-rounded-lg e11-w-[70%]\">\n        {{ apiKey?.oneTimePlainTextKey }}\n      </span>\n      <span class=\"material-icons md-18\">content_copy</span>\n      <span class=\"e11-flex e11-items-center\" *ngIf=\"showCopiedMessage\">\n        <span class=\"material-icons-outlined md-18 e11-mr-1\"> done </span>\n        {{ \"Copied!\" | translate }}\n      </span>\n    </div>\n\n    <div>\n      <div class=\"e11-font-semibold e11-text-skin-error\">\n        {{ \"Please copy this API key and store it as a secret, this is the only time it be available in plain text.\" | translate }}\n      </div>\n      <div class=\"e11-font-semibold\">\n        {{\n          \"This is the admin API key. Please keep it secret and use it only from your backend: this key is used to create, update and delete your data.\"\n            | translate\n        }}\n      </div>\n    </div>\n  </div>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: ManagePartitionComponentStore }] });

class ApiKeyEditComponent {
    constructor(formBuilder, customValidator, store) {
        this.formBuilder = formBuilder;
        this.customValidator = customValidator;
        this.store = store;
        this.scopes = DefaultApiKeyScopes;
        this.keyTypes = DefaultApiKeyTypes;
        this.cancelled = new EventEmitter();
        this.added = new EventEmitter();
        this.destroy$ = new Subject();
        this.partition$ = this.store.selectedPartition$;
        this.selectedApiKey$ = this.store.selectedApiKey$;
        this.formEditKey = this.formBuilder.group({
            description: new FormControl(undefined, [Validators.required, Validators.maxLength(150), E11FormValidator.whitespaceValidator()]),
            scopes: new FormControl(undefined, [Validators.required]),
            type: new FormControl(undefined, [Validators.required]),
            ttl: new FormControl(undefined, [this.customValidator.notPastDateValidator]),
        });
    }
    ngOnInit() {
        this.partition$.pipe(takeUntil(this.destroy$)).subscribe((partition) => {
            this.partition = partition;
        });
        this.selectedApiKey$.pipe(takeUntil(this.destroy$)).subscribe((key) => {
            this.selectedApiKey = key;
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    get f() {
        return this.formEditKey.controls;
    }
    save() {
        if (this.partition && this.formEditKey?.valid && this.formEditKey.dirty) {
            const keyRequest = {
                scopes: this.formEditKey.value.scopes,
                partitionId: this.partition.id,
                description: this.formEditKey.value.description,
                type: this.formEditKey.value.type,
                ttl: this.formEditKey.value.ttl ? new Date(this.formEditKey.value.ttl) : undefined,
            };
            this.store.createApiKey(keyRequest);
            this.added.emit();
        }
        else {
            this.formEditKey?.updateValueAndValidity();
            Validation.validateAll(this.formEditKey);
        }
    }
    resetForm() {
        this.formEditKey.reset({
            description: undefined,
            scopes: undefined,
            type: undefined,
            ttl: undefined,
        }, { emitEvent: false });
    }
    cancel() {
        this.resetForm();
        this.store.selectApiKey(undefined);
        this.cancelled.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ApiKeyEditComponent, deps: [{ token: i1.FormBuilder }, { token: i2$2.E11FormValidationService }, { token: ManagePartitionComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ApiKeyEditComponent, selector: "customer-api-key-edit", inputs: { scopes: "scopes", keyTypes: "keyTypes" }, outputs: { cancelled: "cancelled", added: "added" }, ngImport: i0, template: "<form *ngIf=\"formEditKey\" [formGroup]=\"formEditKey\">\n  <div class=\"e11-w-1/2 e11-pb-1\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"description\"\n      id=\"description\"\n      label=\"{{ 'Description' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formEditKey\"\n      [autofocus]=\"false\"\n      [maxLength]=\"20\"\n      formControlName=\"description\"\n      autocomplete=\"off\"\n      [hasError]=\"!!(f.description.errors && f.description.dirty)\"\n    >\n      <e11-input-errors [parentForm]=\"formEditKey\" [formControl]=\"f.description\" label=\"{{ 'Description' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n  <div class=\"e11-w-1/2 e11-pb-6\">\n    <e11-multi-select\n      id=\"scopes\"\n      name=\"scopes\"\n      [label]=\"'Scopes' | translate\"\n      [options]=\"scopes\"\n      selectMessage=\"Select Scopes\"\n      [hasError]=\"false\"\n      [required]=\"true\"\n      [disabled]=\"false\"\n      formControlName=\"scopes\"\n      [hasError]=\"!!(f.scopes.errors && f.scopes.dirty)\"\n    >\n      <e11-input-errors [parentForm]=\"formEditKey\" [formControl]=\"f.scopes\" label=\"{{ 'Scopes' | translate }}\"></e11-input-errors>\n    </e11-multi-select>\n  </div>\n  <div class=\"e11-w-1/2 e11-pb-6\">\n    <e11-select\n      name=\"keyType\"\n      id=\"keyType\"\n      [label]=\"'Key Type' | translate\"\n      [required]=\"false\"\n      [options]=\"keyTypes\"\n      [disabled]=\"false\"\n      formControlName=\"type\"\n      [hasError]=\"!!(f.type.errors && f.type.dirty)\"\n    >\n      <!-- <e11-input-errors [parentForm]=\"formEditKey\" [formControl]=\"f.type\" label=\"{{ 'Type' | translate }}\"></e11-input-errors> -->\n    </e11-select>\n  </div>\n  <div class=\"e11-w-1/2 e11-pb-1\">\n    <e11-input\n      [type]=\"'date'\"\n      name=\"ttl\"\n      id=\"ttl\"\n      label=\"{{ 'TTL (optional)' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formEditKey\"\n      [autofocus]=\"false\"\n      [maxLength]=\"20\"\n      formControlName=\"ttl\"\n      autocomplete=\"off\"\n      [hasError]=\"!!(f.ttl.errors && f.ttl.dirty)\"\n    >\n      <e11-input-errors [parentForm]=\"formEditKey\" [formControl]=\"f.ttl\" label=\"{{ 'TTL' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n</form>\n<customer-api-key-show *ngIf=\"selectedApiKey\"></customer-api-key-show>\n\n<div class=\"e11-flex e11-justify-end e11-p-1 e11-flex-shrink-0\">\n  <e11-button *ngIf=\"!selectedApiKey\" (click)=\"cancel()\" value=\"{{ 'Cancel' | translate }}\" color=\"neutral\" [buttonGroup]=\"true\" [size]=\"'sm'\">\n  </e11-button>\n  <e11-button *ngIf=\"!!selectedApiKey\" (click)=\"cancel()\" value=\"{{ 'Done' | translate }}\" color=\"neutral\" [buttonGroup]=\"true\" [size]=\"'sm'\">\n  </e11-button>\n  <e11-button\n    (click)=\"save()\"\n    [disabled]=\"!!selectedApiKey\"\n    value=\"{{ 'Create' | translate }}\"\n    color=\"primary-accent\"\n    [buttonGroup]=\"true\"\n    [size]=\"'sm'\"\n  >\n  </e11-button>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "component", type: i7.E11SelectComponent, selector: "e11-select", inputs: ["id", "name", "label", "size", "selectMessage", "labelClass", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "selectClass"], outputs: ["valueChange", "onValueChange"] }, { kind: "component", type: i11.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i8.E11MultiSelectComponent, selector: "e11-multi-select", inputs: ["id", "name", "label", "selectMessage", "labelClassOverrides", "checkboxClassOverrides", "inputClass", "containerClass", "parentForm", "formControlName", "options", "value", "hasError", "required", "disabled", "loading", "tooltipConfig", "labelTextOptional", "searchable", "searchResultsEmpty", "isDropdownSelect", "dropdownContainerClass", "inputClassOverrides"], outputs: ["valueChange"] }, { kind: "component", type: i2$2.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: ApiKeyShowComponent, selector: "customer-api-key-show" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ApiKeyEditComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-api-key-edit', template: "<form *ngIf=\"formEditKey\" [formGroup]=\"formEditKey\">\n  <div class=\"e11-w-1/2 e11-pb-1\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"description\"\n      id=\"description\"\n      label=\"{{ 'Description' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formEditKey\"\n      [autofocus]=\"false\"\n      [maxLength]=\"20\"\n      formControlName=\"description\"\n      autocomplete=\"off\"\n      [hasError]=\"!!(f.description.errors && f.description.dirty)\"\n    >\n      <e11-input-errors [parentForm]=\"formEditKey\" [formControl]=\"f.description\" label=\"{{ 'Description' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n  <div class=\"e11-w-1/2 e11-pb-6\">\n    <e11-multi-select\n      id=\"scopes\"\n      name=\"scopes\"\n      [label]=\"'Scopes' | translate\"\n      [options]=\"scopes\"\n      selectMessage=\"Select Scopes\"\n      [hasError]=\"false\"\n      [required]=\"true\"\n      [disabled]=\"false\"\n      formControlName=\"scopes\"\n      [hasError]=\"!!(f.scopes.errors && f.scopes.dirty)\"\n    >\n      <e11-input-errors [parentForm]=\"formEditKey\" [formControl]=\"f.scopes\" label=\"{{ 'Scopes' | translate }}\"></e11-input-errors>\n    </e11-multi-select>\n  </div>\n  <div class=\"e11-w-1/2 e11-pb-6\">\n    <e11-select\n      name=\"keyType\"\n      id=\"keyType\"\n      [label]=\"'Key Type' | translate\"\n      [required]=\"false\"\n      [options]=\"keyTypes\"\n      [disabled]=\"false\"\n      formControlName=\"type\"\n      [hasError]=\"!!(f.type.errors && f.type.dirty)\"\n    >\n      <!-- <e11-input-errors [parentForm]=\"formEditKey\" [formControl]=\"f.type\" label=\"{{ 'Type' | translate }}\"></e11-input-errors> -->\n    </e11-select>\n  </div>\n  <div class=\"e11-w-1/2 e11-pb-1\">\n    <e11-input\n      [type]=\"'date'\"\n      name=\"ttl\"\n      id=\"ttl\"\n      label=\"{{ 'TTL (optional)' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formEditKey\"\n      [autofocus]=\"false\"\n      [maxLength]=\"20\"\n      formControlName=\"ttl\"\n      autocomplete=\"off\"\n      [hasError]=\"!!(f.ttl.errors && f.ttl.dirty)\"\n    >\n      <e11-input-errors [parentForm]=\"formEditKey\" [formControl]=\"f.ttl\" label=\"{{ 'TTL' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n</form>\n<customer-api-key-show *ngIf=\"selectedApiKey\"></customer-api-key-show>\n\n<div class=\"e11-flex e11-justify-end e11-p-1 e11-flex-shrink-0\">\n  <e11-button *ngIf=\"!selectedApiKey\" (click)=\"cancel()\" value=\"{{ 'Cancel' | translate }}\" color=\"neutral\" [buttonGroup]=\"true\" [size]=\"'sm'\">\n  </e11-button>\n  <e11-button *ngIf=\"!!selectedApiKey\" (click)=\"cancel()\" value=\"{{ 'Done' | translate }}\" color=\"neutral\" [buttonGroup]=\"true\" [size]=\"'sm'\">\n  </e11-button>\n  <e11-button\n    (click)=\"save()\"\n    [disabled]=\"!!selectedApiKey\"\n    value=\"{{ 'Create' | translate }}\"\n    color=\"primary-accent\"\n    [buttonGroup]=\"true\"\n    [size]=\"'sm'\"\n  >\n  </e11-button>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.FormBuilder }, { type: i2$2.E11FormValidationService }, { type: ManagePartitionComponentStore }], propDecorators: { scopes: [{
                type: Input
            }], keyTypes: [{
                type: Input
            }], cancelled: [{
                type: Output
            }], added: [{
                type: Output
            }] } });

class ApiKeyRow {
    constructor(store) {
        this.store = store;
        this.rotated = new EventEmitter();
        this.delete = new EventEmitter();
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ApiKeyRow, deps: [{ token: ManagePartitionComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ApiKeyRow, selector: "customer-partition-key-row", inputs: { apiKey: "apiKey" }, outputs: { rotated: "rotated", delete: "delete" }, ngImport: i0, template: "<div class=\"e11-flex\">\n  <button\n    type=\"button\"\n    (click)=\"rotated.emit()\"\n    class=\"e11-flex-shrink-0 e11-flex e11-items-center e11-p-1 e11-text-skin-base e11-text-opacity-70 e11-rounded-md hover:e11-bg-gray-400 hover:e11-bg-opacity-10 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-skin-primary-accent\"\n  >\n    <span class=\"e11-sr-only\">{{ \"Rotate\" | translate }}</span>\n    <span class=\"material-icons-outlined\"> cached </span>\n  </button>\n\n  <button\n    type=\"button\"\n    (click)=\"delete.emit()\"\n    class=\"e11-flex-shrink-0 e11-flex e11-items-center e11-p-1 e11-text-skin-base e11-text-opacity-70 e11-rounded-md hover:e11-bg-gray-400 hover:e11-bg-opacity-10 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-skin-primary-accent\"\n  >\n    <span class=\"e11-sr-only\">{{ \"Delete\" | translate }}</span>\n    <span class=\"material-icons-outlined\"> delete </span>\n  </button>\n</div>\n", styles: [""], dependencies: [{ kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ApiKeyRow, decorators: [{
            type: Component,
            args: [{ selector: 'customer-partition-key-row', template: "<div class=\"e11-flex\">\n  <button\n    type=\"button\"\n    (click)=\"rotated.emit()\"\n    class=\"e11-flex-shrink-0 e11-flex e11-items-center e11-p-1 e11-text-skin-base e11-text-opacity-70 e11-rounded-md hover:e11-bg-gray-400 hover:e11-bg-opacity-10 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-skin-primary-accent\"\n  >\n    <span class=\"e11-sr-only\">{{ \"Rotate\" | translate }}</span>\n    <span class=\"material-icons-outlined\"> cached </span>\n  </button>\n\n  <button\n    type=\"button\"\n    (click)=\"delete.emit()\"\n    class=\"e11-flex-shrink-0 e11-flex e11-items-center e11-p-1 e11-text-skin-base e11-text-opacity-70 e11-rounded-md hover:e11-bg-gray-400 hover:e11-bg-opacity-10 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-skin-primary-accent\"\n  >\n    <span class=\"e11-sr-only\">{{ \"Delete\" | translate }}</span>\n    <span class=\"material-icons-outlined\"> delete </span>\n  </button>\n</div>\n" }]
        }], ctorParameters: () => [{ type: ManagePartitionComponentStore }], propDecorators: { apiKey: [{
                type: Input
            }], rotated: [{
                type: Output
            }], delete: [{
                type: Output
            }] } });

class ApiKeyListComponent {
    constructor(store) {
        this.store = store;
        this.scopes = DefaultApiKeyScopes;
        this.keyTypes = DefaultApiKeyTypes;
        this.apiKeyRotated = new EventEmitter();
        this.showCopiedMessage = false;
        this.partitionKeys$ = this.store.selectedPartitionKeys$;
        this.destroy$ = new Subject();
        this.loaded$ = this.store.loaded$;
        this.partition$ = this.store.selectedPartition$;
    }
    ngOnInit() {
        this.partition$?.pipe(takeUntil(this.destroy$)).subscribe((partition) => {
            this.partition = partition;
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    addEditKey() {
        this.resetSelected();
        this.editApiKeyModal.open();
    }
    editCancelled() {
        this.editApiKeyModal.close();
    }
    save() { }
    rotateKey(keyId, partitionId) {
        const keyRotationRequest = {
            keyId: keyId,
            partitionId: partitionId,
        };
        this.store.rotatePartitionKey(keyRotationRequest);
        this.rotationConfirmation.open();
    }
    async copyApiKey(key) {
        if (key) {
            this.showCopiedMessage = true;
            await copyItem(key);
            this.showCopiedMessage = false;
        }
    }
    confirmDelete(confirmed) {
        if (this.selectedKey && this.selectedKey.partitionId && confirmed) {
            this.store.deleteApiKey({ keyId: this.selectedKey.id, partitionId: this.selectedKey.partitionId });
            this.store.selectApiKey(undefined);
        }
    }
    resetSelected() {
        this.store.selectApiKey(undefined);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ApiKeyListComponent, deps: [{ token: ManagePartitionComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ApiKeyListComponent, selector: "customer-api-key-list", inputs: { scopes: "scopes", keyTypes: "keyTypes" }, outputs: { apiKeyRotated: "apiKeyRotated" }, viewQueries: [{ propertyName: "editApiKeyModal", first: true, predicate: ["editApiKey"], descendants: true }, { propertyName: "rotationConfirmation", first: true, predicate: ["rotationConfirmation"], descendants: true }], ngImport: i0, template: "<e11-panel>\n  <div class=\"e11-justify-between e11-items-center e11-flex e11-p-4\">\n    <h4>{{ \"Project Keys\" | translate }}</h4>\n    <e11-button color=\"primary-accent\" [value]=\"'New Api Key' | translate\" [disabled]=\"false\" (click)=\"addEditKey()\"> </e11-button>\n  </div>\n  <ng-container *ngrxLet=\"loaded$ as loaded\">\n    <ng-container *ngrxLet=\"partitionKeys$ as partitionKeys\">\n      <table class=\"e11-min-w-full e11-divide-y e11-divide-gray-300\">\n        <thead>\n          <tr>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"Api Key\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"Restrictions\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold e11-float-right\">{{ \"Action\" }}</th>\n          </tr>\n        </thead>\n        <tbody class=\"e11-divide-y e11-divide-gray-100 e11-bg-white\">\n          <tr *ngFor=\"let key of partitionKeys; let i = index\">\n            <td class=\"e11-flex e11-flex-col e11-gap-2 e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-600\">\n              <p class=\"e11-mb-0 e11-text-skin-base\">{{ key.description }}</p>\n              <p class=\"e11-mb-0 e11-text-skin-light\">{{ \"Created on\" | translate }} {{ key.__createdAt | date }}</p>\n              <p class=\"e11-mb-0 e11-text-skin-light\">{{ key.id }}</p>\n            </td>\n\n            <td class=\"e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500\">\n              <span class=\"e11-font-semibold\"> {{ \"Scopes\" | translate }} : </span>\n              <span\n                *ngFor=\"let scope of key.scopes\"\n                class=\"e11-inline-flex e11-items-center e11-rounded-full e11-border e11-bg-gray-400 e11-bg-opacity-10 e11-px-2.5 e11-py-0.5 e11-text-xs e11-font-medium e11-text-skin-base e11-mx-1\"\n                >{{ scope | translate }}</span\n              >\n            </td>\n            <td class=\"e11-relative e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500 e11-float-right\">\n              <customer-partition-key-row\n                [apiKey]=\"key\"\n                (rotated)=\"selectedKey = key; rotateKey(key.id, key.partitionId!)\"\n                (delete)=\"selectedKey = key; confirmation.open()\"\n              ></customer-partition-key-row>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <div *ngIf=\"loaded\">\n        <!-- Empty State -->\n        <div class=\"col-xs-12 text-center e11-mb-16\" *ngIf=\"!partitionKeys?.length\">\n          <!-- Empty State -->\n          <e11-empty-state\n            [icon]=\"'group'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No api key' | translate }}\"\n            subtitle=\"{{ 'There are currently no APi keys.' | translate }}\"\n            [clickable]=\"false\"\n          ></e11-empty-state>\n        </div>\n      </div>\n    </ng-container>\n    <div\n      class=\"e11-loader-fading e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center e11-top-4 active\"\n      [ngClass]=\"{ active: !loaded }\"\n    >\n      <e11-loader-dots *ngIf=\"!loaded\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n    </div>\n  </ng-container>\n</e11-panel>\n\n<e11-modal\n  #editApiKey\n  [darkMode]=\"false\"\n  [title]=\"'Add Key' | translate\"\n  [showHeader]=\"true\"\n  [showFooter]=\"true\"\n  [hideCloseButton]=\"false\"\n  (modalClosed)=\"customerApiKeyEdit.cancel()\"\n  [width]=\"'md'\"\n>\n  <div modal-body>\n    <customer-api-key-edit #customerApiKeyEdit (cancelled)=\"editCancelled()\" [scopes]=\"scopes\" [keyTypes]=\"keyTypes\"></customer-api-key-edit>\n  </div>\n\n  <div modal-footer>\n    <div class=\"e11-flex e11-justify-start e11-font-bold\">{{ partition?.group }}.{{ partition?.name }}</div>\n  </div>\n</e11-modal>\n\n<e11-confirmation\n  #confirmation\n  confirmTitle=\"{{ 'Remove api key' | translate }}\"\n  confirmText=\"{{ 'Delete api key' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [confirmClassOverrides]=\"'e11-bg-skin-error'\"\n  [isMobile]=\"false\"\n  (answer)=\"confirmDelete($event)\"\n>\n  {{ \"WARNING: Deleting this api key will invalidate request from any existing app that use the key.\" | translate }}\n</e11-confirmation>\n\n<e11-confirmation\n  #rotationConfirmation\n  confirmTitle=\"{{ 'New api key' | translate }}\"\n  confirmText=\"{{ 'Confirm' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  (answer)=\"resetSelected()\"\n  [backdropStyle]=\"'dark'\"\n  [confirmClassOverrides]=\"'e11-bg-skin-error'\"\n  [closeOnClickOutside]=\"false\"\n  [closeOnEscape]=\"true\"\n  [isMobile]=\"false\"\n>\n  <customer-api-key-show></customer-api-key-show>\n  <span class=\"e11-p-1 e11-bg-gray-100 e11-rounded-lg\" *ngIf=\"!selectedKey?.id\">\n    {{ \"The API Key will be displayed here ONCE when it is first created\" | translate }}\n  </span>\n</e11-confirmation>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i5.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: i5$1.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: ApiKeyEditComponent, selector: "customer-api-key-edit", inputs: ["scopes", "keyTypes"], outputs: ["cancelled", "added"] }, { kind: "component", type: ApiKeyRow, selector: "customer-partition-key-row", inputs: ["apiKey"], outputs: ["rotated", "delete"] }, { kind: "component", type: ApiKeyShowComponent, selector: "customer-api-key-show" }, { kind: "pipe", type: i1$2.DatePipe, name: "date" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ApiKeyListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-api-key-list', template: "<e11-panel>\n  <div class=\"e11-justify-between e11-items-center e11-flex e11-p-4\">\n    <h4>{{ \"Project Keys\" | translate }}</h4>\n    <e11-button color=\"primary-accent\" [value]=\"'New Api Key' | translate\" [disabled]=\"false\" (click)=\"addEditKey()\"> </e11-button>\n  </div>\n  <ng-container *ngrxLet=\"loaded$ as loaded\">\n    <ng-container *ngrxLet=\"partitionKeys$ as partitionKeys\">\n      <table class=\"e11-min-w-full e11-divide-y e11-divide-gray-300\">\n        <thead>\n          <tr>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"Api Key\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"Restrictions\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold e11-float-right\">{{ \"Action\" }}</th>\n          </tr>\n        </thead>\n        <tbody class=\"e11-divide-y e11-divide-gray-100 e11-bg-white\">\n          <tr *ngFor=\"let key of partitionKeys; let i = index\">\n            <td class=\"e11-flex e11-flex-col e11-gap-2 e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-600\">\n              <p class=\"e11-mb-0 e11-text-skin-base\">{{ key.description }}</p>\n              <p class=\"e11-mb-0 e11-text-skin-light\">{{ \"Created on\" | translate }} {{ key.__createdAt | date }}</p>\n              <p class=\"e11-mb-0 e11-text-skin-light\">{{ key.id }}</p>\n            </td>\n\n            <td class=\"e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500\">\n              <span class=\"e11-font-semibold\"> {{ \"Scopes\" | translate }} : </span>\n              <span\n                *ngFor=\"let scope of key.scopes\"\n                class=\"e11-inline-flex e11-items-center e11-rounded-full e11-border e11-bg-gray-400 e11-bg-opacity-10 e11-px-2.5 e11-py-0.5 e11-text-xs e11-font-medium e11-text-skin-base e11-mx-1\"\n                >{{ scope | translate }}</span\n              >\n            </td>\n            <td class=\"e11-relative e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500 e11-float-right\">\n              <customer-partition-key-row\n                [apiKey]=\"key\"\n                (rotated)=\"selectedKey = key; rotateKey(key.id, key.partitionId!)\"\n                (delete)=\"selectedKey = key; confirmation.open()\"\n              ></customer-partition-key-row>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n      <div *ngIf=\"loaded\">\n        <!-- Empty State -->\n        <div class=\"col-xs-12 text-center e11-mb-16\" *ngIf=\"!partitionKeys?.length\">\n          <!-- Empty State -->\n          <e11-empty-state\n            [icon]=\"'group'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No api key' | translate }}\"\n            subtitle=\"{{ 'There are currently no APi keys.' | translate }}\"\n            [clickable]=\"false\"\n          ></e11-empty-state>\n        </div>\n      </div>\n    </ng-container>\n    <div\n      class=\"e11-loader-fading e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center e11-top-4 active\"\n      [ngClass]=\"{ active: !loaded }\"\n    >\n      <e11-loader-dots *ngIf=\"!loaded\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n    </div>\n  </ng-container>\n</e11-panel>\n\n<e11-modal\n  #editApiKey\n  [darkMode]=\"false\"\n  [title]=\"'Add Key' | translate\"\n  [showHeader]=\"true\"\n  [showFooter]=\"true\"\n  [hideCloseButton]=\"false\"\n  (modalClosed)=\"customerApiKeyEdit.cancel()\"\n  [width]=\"'md'\"\n>\n  <div modal-body>\n    <customer-api-key-edit #customerApiKeyEdit (cancelled)=\"editCancelled()\" [scopes]=\"scopes\" [keyTypes]=\"keyTypes\"></customer-api-key-edit>\n  </div>\n\n  <div modal-footer>\n    <div class=\"e11-flex e11-justify-start e11-font-bold\">{{ partition?.group }}.{{ partition?.name }}</div>\n  </div>\n</e11-modal>\n\n<e11-confirmation\n  #confirmation\n  confirmTitle=\"{{ 'Remove api key' | translate }}\"\n  confirmText=\"{{ 'Delete api key' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [confirmClassOverrides]=\"'e11-bg-skin-error'\"\n  [isMobile]=\"false\"\n  (answer)=\"confirmDelete($event)\"\n>\n  {{ \"WARNING: Deleting this api key will invalidate request from any existing app that use the key.\" | translate }}\n</e11-confirmation>\n\n<e11-confirmation\n  #rotationConfirmation\n  confirmTitle=\"{{ 'New api key' | translate }}\"\n  confirmText=\"{{ 'Confirm' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  (answer)=\"resetSelected()\"\n  [backdropStyle]=\"'dark'\"\n  [confirmClassOverrides]=\"'e11-bg-skin-error'\"\n  [closeOnClickOutside]=\"false\"\n  [closeOnEscape]=\"true\"\n  [isMobile]=\"false\"\n>\n  <customer-api-key-show></customer-api-key-show>\n  <span class=\"e11-p-1 e11-bg-gray-100 e11-rounded-lg\" *ngIf=\"!selectedKey?.id\">\n    {{ \"The API Key will be displayed here ONCE when it is first created\" | translate }}\n  </span>\n</e11-confirmation>\n" }]
        }], ctorParameters: () => [{ type: ManagePartitionComponentStore }], propDecorators: { scopes: [{
                type: Input
            }], keyTypes: [{
                type: Input
            }], apiKeyRotated: [{
                type: Output
            }], editApiKeyModal: [{
                type: ViewChild,
                args: ['editApiKey']
            }], rotationConfirmation: [{
                type: ViewChild,
                args: ['rotationConfirmation']
            }] } });

class EditPartitionComponent {
    set partition(value) {
        if (!value) {
            this._partition = undefined;
            this.resetForm();
            return;
        }
        this._partition = value;
        this.patchForm(value);
    }
    constructor(formBuilder, store) {
        this.formBuilder = formBuilder;
        this.store = store;
        this.saved = new EventEmitter();
        this.cancelled = new EventEmitter();
        this.created = new EventEmitter();
        this.formEditPartition = this.formBuilder.group({
            name: new FormControl(undefined, [Validators.required, E11FormValidator.whitespaceValidator()]),
            group: new FormControl(undefined, [Validators.required, E11FormValidator.whitespaceValidator()]),
        });
        this.partitionGroups$ = this.store.partitionGroups$;
        this.destroy$ = new Subject();
        this.loaded$ = this.store.loaded$;
    }
    ngOnInit() { }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    patchForm(partition) {
        const patchValue = {
            name: partition?.name,
            group: partition?.group,
        };
        this.formEditPartition?.patchValue({ ...patchValue });
    }
    resetForm() {
        this.formEditPartition.reset({
            name: undefined,
            group: undefined,
        }, { emitEvent: false });
        if (!this.groupAutoComplete)
            return;
        this.groupAutoComplete.clear();
    }
    get f() {
        return this.formEditPartition.controls;
    }
    async save() {
        if (this.formEditPartition.valid && this.formEditPartition.dirty) {
            const formData = {
                name: this.formEditPartition.value.name,
                group: this.formEditPartition.value.group,
            };
            this.addOrUpdatePartition(formData, this._partition);
            this.formEditPartition.markAsPristine();
        }
        else {
            this.formEditPartition.updateValueAndValidity();
            Validation.validateAll(this.formEditPartition);
        }
    }
    addOrUpdatePartition(formData, partitionToUpdate) {
        if (partitionToUpdate) {
            partitionToUpdate = { ...partitionToUpdate, name: formData.name, group: formData.group };
            this.store.updatePartition(partitionToUpdate);
            this.saved.emit(partitionToUpdate);
        }
        else {
            this.store.addPartition(formData);
            this.created.emit();
            this.resetForm();
        }
    }
    cancel() {
        this.cancelled.emit();
        this.resetForm();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EditPartitionComponent, deps: [{ token: i1.FormBuilder }, { token: ManagePartitionComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: EditPartitionComponent, selector: "customer-edit-partition", inputs: { partition: "partition" }, outputs: { saved: "saved", cancelled: "cancelled", created: "created" }, viewQueries: [{ propertyName: "groupAutoComplete", first: true, predicate: ["groupAutoComplete"], descendants: true }], ngImport: i0, template: "<form *ngIf=\"formEditPartition\" [formGroup]=\"formEditPartition\">\n  <div class=\"e11-w-1/2 e11-pb-1\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"name\"\n      id=\"name\"\n      label=\"{{ 'Name*' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formEditPartition\"\n      [autofocus]=\"false\"\n      [maxLength]=\"20\"\n      formControlName=\"name\"\n      autocomplete=\"off\"\n      [hasError]=\"!!(f.name.errors && f.name.dirty)\"\n    >\n      <e11-input-errors [parentForm]=\"formEditPartition\" [formControl]=\"f.name\" label=\"{{ 'Name' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n  <div *ngrxLet=\"partitionGroups$ as partitionGroups\" class=\"e11-relative e11-w-1/2 e11-pb-10\">\n    <e11-autocomplete\n      #groupAutoComplete\n      [data]=\"partitionGroups\"\n      [isMultiSelect]=\"false\"\n      [isLoading]=\"false\"\n      (selected)=\"f.group.setValue($event)\"\n      (inputChanged)=\"f.group.setValue($event)\"\n      [initialValue]=\"f.group.value\"\n      [itemTemplate]=\"itemTemplate\"\n      [notFoundTemplate]=\"notFoundTemplate\"\n      [placeholder]=\"'Select group'\"\n      [style]=\"'e11-absolute'\"\n      [label]=\"'Group*' | translate\"\n    >\n      <e11-input-errors [parentForm]=\"formEditPartition\" [formControl]=\"f.group\" label=\"{{ 'Group' | translate }}\"></e11-input-errors>\n    </e11-autocomplete>\n    <ng-template #itemTemplate let-item>\n      <a [innerHTML]=\"item\"></a>\n    </ng-template>\n\n    <ng-template #notFoundTemplate let-notFound>\n      <div [innerHTML]=\"notFound\"></div>\n    </ng-template>\n  </div>\n</form>\n<ng-container *ngrxLet=\"loaded$ as loaded\">\n  <div\n    class=\"e11-loader-fading e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center e11-top-4 active\"\n    [ngClass]=\"{ active: !loaded }\"\n  >\n    <e11-loader-dots *ngIf=\"!loaded\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n  </div>\n</ng-container>\n<div class=\"e11-flex e11-justify-end e11-p-1 e11-flex-shrink-0 e11-mt-auto\">\n  <e11-button (click)=\"cancel()\" value=\"{{ 'Cancel' | translate }}\" color=\"neutral\" [buttonGroup]=\"true\" [size]=\"'sm'\"> </e11-button>\n  <e11-button (click)=\"save()\" value=\"{{ 'Save' | translate }}\" color=\"primary-accent\" [buttonGroup]=\"true\" [size]=\"'sm'\"> </e11-button>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i11.E11InputComponent, selector: "e11-input", inputs: ["containerClass", "inputClass", "hintText", "label", "type", "size", "style", "placeholder", "maxLength", "max", "name", "id", "iconLeft", "iconLeftBorder", "required", "hasError", "labelColor", "borderGlow", "checkIcon", "clearIcon", "autofocus", "togglePassword", "hasButton", "buttonText", "buttonIcon", "buttonIconType", "buttonIconSize", "readonly", "disabled", "disabledText", "autocomplete", "formControlName", "isRounded", "parentForm", "tooltipConfig", "icon", "iconType", "iconSize", "darkMode", "context", "enforceCharacterLimit", "showCharacterLimitWarning", "loading", "leadingIcon", "trailingIcon"], outputs: ["change", "focus", "blur"] }, { kind: "component", type: i7$4.E11AutocompleteComponent, selector: "e11-autocomplete", inputs: ["name", "label", "placeholder", "heading", "required", "initialValue", "data", "selectedData", "searchKeyword", "isMultiSelect", "notFoundText", "isLoading", "skeletonLoading", "debounceTime", "disabled", "minQueryLength", "focusFirst", "stopSelectEvent", "customFilter", "formControlName", "parentForm", "hasError", "itemTemplate", "notFoundTemplate"], outputs: ["selected", "inputChanged", "inputFocused", "inputCleared", "opened", "closed", "scrolledToEnd"] }, { kind: "component", type: i2$2.E11InputErrorsComponent, selector: "e11-input-errors", inputs: ["formControl", "parentForm", "label", "formSubmitted", "suppressError", "messageOverrides"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: EditPartitionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-edit-partition', template: "<form *ngIf=\"formEditPartition\" [formGroup]=\"formEditPartition\">\n  <div class=\"e11-w-1/2 e11-pb-1\">\n    <e11-input\n      [type]=\"'text'\"\n      name=\"name\"\n      id=\"name\"\n      label=\"{{ 'Name*' | translate }}\"\n      [size]=\"'md'\"\n      [borderGlow]=\"'primary'\"\n      [parentForm]=\"formEditPartition\"\n      [autofocus]=\"false\"\n      [maxLength]=\"20\"\n      formControlName=\"name\"\n      autocomplete=\"off\"\n      [hasError]=\"!!(f.name.errors && f.name.dirty)\"\n    >\n      <e11-input-errors [parentForm]=\"formEditPartition\" [formControl]=\"f.name\" label=\"{{ 'Name' | translate }}\"></e11-input-errors>\n    </e11-input>\n  </div>\n  <div *ngrxLet=\"partitionGroups$ as partitionGroups\" class=\"e11-relative e11-w-1/2 e11-pb-10\">\n    <e11-autocomplete\n      #groupAutoComplete\n      [data]=\"partitionGroups\"\n      [isMultiSelect]=\"false\"\n      [isLoading]=\"false\"\n      (selected)=\"f.group.setValue($event)\"\n      (inputChanged)=\"f.group.setValue($event)\"\n      [initialValue]=\"f.group.value\"\n      [itemTemplate]=\"itemTemplate\"\n      [notFoundTemplate]=\"notFoundTemplate\"\n      [placeholder]=\"'Select group'\"\n      [style]=\"'e11-absolute'\"\n      [label]=\"'Group*' | translate\"\n    >\n      <e11-input-errors [parentForm]=\"formEditPartition\" [formControl]=\"f.group\" label=\"{{ 'Group' | translate }}\"></e11-input-errors>\n    </e11-autocomplete>\n    <ng-template #itemTemplate let-item>\n      <a [innerHTML]=\"item\"></a>\n    </ng-template>\n\n    <ng-template #notFoundTemplate let-notFound>\n      <div [innerHTML]=\"notFound\"></div>\n    </ng-template>\n  </div>\n</form>\n<ng-container *ngrxLet=\"loaded$ as loaded\">\n  <div\n    class=\"e11-loader-fading e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center e11-top-4 active\"\n    [ngClass]=\"{ active: !loaded }\"\n  >\n    <e11-loader-dots *ngIf=\"!loaded\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n  </div>\n</ng-container>\n<div class=\"e11-flex e11-justify-end e11-p-1 e11-flex-shrink-0 e11-mt-auto\">\n  <e11-button (click)=\"cancel()\" value=\"{{ 'Cancel' | translate }}\" color=\"neutral\" [buttonGroup]=\"true\" [size]=\"'sm'\"> </e11-button>\n  <e11-button (click)=\"save()\" value=\"{{ 'Save' | translate }}\" color=\"primary-accent\" [buttonGroup]=\"true\" [size]=\"'sm'\"> </e11-button>\n</div>\n" }]
        }], ctorParameters: () => [{ type: i1.FormBuilder }, { type: ManagePartitionComponentStore }], propDecorators: { groupAutoComplete: [{
                type: ViewChild,
                args: ['groupAutoComplete']
            }], saved: [{
                type: Output
            }], cancelled: [{
                type: Output
            }], created: [{
                type: Output
            }], partition: [{
                type: Input
            }] } });

class PartitionListTdMoreComponent {
    onClick(targetElement) {
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.dropDownOpen = false;
        }
    }
    onKeydownHandler(event) {
        if (event.key === 'Escape') {
            this.dropDownOpen = false;
        }
    }
    constructor(elementRef, store) {
        this.elementRef = elementRef;
        this.store = store;
        this.onEdit = new EventEmitter();
        this.onDelete = new EventEmitter();
        this.dropDownOpen = false;
        this.selectedPartition$ = this.store.selectedPartition$;
    }
    onClickButton() {
        this.dropDownOpen = !this.dropDownOpen;
    }
    ngOnInit() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionListTdMoreComponent, deps: [{ token: i0.ElementRef }, { token: ManagePartitionComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PartitionListTdMoreComponent, selector: "partition-list-row", inputs: { partition: "partition" }, outputs: { onEdit: "onEdit", onDelete: "onDelete" }, host: { listeners: { "document:click": "onClick($event.target)", "document:keydown": "onKeydownHandler($event)" } }, ngImport: i0, template: "<ng-container *ngrxLet=\"selectedPartition$ as selectedPartition\">\n  <td class=\"e11-relative e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500 e11-float-right\">\n    <button\n      type=\"button\"\n      (click)=\"onClickButton()\"\n      class=\"e11-flex-shrink-0 e11-flex e11-items-center e11-p-1 e11-text-skin-base e11-rounded-md hover:e11-bg-gray-400 hover:e11-bg-opacity-10 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-skin-primary-accent\"\n    >\n      <span class=\"e11-sr-only\">{{ \"More action\" | translate }}</span>\n      <span class=\"material-icons-outlined\"> more_vert </span>\n    </button>\n    <ul\n      tabindex=\"-1\"\n      class=\"e11-absolute e11-right-0 e11-w-52 e11-z-10 e11-mt-1 e11-max-h-60 e11-overflow-auto e11-rounded-md e11-bg-white e11-py-1 e11-text-base e11-shadow-lg e11-ring-1 e11-ring-black e11-ring-opacity-5 focus:e11-outline-none sm:e11-text-sm\"\n      id=\"options\"\n      role=\"listbox\"\n      [ngClass]=\"{\n        'e11-hidden': !dropDownOpen,\n        'e11-block ': dropDownOpen\n      }\"\n    >\n      <li\n        class=\"e11-relative e11-cursor-pointer e11-select-none e11-py-2 e11-pl-3 e11-pr-9 e11-text-gray-900 hover:e11-bg-gray-400 hover:e11-bg-opacity-10\"\n        id=\"option-0\"\n        role=\"option\"\n        tabindex=\"-1\"\n        (click)=\"onEdit.emit()\"\n      >\n        {{ \"Edit\" | translate }}\n      </li>\n      <li\n        *ngIf=\"selectedPartition && selectedPartition.id !== partition.id\"\n        class=\"e11-relative e11-cursor-pointer e11-select-none e11-py-2 e11-pl-3 e11-pr-9 e11-text-gray-900 hover:e11-bg-gray-400 hover:e11-bg-opacity-10\"\n        id=\"option-0\"\n        role=\"option\"\n        tabindex=\"-1\"\n        (click)=\"onDelete.emit()\"\n      >\n        {{ \"Delete\" | translate }}\n      </li>\n    </ul>\n  </td>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionListTdMoreComponent, decorators: [{
            type: Component,
            args: [{ selector: 'partition-list-row', template: "<ng-container *ngrxLet=\"selectedPartition$ as selectedPartition\">\n  <td class=\"e11-relative e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500 e11-float-right\">\n    <button\n      type=\"button\"\n      (click)=\"onClickButton()\"\n      class=\"e11-flex-shrink-0 e11-flex e11-items-center e11-p-1 e11-text-skin-base e11-rounded-md hover:e11-bg-gray-400 hover:e11-bg-opacity-10 focus:e11-outline-none focus:e11-ring-2 focus:e11-ring-skin-primary-accent\"\n    >\n      <span class=\"e11-sr-only\">{{ \"More action\" | translate }}</span>\n      <span class=\"material-icons-outlined\"> more_vert </span>\n    </button>\n    <ul\n      tabindex=\"-1\"\n      class=\"e11-absolute e11-right-0 e11-w-52 e11-z-10 e11-mt-1 e11-max-h-60 e11-overflow-auto e11-rounded-md e11-bg-white e11-py-1 e11-text-base e11-shadow-lg e11-ring-1 e11-ring-black e11-ring-opacity-5 focus:e11-outline-none sm:e11-text-sm\"\n      id=\"options\"\n      role=\"listbox\"\n      [ngClass]=\"{\n        'e11-hidden': !dropDownOpen,\n        'e11-block ': dropDownOpen\n      }\"\n    >\n      <li\n        class=\"e11-relative e11-cursor-pointer e11-select-none e11-py-2 e11-pl-3 e11-pr-9 e11-text-gray-900 hover:e11-bg-gray-400 hover:e11-bg-opacity-10\"\n        id=\"option-0\"\n        role=\"option\"\n        tabindex=\"-1\"\n        (click)=\"onEdit.emit()\"\n      >\n        {{ \"Edit\" | translate }}\n      </li>\n      <li\n        *ngIf=\"selectedPartition && selectedPartition.id !== partition.id\"\n        class=\"e11-relative e11-cursor-pointer e11-select-none e11-py-2 e11-pl-3 e11-pr-9 e11-text-gray-900 hover:e11-bg-gray-400 hover:e11-bg-opacity-10\"\n        id=\"option-0\"\n        role=\"option\"\n        tabindex=\"-1\"\n        (click)=\"onDelete.emit()\"\n      >\n        {{ \"Delete\" | translate }}\n      </li>\n    </ul>\n  </td>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: ManagePartitionComponentStore }], propDecorators: { partition: [{
                type: Input
            }], onEdit: [{
                type: Output
            }], onDelete: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event.target']]
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class ListPartitionsComponent {
    constructor(store) {
        this.store = store;
        this.loaded$ = this.store.loaded$;
        this.customerPartitions$ = this.store.customerPartitions$;
        this.selectedPartition$ = this.store.selectedPartition$;
        this.partitionSelected = new EventEmitter();
    }
    ngOnInit() {
        this.store.loadPartitions();
    }
    deleteConfirmation(answer) {
        if (!answer) {
            return;
        }
        this.store.deletePartition(this._partition);
        this._partition = undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ListPartitionsComponent, deps: [{ token: ManagePartitionComponentStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: ListPartitionsComponent, selector: "customer-list-partitions", outputs: { partitionSelected: "partitionSelected" }, viewQueries: [{ propertyName: "confirmation", first: true, predicate: ["confirmation"], descendants: true }], ngImport: i0, template: "<e11-panel>\n  <div class=\"e11-justify-between e11-items-center e11-flex e11-p-4\">\n    <h4>{{ \"All Projects\" | translate }}</h4>\n    <e11-button color=\"primary-accent\" value=\"Add Project\" [disabled]=\"false\" (click)=\"_partition = undefined; managePartitionModal.open()\">\n    </e11-button>\n  </div>\n  <ng-container *ngrxLet=\"loaded$ as loaded\">\n    <ng-container *ngrxLet=\"customerPartitions$ as customerPartitions\">\n      <table class=\"e11-min-w-full e11-divide-y e11-divide-gray-300\">\n        <thead>\n          <tr>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"Name\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"Group\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"ID\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold e11-float-right\">{{ \"Action\" }}</th>\n          </tr>\n        </thead>\n        <tbody class=\"e11-divide-y e11-divide-gray-100 e11-bg-white\">\n          <tr *ngFor=\"let partition of customerPartitions; let i = index\">\n            <td class=\"e11-flex e11-gap-2 e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500\">\n              <span>\n                {{ partition.name }}\n              </span>\n              <ng-container *ngrxLet=\"selectedPartition$ as selectedPartition\">\n                <span\n                  *ngIf=\"selectedPartition?.id === partition.id\"\n                  class=\"e11-inline-flex e11-items-center e11-rounded-full e11-bg-skin-primary e11-px-2.5 e11-py-0.5 e11-text-xs e11-font-medium e11-text-skin-white\"\n                  >{{ \"Active\" | translate }}</span\n                >\n              </ng-container>\n            </td>\n            <td class=\"e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500\">\n              {{ partition.group }}\n            </td>\n            <td class=\"e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500\">\n              {{ partition.id }}\n            </td>\n            <partition-list-row\n              (onEdit)=\"_partition = partition; managePartitionModal.open()\"\n              (onDelete)=\"_partition = partition; confirmation.open()\"\n              [partition]=\"partition\"\n            ></partition-list-row>\n          </tr>\n        </tbody>\n      </table>\n      <div *ngIf=\"loaded\">\n        <!-- Empty State -->\n        <div class=\"col-xs-12 text-center e11-mb-16\" *ngIf=\"!customerPartitions?.length\">\n          <!-- Empty State -->\n          <e11-empty-state\n            [icon]=\"'group'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No Projects' | translate }}\"\n            subtitle=\"{{ 'There are currently no projects.' | translate }}\"\n            [clickable]=\"false\"\n          ></e11-empty-state>\n        </div>\n      </div>\n    </ng-container>\n    <div\n      class=\"e11-loader-fading e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center e11-top-4 active\"\n      [ngClass]=\"{ active: !loaded }\"\n    >\n      <e11-loader-dots *ngIf=\"!loaded\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n    </div>\n  </ng-container>\n</e11-panel>\n\n<e11-modal\n  #managePartitionModal\n  [width]=\"'md'\"\n  title=\"{{ _partition ? 'Edit project' : ('Edit project' | translate) }}\"\n  [showHeader]=\"true\"\n  [showFooter]=\"false\"\n  [bodyHeight]=\"'auto'\"\n  (modalClosed)=\"_partition = undefined\"\n>\n  <div modal-body class=\"e11-mb-8\">\n    <customer-edit-partition\n      [partition]=\"_partition\"\n      (saved)=\"_partition = undefined; managePartitionModal.close()\"\n      (created)=\"_partition = undefined; managePartitionModal.close()\"\n      (cancelled)=\"_partition = undefined; managePartitionModal.close()\"\n    ></customer-edit-partition>\n  </div>\n</e11-modal>\n\n<e11-confirmation\n  #confirmation\n  confirmTitle=\"{{ 'Remove project' | translate }}\"\n  confirmText=\"{{ 'Delete project' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [confirmClassOverrides]=\"'e11-bg-skin-error'\"\n  [isMobile]=\"false\"\n  (answer)=\"deleteConfirmation($event)\"\n  [confirmValueWithInputBox]=\"true\"\n  [valueToConfirm]=\"_partition?.name\"\n>\n  <div>\n    {{ \"WARNING: Deleting this project will result in the permanent loss of associated data. Deleting a project cannot be undone.\" | translate }}\n    <p class=\"e11-my-2\">\n      {{ \"Please input the project name to confirm: \" | translate }} <span class=\"e11-font-semibold\"> {{ _partition?.name }}</span>\n    </p>\n  </div>\n</e11-confirmation>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$3.E11EmptyStateComponent, selector: "e11-empty-state", inputs: ["icon", "iconType", "iconSize", "customImageUrl", "customImageAltText", "showButton", "borderColor", "buttonValue", "buttonColor", "buttonDisabled", "buttonIcon", "border", "title", "subtitle", "clickable", "disabled", "disabledText", "containerClass", "contentClass", "containerClassOverrides", "contentClassOverrides", "htmlSubtitle"], outputs: ["buttonClicked"] }, { kind: "component", type: i4.E11ButtonComponent, selector: "e11-button", inputs: ["color", "ghost", "fontColor", "id", "name", "type", "value", "size", "style", "buttonStyle", "loading", "skeletonLoading", "loadingText", "display", "buttonGroup", "paddingX", "icon", "iconType", "symbol", "symbolType", "iconSize", "iconPosition", "iconClassOverrides", "containerClassOverrides", "disabledText", "disabled", "titleText", "titleTextPosition", "autofocus"] }, { kind: "component", type: i5.E11ConfirmationComponent, selector: "e11-confirmation", inputs: ["confirmTitle", "confirmText", "cancelText", "confirmClassOverrides", "cancelClassOverrides", "isMobile", "processing", "processingText", "closeOnEscape", "closeOnClickOutside", "hasBackdrop", "backdropStyle", "confirmValueWithInputBox", "valueToConfirm"], outputs: ["answer"] }, { kind: "component", type: i5$1.E11PanelComponent, selector: "e11-panel", inputs: ["size", "headerText", "headerSize", "headerBgColor", "headerFontColor", "headerStyle", "ctaIcon", "ctaIconType", "ctaIconSize", "ctaText", "ctaFontColor", "hasBorder", "hasShadow", "containerClassOverrides", "contentClassOverrides", "headerTemplate", "bgOpacity"], outputs: ["ctaClicked"] }, { kind: "component", type: i5$2.E11LoaderDotsComponent, selector: "e11-loader-dots", inputs: ["color", "size", "fontSize", "fontColor", "label", "buttonLoader", "fade", "fullScreen", "active", "hasBackdrop", "backdropStyle"] }, { kind: "component", type: i6$1.E11ModalComponent, selector: "e11-modal", inputs: ["title", "width", "bodyHeight", "titleAlign", "hideCloseButton", "closer", "bodyClassOverrides", "bodyClass", "modalClassOverrides", "modalClass", "contentClassOverrides", "contentClass", "headerClassOverrides", "headerClass", "footerClassOverrides", "footerClass", "showFooter", "showHeader", "darkMode", "closeOnEscape", "closeOnClickOutside", "headerCTAs", "hasBackdrop", "backdropStyle"], outputs: ["modalOpened", "onModalOpened", "modalClosed", "onModalClosed", "headerCTAClicked", "onHeaderCTAClicked"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "component", type: EditPartitionComponent, selector: "customer-edit-partition", inputs: ["partition"], outputs: ["saved", "cancelled", "created"] }, { kind: "component", type: PartitionListTdMoreComponent, selector: "partition-list-row", inputs: ["partition"], outputs: ["onEdit", "onDelete"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: ListPartitionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-list-partitions', template: "<e11-panel>\n  <div class=\"e11-justify-between e11-items-center e11-flex e11-p-4\">\n    <h4>{{ \"All Projects\" | translate }}</h4>\n    <e11-button color=\"primary-accent\" value=\"Add Project\" [disabled]=\"false\" (click)=\"_partition = undefined; managePartitionModal.open()\">\n    </e11-button>\n  </div>\n  <ng-container *ngrxLet=\"loaded$ as loaded\">\n    <ng-container *ngrxLet=\"customerPartitions$ as customerPartitions\">\n      <table class=\"e11-min-w-full e11-divide-y e11-divide-gray-300\">\n        <thead>\n          <tr>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"Name\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"Group\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold\">{{ \"ID\" | translate }}</th>\n            <th scope=\"col\" class=\"e11-px-3 e11-py-3.5 e11-text-left e11-text-sm e11-font-semibold e11-float-right\">{{ \"Action\" }}</th>\n          </tr>\n        </thead>\n        <tbody class=\"e11-divide-y e11-divide-gray-100 e11-bg-white\">\n          <tr *ngFor=\"let partition of customerPartitions; let i = index\">\n            <td class=\"e11-flex e11-gap-2 e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500\">\n              <span>\n                {{ partition.name }}\n              </span>\n              <ng-container *ngrxLet=\"selectedPartition$ as selectedPartition\">\n                <span\n                  *ngIf=\"selectedPartition?.id === partition.id\"\n                  class=\"e11-inline-flex e11-items-center e11-rounded-full e11-bg-skin-primary e11-px-2.5 e11-py-0.5 e11-text-xs e11-font-medium e11-text-skin-white\"\n                  >{{ \"Active\" | translate }}</span\n                >\n              </ng-container>\n            </td>\n            <td class=\"e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500\">\n              {{ partition.group }}\n            </td>\n            <td class=\"e11-whitespace-nowrap e11-px-3 e11-py-2 e11-text-sm e11-text-gray-500\">\n              {{ partition.id }}\n            </td>\n            <partition-list-row\n              (onEdit)=\"_partition = partition; managePartitionModal.open()\"\n              (onDelete)=\"_partition = partition; confirmation.open()\"\n              [partition]=\"partition\"\n            ></partition-list-row>\n          </tr>\n        </tbody>\n      </table>\n      <div *ngIf=\"loaded\">\n        <!-- Empty State -->\n        <div class=\"col-xs-12 text-center e11-mb-16\" *ngIf=\"!customerPartitions?.length\">\n          <!-- Empty State -->\n          <e11-empty-state\n            [icon]=\"'group'\"\n            [iconSize]=\"'md-36'\"\n            title=\"{{ 'No Projects' | translate }}\"\n            subtitle=\"{{ 'There are currently no projects.' | translate }}\"\n            [clickable]=\"false\"\n          ></e11-empty-state>\n        </div>\n      </div>\n    </ng-container>\n    <div\n      class=\"e11-loader-fading e11-w-full e11-flex e11-text-center e11-items-center e11-justify-center e11-top-4 active\"\n      [ngClass]=\"{ active: !loaded }\"\n    >\n      <e11-loader-dots *ngIf=\"!loaded\" [size]=\"'md'\" [color]=\"'e11-bg-skin-primary-accent'\"></e11-loader-dots>\n    </div>\n  </ng-container>\n</e11-panel>\n\n<e11-modal\n  #managePartitionModal\n  [width]=\"'md'\"\n  title=\"{{ _partition ? 'Edit project' : ('Edit project' | translate) }}\"\n  [showHeader]=\"true\"\n  [showFooter]=\"false\"\n  [bodyHeight]=\"'auto'\"\n  (modalClosed)=\"_partition = undefined\"\n>\n  <div modal-body class=\"e11-mb-8\">\n    <customer-edit-partition\n      [partition]=\"_partition\"\n      (saved)=\"_partition = undefined; managePartitionModal.close()\"\n      (created)=\"_partition = undefined; managePartitionModal.close()\"\n      (cancelled)=\"_partition = undefined; managePartitionModal.close()\"\n    ></customer-edit-partition>\n  </div>\n</e11-modal>\n\n<e11-confirmation\n  #confirmation\n  confirmTitle=\"{{ 'Remove project' | translate }}\"\n  confirmText=\"{{ 'Delete project' | translate }}\"\n  cancelText=\"{{ 'Cancel' | translate }}\"\n  [backdropStyle]=\"'dark'\"\n  [confirmClassOverrides]=\"'e11-bg-skin-error'\"\n  [isMobile]=\"false\"\n  (answer)=\"deleteConfirmation($event)\"\n  [confirmValueWithInputBox]=\"true\"\n  [valueToConfirm]=\"_partition?.name\"\n>\n  <div>\n    {{ \"WARNING: Deleting this project will result in the permanent loss of associated data. Deleting a project cannot be undone.\" | translate }}\n    <p class=\"e11-my-2\">\n      {{ \"Please input the project name to confirm: \" | translate }} <span class=\"e11-font-semibold\"> {{ _partition?.name }}</span>\n    </p>\n  </div>\n</e11-confirmation>\n" }]
        }], ctorParameters: () => [{ type: ManagePartitionComponentStore }], propDecorators: { confirmation: [{
                type: ViewChild,
                args: ['confirmation']
            }], partitionSelected: [{
                type: Output
            }] } });

class PartitionSwitcherComponent {
    constructor(store, elementRef) {
        this.store = store;
        this.elementRef = elementRef;
        this.loaded$ = this.store.loaded$;
        this.customerPartitions$ = this.store.customerPartitions$;
        this.selectedPartition$ = this.store.selectedPartition$;
        this.dropDownOpen = false;
        this.partitionSelected = new EventEmitter();
    }
    ngOnInit() {
        this.store.loadPartitions();
    }
    selected(partition) {
        this.store.selectPartition(partition);
        this.partitionSelected.emit(partition);
    }
    onClick(targetElement) {
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.dropDownOpen = false;
        }
    }
    onKeydownHandler(event) {
        if (event.key === 'Escape') {
            this.dropDownOpen = false;
        }
    }
    onClickButton() {
        this.dropDownOpen = !this.dropDownOpen;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionSwitcherComponent, deps: [{ token: ManagePartitionComponentStore }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: PartitionSwitcherComponent, selector: "customer-switch-partition", outputs: { partitionSelected: "partitionSelected" }, host: { listeners: { "document:click": "onClick($event.target)", "document:keydown": "onKeydownHandler($event)" } }, ngImport: i0, template: "<ng-container *ngrxLet=\"loaded$ as loaded\">\n  <ng-container *ngrxLet=\"selectedPartition$ as selectedPartition\">\n    <ng-container *ngrxLet=\"customerPartitions$ as customerPartitions\">\n      <div>\n        <div class=\"e11-relative e11-group e11-mt-2\">\n          <input\n            id=\"combobox\"\n            [value]=\"selectedPartition?.name || 'Select project' | translate\"\n            type=\"text\"\n            class=\"e11-w-full e11-cursor-pointer e11-rounded-md e11-border-0 e11-bg-white e11-py-1.5 e11-pl-3 e11-pr-12 e11-text-gray-900 e11-shadow-sm e11-ring-1 e11-ring-inset e11-ring-gray-300 focus:e11-ring-2 focus:e11-ring-inset focus:e11-ring-skin-primary-accent sm:e11-text-sm sm:e11-leading-6\"\n            role=\"combobox\"\n            aria-controls=\"options\"\n            aria-expanded=\"false\"\n            (click)=\"onClickButton()\"\n          />\n          <button\n            type=\"button\"\n            class=\"e11-absolute e11-inset-y-0 e11-right-0 e11-flex e11-items-center e11-rounded-r-md e11-px-2 focus:e11-outline-none\"\n          >\n            <span class=\"material-icons-outlined e11-h-5 e11-w-5\"> unfold_more </span>\n          </button>\n\n          <ul\n            tabindex=\"-1\"\n            class=\"e11-absolute e11-z-10 e11-mt-1 e11-max-h-60 e11-w-full e11-overflow-auto e11-rounded-md e11-bg-white e11-py-1 e11-text-base e11-shadow-lg e11-ring-1 e11-ring-black e11-ring-opacity-5 focus:e11-outline-none sm:e11-text-sm\"\n            id=\"options\"\n            role=\"listbox\"\n            [ngClass]=\"{\n              'e11-hidden': !dropDownOpen,\n              'e11-block ': dropDownOpen\n            }\"\n          >\n            <li\n              *ngFor=\"let partition of customerPartitions\"\n              (click)=\"onClickButton(); selected(partition)\"\n              class=\"e11-relative e11-cursor-pointer e11-select-none e11-py-2 e11-pl-3 e11-pr-9 e11-text-gray-900 hover:e11-bg-gray-400 hover:e11-bg-opacity-10\"\n              id=\"option-0\"\n              role=\"option\"\n              tabindex=\"-1\"\n            >\n              <div class=\"e11-flex\">\n                <span class=\"e11-truncate\">{{ partition.name }}</span>\n                <span class=\"e11-ml-2 e11-truncate e11-text-gray-500\">({{ partition.group }})</span>\n              </div>\n\n              <span\n                *ngIf=\"selectedPartition?.id === partition.id\"\n                class=\"e11-absolute e11-inset-y-0 e11-right-0 e11-flex e11-items-center e11-pr-4 e11-text-skin-primary e11-pl-4\"\n              >\n                <span class=\"material-icons-outlined\"> done </span>\n              </span>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n</ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$2.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3$2.LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionSwitcherComponent, decorators: [{
            type: Component,
            args: [{ selector: 'customer-switch-partition', template: "<ng-container *ngrxLet=\"loaded$ as loaded\">\n  <ng-container *ngrxLet=\"selectedPartition$ as selectedPartition\">\n    <ng-container *ngrxLet=\"customerPartitions$ as customerPartitions\">\n      <div>\n        <div class=\"e11-relative e11-group e11-mt-2\">\n          <input\n            id=\"combobox\"\n            [value]=\"selectedPartition?.name || 'Select project' | translate\"\n            type=\"text\"\n            class=\"e11-w-full e11-cursor-pointer e11-rounded-md e11-border-0 e11-bg-white e11-py-1.5 e11-pl-3 e11-pr-12 e11-text-gray-900 e11-shadow-sm e11-ring-1 e11-ring-inset e11-ring-gray-300 focus:e11-ring-2 focus:e11-ring-inset focus:e11-ring-skin-primary-accent sm:e11-text-sm sm:e11-leading-6\"\n            role=\"combobox\"\n            aria-controls=\"options\"\n            aria-expanded=\"false\"\n            (click)=\"onClickButton()\"\n          />\n          <button\n            type=\"button\"\n            class=\"e11-absolute e11-inset-y-0 e11-right-0 e11-flex e11-items-center e11-rounded-r-md e11-px-2 focus:e11-outline-none\"\n          >\n            <span class=\"material-icons-outlined e11-h-5 e11-w-5\"> unfold_more </span>\n          </button>\n\n          <ul\n            tabindex=\"-1\"\n            class=\"e11-absolute e11-z-10 e11-mt-1 e11-max-h-60 e11-w-full e11-overflow-auto e11-rounded-md e11-bg-white e11-py-1 e11-text-base e11-shadow-lg e11-ring-1 e11-ring-black e11-ring-opacity-5 focus:e11-outline-none sm:e11-text-sm\"\n            id=\"options\"\n            role=\"listbox\"\n            [ngClass]=\"{\n              'e11-hidden': !dropDownOpen,\n              'e11-block ': dropDownOpen\n            }\"\n          >\n            <li\n              *ngFor=\"let partition of customerPartitions\"\n              (click)=\"onClickButton(); selected(partition)\"\n              class=\"e11-relative e11-cursor-pointer e11-select-none e11-py-2 e11-pl-3 e11-pr-9 e11-text-gray-900 hover:e11-bg-gray-400 hover:e11-bg-opacity-10\"\n              id=\"option-0\"\n              role=\"option\"\n              tabindex=\"-1\"\n            >\n              <div class=\"e11-flex\">\n                <span class=\"e11-truncate\">{{ partition.name }}</span>\n                <span class=\"e11-ml-2 e11-truncate e11-text-gray-500\">({{ partition.group }})</span>\n              </div>\n\n              <span\n                *ngIf=\"selectedPartition?.id === partition.id\"\n                class=\"e11-absolute e11-inset-y-0 e11-right-0 e11-flex e11-items-center e11-pr-4 e11-text-skin-primary e11-pl-4\"\n              >\n                <span class=\"material-icons-outlined\"> done </span>\n              </span>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </ng-container>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: () => [{ type: ManagePartitionComponentStore }, { type: i0.ElementRef }], propDecorators: { partitionSelected: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event.target']]
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

const DeclareExportComponents = [
    ApiKeyEditComponent,
    ApiKeyListComponent,
    ApiKeyRow,
    ApiKeyShowComponent,
    EditPartitionComponent,
    ListPartitionsComponent,
    PartitionListTdMoreComponent,
    PartitionSwitcherComponent,
];
class PartitionManageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionManageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: PartitionManageModule, declarations: [ApiKeyEditComponent,
            ApiKeyListComponent,
            ApiKeyRow,
            ApiKeyShowComponent,
            EditPartitionComponent,
            ListPartitionsComponent,
            PartitionListTdMoreComponent,
            PartitionSwitcherComponent], imports: [CommonModule, SharedModule], exports: [ApiKeyEditComponent,
            ApiKeyListComponent,
            ApiKeyRow,
            ApiKeyShowComponent,
            EditPartitionComponent,
            ListPartitionsComponent,
            PartitionListTdMoreComponent,
            PartitionSwitcherComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionManageModule, imports: [CommonModule, SharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionManageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DeclareExportComponents],
                    imports: [CommonModule, SharedModule],
                    exports: [...DeclareExportComponents],
                }]
        }] });

// TODO: split into CustomerAccountModule, CustomerClientModule, and CustomerCoreModule
const DECLARE_EXPORT_COMPONENTS = [
    CustomerComponent,
    CustomerDepartmentsListComponent,
    CustomerDepartmentDetailComponent,
    CustomerLocationListComponent,
    CustomerLocationDetailComponent,
    CustomerSummaryComponent,
];
const IMPORT_EXPORT_MODULES = [CompanyAccountModule, CustomerClientModule, PartitionManageModule, EditableBusinessModule, CustomerAdminModule];
class CustomerModule {
    static forRoot(rootConfig) {
        const partitionConfig = !rootConfig.partitionConfigProvider
            ? this.defaultConfiguration.partitionConfigProvider
            : {
                provide: [CustomerPartitionConfigProvider, CultureIndexConfigProvider],
                useClass: rootConfig.partitionConfigProvider,
            };
        return {
            ngModule: CustomerModule,
            providers: [
                {
                    provide: BaseCustomerConfigProvider,
                    useClass: rootConfig.configProvider,
                },
                {
                    provide: CultureIndexConfigProvider,
                    useClass: rootConfig.cultureIndexProvider,
                },
                partitionConfig,
                { provide: 'dynamicComponentsConfig', useValue: rootConfig.dynamicCustomersTabComponents },
                {
                    provide: APP_INITIALIZER,
                    useFactory: (dynamicRouteService) => () => dynamicRouteService.loadComponents(rootConfig.dynamicCustomersTabComponents),
                    deps: [DynamicComponentService],
                    multi: true,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.9", ngImport: i0, type: CustomerModule, declarations: [CustomerComponent,
            CustomerDepartmentsListComponent,
            CustomerDepartmentDetailComponent,
            CustomerLocationListComponent,
            CustomerLocationDetailComponent,
            CustomerSummaryComponent], imports: [CompanyAccountModule, CustomerClientModule, PartitionManageModule, EditableBusinessModule, CustomerAdminModule, CommonModule,
            RouterModule,
            ReactiveFormsModule,
            TranslateModule,
            // LetModule,
            SharedModule, i2$2.E11InputErrorsModule], exports: [CustomerComponent,
            CustomerDepartmentsListComponent,
            CustomerDepartmentDetailComponent,
            CustomerLocationListComponent,
            CustomerLocationDetailComponent,
            CustomerSummaryComponent, CompanyAccountModule, CustomerClientModule, PartitionManageModule, EditableBusinessModule, CustomerAdminModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerModule, imports: [IMPORT_EXPORT_MODULES, CommonModule,
            RouterModule,
            ReactiveFormsModule,
            TranslateModule,
            // LetModule,
            SharedModule,
            // NgAisModule.forRoot(),
            // NgAisInstantSearchModule.forRoot(),
            // NgAisHitsModule,
            // NgAisSearchBoxModule,
            // SearchModule,
            E11InputErrorsModule.forRoot({
                additional: {
                    phoneNumber: 'Please enter a valid phone number',
                    invalidDate: 'Please enter a valid date',
                    invalidStartDate: 'Must be before end date',
                    invalidEndDate: 'Must be after start date',
                    hasAlphaNumericError: 'Only letters and numbers are allowed here',
                },
            }), CompanyAccountModule, CustomerClientModule, PartitionManageModule, EditableBusinessModule, CustomerAdminModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CustomerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DECLARE_EXPORT_COMPONENTS],
                    imports: [
                        ...IMPORT_EXPORT_MODULES,
                        CommonModule,
                        RouterModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        // LetModule,
                        SharedModule,
                        // NgAisModule.forRoot(),
                        // NgAisInstantSearchModule.forRoot(),
                        // NgAisHitsModule,
                        // NgAisSearchBoxModule,
                        // SearchModule,
                        E11InputErrorsModule.forRoot({
                            additional: {
                                phoneNumber: 'Please enter a valid phone number',
                                invalidDate: 'Please enter a valid date',
                                invalidStartDate: 'Must be before end date',
                                invalidEndDate: 'Must be after start date',
                                hasAlphaNumericError: 'Only letters and numbers are allowed here',
                            },
                        }),
                    ],
                    exports: [...DECLARE_EXPORT_COMPONENTS, ...IMPORT_EXPORT_MODULES],
                }]
        }] });

class DefaultPartitionGuard {
    constructor(partitionStore, router, configProvider) {
        this.partitionStore = partitionStore;
        this.router = router;
        this.configProvider = configProvider;
    }
    canActivate(route, state) {
        return this.partitionStore.selectedPartition$.pipe(tap((partition) => {
            if (!partition) {
                this.partitionStore.bootStrap();
            }
        }), filter$1(isNotNil), switchMap((partition) => {
            const { url } = state;
            const { name: partitionName } = partition;
            this.router.navigateByUrl(`${this.configProvider.config.basePartitionPartial}/${partitionName}${url}`);
            return of(false);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultPartitionGuard, deps: [{ token: ManagePartitionComponentStore }, { token: i2$1.Router }, { token: CustomerPartitionConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultPartitionGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: DefaultPartitionGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ManagePartitionComponentStore }, { type: i2$1.Router }, { type: CustomerPartitionConfigProvider }] });

class PartitionGuard {
    constructor(partitionStore, router, configProvider) {
        this.partitionStore = partitionStore;
        this.router = router;
        this.configProvider = configProvider;
    }
    canActivate(route, state) {
        const { partitionId: partitionName } = route.params;
        return this.partitionStore.customerPartitions$.pipe(filter$1((customerPartitions) => customerPartitions.length > 0), switchMap((customerPartitions) => {
            const partition = customerPartitions.find((partition) => partition.name === partitionName);
            if (!partition) {
                this.router.navigateByUrl(this.configProvider.config.listOfPartitionsUrl);
                return of(false);
            }
            this.partitionStore.selectPartition(partition);
            return of(true);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionGuard, deps: [{ token: ManagePartitionComponentStore }, { token: i2$1.Router }, { token: CustomerPartitionConfigProvider }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: PartitionGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ManagePartitionComponentStore }, { type: i2$1.Router }, { type: CustomerPartitionConfigProvider }] });

class CompanySessionTimeoutComponent {
    constructor(customerStore) {
        this.customerStore = customerStore;
        this.onTimeout = new EventEmitter();
        this.customer$ = this.customerStore.currentCustomer$;
        this.sessionTimeout$ = this.customer$.pipe(map$1((customer) => customer?.sessionExpirationSeconds ?? null));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanySessionTimeoutComponent, deps: [{ token: CustomerStore }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.9", type: CompanySessionTimeoutComponent, isStandalone: true, selector: "sdk-company-session-timeout", outputs: { onTimeout: "onTimeout" }, ngImport: i0, template: `
    <ng-container *ngrxLet="sessionTimeout$ as sessionTimeout">
      <sdk-auth-activity-monitor
        *ngIf="sessionTimeout"
        [inactivityTimeoutSeconds]="sessionTimeout"
        (onTimeout)="onTimeout.emit($event)"
      ></sdk-auth-activity-monitor>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "component", type: ActivityMonitorComponent, selector: "sdk-auth-activity-monitor", inputs: ["inactivityTimeoutSeconds", "warningThreshold"], outputs: ["onTimeout"] }, { kind: "directive", type: LetDirective, selector: "[ngrxLet]", inputs: ["ngrxLet", "ngrxLetSuspenseTpl"] }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.9", ngImport: i0, type: CompanySessionTimeoutComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sdk-company-session-timeout',
                    standalone: true,
                    imports: [ActivityMonitorComponent, LetDirective, NgIf],
                    template: `
    <ng-container *ngrxLet="sessionTimeout$ as sessionTimeout">
      <sdk-auth-activity-monitor
        *ngIf="sessionTimeout"
        [inactivityTimeoutSeconds]="sessionTimeout"
        (onTimeout)="onTimeout.emit($event)"
      ></sdk-auth-activity-monitor>
    </ng-container>
  `,
                }]
        }], ctorParameters: () => [{ type: CustomerStore }], propDecorators: { onTimeout: [{
                type: Output
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ApiKeyEditComponent, ApiKeyListComponent, ApiKeyRow, ApiKeyShowComponent, ApiKeyType, BaseCustomerConfigProvider, BusinessClassification, BusinessSizeRange, CLIENT_LOGO_DEFAULTS, ClientManageComponent, ClientPages, CompanyAccountModule, CompanyDepartmentsListComponent, CompanyLocationCardComponent, CompanyLocationListComponent, CompanyLogoUploadModalComponent, CompanySessionTimeoutComponent, ContactFormComponent, ContactListComponent, CultureIndexConfigProvider, CultureIndexService, CustomerAdminModule, CustomerClientContactService, CustomerClientContactStore, CustomerClientContactsComponent, CustomerClientDataNotFoundComponent, CustomerClientDepartmentService, CustomerClientDepartmentStore, CustomerClientDepartmentsComponent, CustomerClientDetailComponent, CustomerClientLocationService, CustomerClientLocationStore, CustomerClientLocationsComponent, CustomerClientLogoComponent, CustomerClientModule, CustomerClientNavigationComponent, CustomerClientNavigationService, CustomerClientSearchComponent, CustomerClientService, CustomerClientStore, CustomerComponent, CustomerConfigProvider, CustomerContactRepository, CustomerContactRestService, CustomerContactService, CustomerContactStore, CustomerContactsComponent, CustomerDepartmentDetailComponent, CustomerDepartmentRepository, CustomerDepartmentRestService, CustomerDepartmentService, CustomerDepartmentStore, CustomerDepartmentsComponent, CustomerDepartmentsListComponent, CustomerLocationDetailComponent, CustomerLocationListComponent, CustomerLocationRepository, CustomerLocationRestService, CustomerLocationService, CustomerLocationStore, CustomerLocationsComponent, CustomerLogoComponent, CustomerManageCompanyInfoComponent, CustomerModule, CustomerPartitionConfigProvider, CustomerPermissions, CustomerRepository, CustomerService, CustomerStore, CustomerSummaryComponent, CustomerType, DefaultApiKeyScopes, DefaultApiKeyTypes, DefaultCustomerPartitionConfigProvider, DefaultCustomerRoles, DefaultPartitionGuard, EditPartitionComponent, EditableBusinessModule, FormCompanyDetailComponent, FormDepartmentDetailComponent, GICSIndustryGroup, IndustrySector, LOGO_DEFAULTS, ListPartitionsComponent, LocationFormComponent, LogoManageComponent, ManageCompanyLogoComponent, ManagePartitionComponentStore, PartitionGuard, PartitionListTdMoreComponent, PartitionManageModule, PartitionSwitcherComponent, PlatformAdminClientComponent, PlatformAdminContactRestService, PlatformAdminContactStore, PlatformAdminContactsComponent, PlatformAdminCustomerDetailComponent, PlatformAdminCustomerRestService, PlatformAdminCustomerStore, PlatformAdminDepartmentRestService, PlatformAdminDepartmentStore, PlatformAdminDepartmentsComponent, PlatformAdminLocationRestService, PlatformAdminLocationStore, PlatformAdminLocationsComponent, PlatformAdminSearchKeyService, SEARCH_INDICES, SearchAllCustomersComponent, SearchBusinessCustomersComponent, SearchConsumerCustomersComponent, registrationSettingsKeys };
